import { Calendar } from "@fullcalendar/core";
import { ETIME } from "constants";
import { stat } from "fs";
import { List } from "immutable";

import { Context } from "../appcontext";
import { ModalPosition } from "../components/K2Modal";
import { RealizerOperations, ViewRealizer, ViewRealizerAttachDetachControlFce, ViewRealizerManager, VRContext } from "../viewrealizer";
import { call, Helper, isPhoneNumber, Log, parseData, Size, GPSReader } from "./common";
import {
  Align,
  CheckBoxDataRequest,
  cJSonDefaultAcceptExecute,
  cJSonFunctionContextMenu,
  cJSonFunctionExecute,
  cJSonFunctionGridOperation,
  cJsonFunctionHideFloater,
  cJsonFunctionShowFloater,
  ColumnProportionEm,
  ControlDataRequest,
  CSFile,
  CSNclButtonMetadata,
  CSNclCheckBoxMetaData,
  CSNclCommandItemMetadata,
  CSNclContainerMetadata,
  CSNclControlMetadata,
  CSNclDataGridBaseMetadata,
  CSNclInnerGanttMetadata,
  CSNclDataGridContent,
  CSNclGanttContent,
  CSNclDataGridMetadata,
  CSNclGanttMetadata,
  CSNclDataLabelMetadata,
  CSNclDynamicContentMetadata,
  CSNclExpanderMetadata,
  CSNclFloaterAccessorMetadata,
  CSNclFloaterViewMetadata,
  CSNclFormattableInputMetadata,
  CSNclGroupBoxMetaData,
  CSNclHeaderedMetadata,
  CSNclHeaderMetaData,
  CSNclImageMetadata,
  CSNclInnerDataGridMetadata,
  CSNclInputMetadata,
  CSNclLocatorPanelMetadata,
  CSNclMenuContainerMetadata,
  CSNclMenuDividerMetadata,
  CSNclMenuGroupMetadata,
  CSNclMenuItemBaseMetadata,
  CSNclMenuItemMetadata,
  CSNclMenuMetadata,
  CSNclMenuViewMetadata,
  CSNclPageMetadata,
  CSNclPanelMetadata,
  CSNclListViewMetadata,
  CSNclCalendarMetadata,
  CSNclPreviewPanelMetadata,
  CSNclSplitterPanelMetadata,
  CSNclTabControlMetadata,
  CSNclTabToolBarMetadata,
  CSNclToolBarMetadata,
  CSNclViewMetadata,
  CSNclVRTabControlMetadata,
  CSUFNclControlMetadata,
  CSUFUpdateControl,
  CSUpdateCommandItem,
  CSUpdateControl,
  CSUpdateDynamicContent,
  CSUpdateMenuContainer,
  DataActionDecorate,
  InnerDataGridDataRequest,
  GanttDataRequest,
  DisplayMode,
  FrgtCommandItemData,
  FrgtGridLinesStyle,
  Function,
  GlyphId,
  GridOperations,
  HorizontalAlignment,
  IconPosition,
  InputDataRequest,
  OpenDialogDataRequest,
  Orientation,
  SplitterDataRequest,
  TabControlDataRequest,
  UFUpdateControl,
  Updatable,
  UpdateCheckBox,
  UpdateCommandItem,
  UpdateControl,
  UpdateDataLabel,
  UpdateDockControl,
  UpdateDynamicContent,
  UpdateExpander,
  UpdateFormattableInput,
  UpdateHeadered,
  UpdateImage,
  UpdateInnerDataGrid,
  UpdateInnerGantt,
  UpdateInput,
  UpdateMenuContainer,
  UpdateSplitterPanel,
  UpdateTabControl,
  UpdateVRTabControl,
  VerticalAlignment,
  CSNclSignInputMetadata,
  UpdateSignInput,
  SignData,
  SignInputDataRequest,
  FrameStyle,
  RectInDock,
  CSNclDataGridFooter,
  CSNclGanttFooter,
  cJSonFunctionGridChangeSortBy,
  cJSonChangeActiveDateRange,
  UpdateListView,
  UpdateCalendar,
  //UpdateGantt,
  CSNclInnerSectionMetaData,
  CSNclInnerToolBarMetadata,
  CSNclRibbonMetadata,
  TUFActionDisplayStyle,
  CSNclBreakerMetadata,
  UpdateRibbon,
  ListViewDataRequest,
  TNclInputType,
  cJSonFunctionShowSetting,
  cJSonFunctionNextPriorValue,
  cJSonFunctionShowDocumentByK2PK,
  cJSonFunctionEditOnlineAppointment,
  DEFAULT_LANG_IMG,
  UpdateInnerToolbar,
  cJSonFunctionDragAndDropAppointment,
  UpdatePageControl,
  cJSonFunctionDeleteOnlineAppointment,
  CSNCLTreeViewMetadata,
  CSNclInnerTreeViewMetadata,
  UpdateInnerTreeView,
  cJSonFunctionToggleNodeExecute,
  TreeViewDataRequest,
  FrgtPanelBaseData,
  FrgtSplitterPanelData,
  SplitterPanelOrientation,
  TTreeDataMoveNodeMode,
  cJSonFunctionMoveNodeExecute,
  CSTreeDataItem,
  TTreeDataHasChildNodes,
  ModifyTreeItem,
  TDataItemModifyType,
  ModifyItem,
  CSDataItem,
  CSUpdateInnerDataGrid,
  CSNclQuickFilterMetadata,
  UpdateQuickFilter,
  CSUpdateQuickFilter,
  CSNclAggregationPanel,
  UpdateAggregationPanel,
  UpdateDataGrid,
  cJSonDataGridDblClickExecute,
  RibbonDataRequest,
  CSUpdateInnerTreeView,
  InnerColumnsListDataRequest,
  GetColumnWidthEm,
  ColumnsProportion,
  cJSonTreeViewDblClickExecute,
  CSUpdateInnerColumnsList,
  TUFCharCountMultiplierKind,
  TAlignment,
  TUFContextDisplayStyle,
  GetColumnWidth,
  CSTreeColumn,
  ClientData,
  CSUpdateRibbon,
  ViewDataRequest,
  ExplicitBounds,
  cJSonFunctionDefaultExplicitBounds,
  cJSonFunctionDeleteAppointment,
  CSNclClientMenuItemMetadata,
  UpdateFilePreview,
  UpdateDashboard,
  CSNCLDashboardMetadata,
  CSNclDeviceConnectorDialogMetadata,
  DeviceConnectorDataRequest,
  TBehaviorTypeByDevice,
  CSNclGPSDialogMetadata,
  GPSDataRequest,
  TDeviceConnectResult,
  cJSonFunctionPartClickExecute,
  CSUpdateDashboard,
  DashboardData,
  Part,
  PartState,
  Dashboard,
  TPartState,
  UpdateMultiFormatText,
  CSNclMultiFormatTextMetadata,
  TMouseButton,
  cJSonFunctionCloseView,
  cJSonFunctionODUploadFile,
  cJSonMemberClickToExpand,
  clNone,
  AlphabetMode,
  cmdOKView,
  CSNclVirtualKeyboardDialogMetadata,
  CSUpdateInput,
  CSUpdateVirtualKeyboard,
  FrgtButtonData,
  FrgtInputData,
  TUFDisplayValueAs,
  UpdateVirtualKeyboard,
  VirtualKeyboardRequest,
  FilterPart,
  VisibleMember,
  cJSonTreeViewPartClick,
  CSNclWebViewMetadata,
  cJSonFunctionAutoClose,
  cJSonDynamicFilterPartClick,
  cJSonPartUpdate,
  CSNclCodeReaderDialogMetadata,
  CodeReaderRequest,
  cJSonFunctionODBeginUploadFile,
  cJSonFunctionODEndUploadFile,
  cJSonFunctionODCancelUploadFile,
  UpdateOpenDialogContent,
  SilentOpenDialogDataRequest,
  CSNclOpenDialogMetadata,
  cJSonExecuteCommandByNumber,
  TGPSRequest,
} from "./communication.base";
import { VisualContext } from "./visualContext";
import { K2App } from "../components/app";
import { ApplicationBase } from "../app";

export type ForEachNestedControlFce = (control: NclControlBase) => any;

export interface UFOverAlign {
  getOverRect(): DOMRect;
  registerOverAlignListener?(listener: UFOverAlignListener): void;
  unRegisterOverAlignListener?(listener: UFOverAlignListener): void;
}

export interface UFOverAlignListener {
  updateAlignAnchor(): void;
}

export interface NclControlBase extends Updatable {
  appendFunction(fce: Function): void;
  init(listener: ControlListener): UpdateControl;
  willUnMount(onlyListener: boolean): void;
  getRealizerUID(): string;
  isInPreview(): boolean;
  MetaData: CSNclControlMetadata;
  State: ControlStateBase;
  Listener: any; //typ any je zde schválně, jelikož je pak možné využít metody findDOMNode v reactu
  InEditMode: boolean;
  VCX: VisualContext;
  ComputedMinHeight: number;
  ComputedMinHeightWithMargin: number;
  MarginXFactor: number;
  MarginYFactor: number;
  Size: number;
  Parent: NclControlBase;
}

export interface UFNclControlBase extends NclControlBase {
  setAsActiveControl(isActive: boolean): void;
  setVCX(vcx: VisualContext, forceRefresh: boolean): void;
  MetaData: CSUFNclControlMetadata;
}

export interface ControlListener {
  setAsActive?(isActive: boolean): void;
  updateState(state: UpdateControl): void;
  updateVCX(vcxVersion: number): void;
}

export interface InputListener extends ControlListener {
  getSelectionStart(): number;
  getSelectionEnd(): number;
  setText(value: string, position: number): void;
}
/**
 * Interface for window.
 */
export interface ViewListener extends ControlListener {
  /**
   * Method for close window. Promise resolve is called when window is closed, after all animation.
   */
  close(): Promise<void>;
  /**
   * Method for open window. Promise resolve is called when window is closed, after all animation.
   */
  show(): Promise<void>;

  /**
   * Start auto update interval when Interval > 0
   */
  startAutoUpdate(): void;

  /**
   * Stop auto update interval
   */
  stopAutoUpdate(): void;
}

/**
 * Interface for dock component
 */
export interface DockListener extends ControlListener {
  /**
   * Dock realizer to dock component.Promise resolve is called when VR is docked and all animation ended.
   */
  dock(state: UpdateDockControl): Promise<void>;
  /**
   * UnDock realizer from dock component.Promise resolve is called when VR is docked and all animation ended.
   */
  undock(): Promise<void>;
}

export interface ContainerListener extends ControlListener {
  reCalculateHeight(byControlUID: string): void; //vyvolá přepočet výšky bandů
}

export interface DataGridListener extends ControlListener {
  updatePosition(oldRow: number, newRow: number, oldCol: number, newCol: number): void;
}

export interface TreeViewListener extends ControlListener {
  updatePosition(oldRow: string, newRow: string, oldCol: number, newCol: number): void;
}

/**
 * interface se základními vlastnostmi které mohou číst i ostatní komponenty a ne jen ty které ncl vlastní.
 */
export interface ControlStateBase {
  readonly Visible: boolean;
  readonly Enabled: boolean;
  readonly TabStop: boolean;
}

export interface InputSelectionText {
  start: number;
  end: number;
}
/**
 * Control implements this interface can be add client action to context menu.
 */
interface ClientContextMenuEmitor {
  appendActionTo(menu: CSNclMenuMetadata): void;
}

var lastFceKey: { key: string; timestamp: number };
var limitedFceList = [cJSonFunctionExecute]; //list of functions for which multi-run is blocked

abstract class NclControl<T extends CSNclControlMetadata, S extends UpdateControl> implements NclControlBase {
  protected vr: ViewRealizer;
  protected vrAttachDetachFce: ViewRealizerAttachDetachControlFce = null;
  private listener: ControlListener;
  protected state: S;
  protected ncl: T;
  private request: ControlDataRequest;
  private isPreparedDataRequest: boolean = false;
  private nestedControls: NclControlBase[];
  protected parent: NclControlBase;

  constructor(ncl: T, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    this.vr = vr;
    this.vrAttachDetachFce = vrAttachDetachFce;
    this.ncl = Helper.clone(ncl);
    if (!this.ncl) {
      throw new Error("Ncl isn't defined.");
    }
    this.parent = parent;
    if (this.vrAttachDetachFce != null) this.vrAttachDetachFce.call(this.vr, this, true);
    this.state = this.createDefaultState();
    this.initDataRequest();
  }

  get Size(): number {
    return 1;
  }

  get VCX(): VisualContext {
    return this.internalGetVCX();
  }

  get MetaData(): CSNclControlMetadata {
    return this.ncl;
  }

  get Ncl(): T {
    return this.ncl;
  }

  get State(): ControlStateBase {
    return this.state;
  }

  get Listener(): any {
    return this.listener;
  }

  get InEditMode(): boolean {
    return this.internalInEditMode();
  }

  get MarginXFactor(): number {
    return 1;
  }

  get MarginYFactor(): number {
    return 1;
  }

  get ComputedMinHeight(): number {
    return this.computeMinHeight(false);
  }

  get ComputedMinHeightWithMargin(): number {
    return this.computeMinHeight(true);
  }

  get Parent(): NclControlBase {
    return this.parent;
  }

  get IsPreparedDataRequest(): boolean {
    return this.isPreparedDataRequest;
  }

  public isInPreview(): boolean {
    let ctrl: NclControl<any, any> = this;
    while (ctrl) {
      if (ctrl instanceof NclPreviewPanel) return true;
      ctrl = ctrl.Parent as NclControl<any, any>;
    }

    return false;
  }

  public addNestedControl(control: NclControlBase) {
    if (!this.nestedControls) this.nestedControls = [];

    this.nestedControls.push(control);
  }

  public removeNestedControl(control: NclControlBase) {
    if (this.nestedControls) {
      let i = this.nestedControls.indexOf(control);
      if (i >= 0) {
        this.nestedControls.splice(i, 1);
      }
    }
  }

  protected internalInEditMode(): boolean {
    return this.vr.InEditMode;
  }

  protected forEachNestedControls(fce: ForEachNestedControlFce) {
    if (this.nestedControls) this.nestedControls.map(fce);
  }

  protected internalGetVCX(): VisualContext {
    if (this.parent) {
      return this.parent.VCX;
    }
    if (this.vr) {
      return this.vr.VCX;
    }

    return VisualContext.Default;
  }

  protected computeMinHeight(withMargin: boolean): number {
    return this.internalComputeMinHeight();
  }

  protected internalComputeMinHeight(): number {
    return this.VCX.MinRowHeight;
  }

  protected abstract createDefaultState(): S;

  public appendFunction(fce: Function, callServer: boolean = false) {
    if (callServer && limitedFceList.indexOf(fce.Name) >= 0) {
      let key = `${this.MetaData.ControlUID}_${fce.Name}`;
      if (lastFceKey && key === lastFceKey.key && new Date().getTime() - lastFceKey.timestamp <= 300) {
        return;
      }
      lastFceKey = { key: key, timestamp: new Date().getTime() };
    }
    if (this.request.Functions == null) this.request.Functions = new Array<Function>();

    if (
      this.request.Functions.findIndex((value: Function, index: number, obj: Function[]) => {
        if (value.Name === fce.Name) return true;
      }) === -1
    ) {
      this.request.Functions.push(fce);
    }
    this.isPreparedDataRequest = true;
    if (callServer) {
      this.vr.sendRequest(RealizerOperations.None, this);
    }
  }

  public callCommand(cmd: string, args?: any) {
    if (this.request.Commands == null) this.request.Commands = new Array<Function>();

    if (
      this.request.Commands.findIndex((value: Function, index: number, obj: Function[]) => {
        if (value.Name === cmd) return true;
      }) === -1
    ) {
      this.request.Commands.push({ Name: cmd, Args: args });
    }
    this.isPreparedDataRequest = true;
    this.vr.sendRequest(RealizerOperations.None, this);
  }

  public resetToState() {
    if (this.listener) {
      let st = this.state.toJS();
      this.state = this.createDefaultState();
      this.updateState(st);
    }
  }

  public updateState(data: CSUpdateControl) {
    let newState: S = this.state.with(data) as S;
    let canUpdate: boolean = true;
    if (
      Object.keys(data).length === 2 &&
      data.Visible === false &&
      this.parent &&
      this.parent.State.Visible === data.Visible &&
      (!(this.parent instanceof NclPage) || !(this.parent.parent instanceof NclVRTabControl))
    ) {
      canUpdate = false; //Can't call update when parent container is invisible.
    }
    this.setState(newState, canUpdate);
  }

  protected setState(newState: S, canUpdate: boolean) {
    if (newState !== this.state) {
      if (canUpdate) canUpdate = this.internalCanUpdate(newState);

      let oldState = this.state;
      this.state = newState;
      this.afterSetState(canUpdate, oldState);
    }
  }

  protected afterSetState(canUpdate: boolean, oldState: S) {
    if (canUpdate) {
      if (this.listener != null) {
        if (this.state.Visible != oldState.Visible && this.parent instanceof NclContainerBase) {
          this.parent.changeVisibleAnyPartsOfContainer(this.MetaData.ControlUID);
        }
        this.listener.updateState(this.state);
      } else {
        if (this.state.Visible === oldState.Visible) {
          Log.warn("Listener not found."); //pouze zmena visible muze narazit na nenastavenneho listenera, v jinem pripade se jedna o zbytecny update a mel by byt zrusen
        }
      }
    }
  }

  public collectData(collector: Array<ControlDataRequest>) {
    this.internalCollectData(collector);
  }

  public setAsActiveControl(isActive: boolean) {
    if (this.listener && this.listener.setAsActive) {
      this.listener.setAsActive(isActive);
    }
  }

  public setActiveControlRequested() {
    this.vr.RequestActiveControlUID = this.ncl.ControlUID;
  }

  public willUnMount(onlyListener: boolean) {
    if (onlyListener) {
      this.listener = null;
    } else {
      this.vrAttachDetachFce.call(this.vr, this);
      this.vrAttachDetachFce = null;
      this.listener = null;
      this.parent = null;
      this.vr = null;
    }
    this.forEachNestedControls((ctrl) => {
      ctrl.willUnMount(onlyListener);
    });
  }

  protected internalCanUpdate(newState: S): boolean {
    return true;
  }

  public getRealizerUID(): string {
    if (this.vr != null) {
      return this.vr.getRealizerUID();
    }

    return "";
  }

  protected internalCollectData(collector: Array<ControlDataRequest>) {
    if (this.isPreparedDataRequest) {
      collector.push(this.request);
      this.initDataRequest();
    }

    this.forEachNestedControls((value) => {
      value.collectData(collector);
    });
  }

  public init(listener: ControlListener): UpdateControl {
    if (this.listener == null) this.listener = listener;
    return this.state;
  }

  protected internalSetVCX(vcx: VisualContext, forceRefresh: boolean) {
    if (this.listener != null && forceRefresh && this.state.Visible) {
      this.listener.updateVCX(this.VCX.getVersion());
    }

    this.forEachNestedControls((value) => {
      (value as NclControl<any, any>).internalSetVCX(vcx, forceRefresh);
    });
  }

  protected internalSetData<U extends ControlDataRequest>(
    data: U,
    callServer: Boolean,
    changeDataValue: boolean = false,
    rootOperation: RealizerOperations = RealizerOperations.None
  ) {
    if (data != null) {
      Object.assign(this.request, data);
      this.isPreparedDataRequest = true;
      if (changeDataValue) {
        this.vr.addToChangeList(this.MetaData.ControlUID);
      }
    }

    if (callServer) {
      this.vr.sendRequest(rootOperation, this);
    }
  }

  protected initDataRequest() {
    this.request = { ControlUID: this.ncl.ControlUID };
    this.isPreparedDataRequest = false;
  }

  public async copy(text: string) {
    try {
      await navigator.clipboard.writeText(text);
    } catch (error) {
      console.log(error);
    }
  }
}

abstract class UFNclControl<T extends CSUFNclControlMetadata, S extends UFUpdateControl> extends NclControl<T, S> implements UFNclControlBase {
  private vcx: VisualContext;

  protected internalGetVCX(): VisualContext {
    if (this.vcx) {
      return this.vcx;
    }

    return super.internalGetVCX();
  }

  get MetaData(): CSUFNclControlMetadata {
    return this.ncl;
  }

  get Size(): number {
    let size = this.Ncl.FrgtData.Size;
    if (size && size != NaN) {
      return Math.max(size, 1);
    }

    return 1;
  }

  protected internalComputeMinHeight(): number {
    return super.internalComputeMinHeight() * this.Size;
  }

  public willUnMount(onlyListener: boolean) {
    super.willUnMount(onlyListener);
    if (!onlyListener) this.vcx = null;
  }

  public setVCX(vcx: VisualContext, forceRefresh: boolean) {
    this.internalSetVCX(vcx, forceRefresh);
  }

  protected internalSetVCX(vcx: VisualContext, forceRefresh: boolean) {
    if (vcx.ZoomFactor != this.MetaData.FrgtData.ZoomFactor) {
      this.vcx = vcx.createVCXForZoomFactor(this.MetaData.FrgtData.ZoomFactor);
    } else {
      this.vcx = null;
    }

    super.internalSetVCX(vcx, forceRefresh);
  }
}

export interface NclBaseContainer extends UFNclControlBase {
  Children: List<UFNclControlBase>;
  Parts: Array<Array<UFNclControlBase>>;
  VerticalLines: FrgtGridLinesStyle;
  HorizontalLines: FrgtGridLinesStyle;
  Parent: NclControlBase;
}

export enum ScrollOption {
  None,
  Enabled,
  Disabled,
}

export abstract class NclContainerBase<T extends CSNclContainerMetadata, S extends UFUpdateControl> extends UFNclControl<T, S> implements NclBaseContainer {
  private _Children: List<UFNclControlBase>;
  private _Parts: Array<Array<UFNclControlBase>>;

  constructor(ncl: T, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    this.initChildren(ncl);
  }

  public get VerticalLines(): FrgtGridLinesStyle {
    return this.InternalGetVerticalLines();
  }

  public get HorizontalLines(): FrgtGridLinesStyle {
    return this.InternalGetHorizontalLines();
  }

  get MarginXFactor(): number {
    return 0;
  }

  get MarginYFactor(): number {
    return 0;
  }

  public willUnMount(onlyListener: boolean) {
    super.willUnMount(onlyListener);
    this.Children.forEach((child) => {
      child.willUnMount(onlyListener);
    });
  }

  protected internalSetVCX(vcx: VisualContext, forceRefresh: boolean) {
    super.internalSetVCX(vcx, forceRefresh);
    if (this.Children) {
      if (this.Children) {
        this.Children.forEach((value: UFNclControlBase, key: number, iter: List<UFNclControlBase>) => {
          value.setVCX(this.VCX, forceRefresh);
        });
      }
    }
  }

  public changeVisibleAnyPartsOfContainer(controlUID: string) {
    let listener: ContainerListener = this.Listener as ContainerListener;
    if (listener && listener.reCalculateHeight) {
      listener.reCalculateHeight(controlUID);
    }
  }

  protected InternalGetVerticalLines(): FrgtGridLinesStyle {
    return FrgtGridLinesStyle.glsNone;
  }

  protected InternalGetHorizontalLines(): FrgtGridLinesStyle {
    return FrgtGridLinesStyle.glsNone;
  }

  private initChildren(ncl: CSNclContainerMetadata) {
    if (ncl.Controls) {
      let children = new Array<UFNclControlBase>();
      for (var i = 0; i < ncl.Controls.length; i++) {
        children.push(NclContainerBase.createControl(ncl.Controls[i], this, this.vr, this.vrAttachDetachFce));
      }

      this._Children = List<UFNclControlBase>(children);
      this._Parts = NclContainerBase.splitToParts(this._Children);
    } else {
      this._Children = List<UFNclControlBase>();
      this._Parts = [];
    }
  }

  get Children(): List<UFNclControlBase> {
    return this.getChildren();
  }

  protected getChildren(): List<UFNclControlBase> {
    return this._Children;
  }

  get Parts(): Array<Array<UFNclControlBase>> {
    return this.getParts();
  }

  protected getParts(): Array<Array<UFNclControlBase>> {
    return this._Parts;
  }

  public static createControl(
    ncl: CSUFNclControlMetadata,
    parent: NclControlBase,
    vr: ViewRealizer,
    vrAttachDetachFce: ViewRealizerAttachDetachControlFce
  ): UFNclControlBase {
    switch (ncl.__type) {
      case ControlType.Input:
        return new NclInput(ncl as CSNclInputMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.SimpleDataGrid:
        return new NclSimpleDataGrid(ncl as CSNclDataGridMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.DataGrid:
        return new NclDataGrid(ncl as CSNclDataGridMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.RibbonAction:
      case ControlType.CommandAction:
      case ControlType.ActionTT:
      case ControlType.Action:
        return new NclCommandItem(ncl as CSNclCommandItemMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.MenuButton:
        return new NclCommandItem(ncl as CSNclCommandItemMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.Button:
        return new NclButton(ncl as CSNclButtonMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.DetailTab:
      case ControlType.Tab:
        return new NclTabControl(ncl as CSNclTabControlMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.MultiContent:
        return new NclMultiContent(ncl as CSNclTabControlMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.SplitPanel:
        return new NclSplitterPanel(ncl as CSNclSplitterPanelMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.DataLabel:
        return new NclDataLabel(ncl as CSNclDataLabelMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.PreviewPanel:
        return new NclPreviewPanel(ncl as CSNclPreviewPanelMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.CheckBox:
        return new NclCheckBox(ncl as CSNclCheckBoxMetaData, parent, vr, vrAttachDetachFce);
      case ControlType.GroupBox:
        return new NclGroupBox(ncl as CSNclGroupBoxMetaData, parent, vr, vrAttachDetachFce);
      case ControlType.Expander:
        return new NclExpander(ncl as CSNclExpanderMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.DynamicContent:
        return new NclDynamicContent(ncl as CSNclDynamicContentMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.Panel:
      case ControlType.Container:
        return new NclPanel<CSNclPanelMetadata, UFUpdateControl>(ncl as CSNclPanelMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.ListView:
        return new NclListView(ncl as CSNclListViewMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.Calendar:
        return new NclCalendar(ncl as CSNclCalendarMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.Gantt:
        return new NclGantt(ncl as CSNclGanttMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.LibraryReference:
        return new NclLibraryReference(ncl as CSNclContainerMetadata, parent, vr, vrAttachDetachFce);
      //case 'TNclControl': return new K2Control(ncl as INclControl, vr);
      case ControlType.VRTab:
        return new NclVRTabControl(ncl as CSNclVRTabControlMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.Image:
        return new NclImage(ncl as CSNclImageMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.FilePreview:
        return new NclFilePreview(ncl as CSNclImageMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.Space:
        return new NclSpace(ncl, parent, vr, vrAttachDetachFce);
      case ControlType.FloaterView:
        return new NclFloaterView(ncl as CSNclFloaterViewMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.MenuView:
        return new NclMenuView(ncl as CSNclMenuViewMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.View:
        return new NclView(ncl as CSNclViewMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.InplaceView:
        return new NclInplaceView(ncl as CSNclViewMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.ToolBar:
        return new NclTabToolBar(ncl as CSNclTabToolBarMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.ActionSeparator:
        return new NclActionSeparator(ncl, parent, vr, vrAttachDetachFce);
      case ControlType.StackPanel:
        return new NclStackPanel(ncl as CSNclContainerMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.Page:
        return new NclPage(ncl as CSNclPageMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.FloaterAccessor:
        return new NclFloaterAccessor(ncl as CSNclFloaterAccessorMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.OpenDialog:
        return new NclOpenDialog(ncl as CSNclOpenDialogMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.SilentOpenDialog:
        return new NclSilentOpenDialog(ncl as CSNclOpenDialogMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.OpenDialogContent:
        return new NclSilentOpenDialogContent(ncl as CSNclPanelMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.DeviceConnector:
        return new NclDeviceConnectorDialog(ncl as CSNclDeviceConnectorDialogMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.GPSReader:
        return new NclGPSDialog(ncl as CSNclGPSDialogMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.FormattableInput:
        return new NclFormattableInput(ncl as CSNclFormattableInputMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.LocatorPanel:
        return new NclLocatorPanel(ncl as CSNclLocatorPanelMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.SignInput:
        return new NclSignInput(ncl as CSNclSignInputMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.Ribbon:
        return new NclRibbon(ncl as CSNclRibbonMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.Breaker:
        return new NclBreaker(ncl as CSNclBreakerMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.TreeView:
        return new NclTreeView(ncl as CSNCLTreeViewMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.Dashboard:
        return new NclDashboard(ncl as CSNCLDashboardMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.MultiFormatText:
        return new NclMultiFormatText(ncl as CSNclMultiFormatTextMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.VirtualKeyboardDialog:
        return new NclVirtualKeyboardDialog(ncl as CSNclVirtualKeyboardDialogMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.CodeReaderDialog:
        return new NclCodeReaderDialog(ncl as CSNclCodeReaderDialogMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.WebView:
        return new NclWebView(ncl as CSNclWebViewMetadata, parent, vr, vrAttachDetachFce);
      default:
        //Log.warn('Unknown ncl control: ' + ncl.__type);
        return new NclUndefinedControl(ncl, parent, vr, vrAttachDetachFce);
    }
  }

  protected internalCollectData(collector: Array<ControlDataRequest>) {
    super.internalCollectData(collector);
    this.internalCollectChildrenUpdate(collector);
  }

  protected internalCollectChildrenUpdate(collector: Array<ControlDataRequest>) {
    this.Children.map((child) => {
      child.collectData(collector);
    });
  }

  protected static splitToParts(controls: List<UFNclControlBase>): Array<UFNclControlBase[]> {
    let parts = new Array<UFNclControlBase[]>();

    let band: UFNclControlBase[] = null;
    controls.map((child) => {
      if (parts.length <= child.MetaData.Bounds.PartIndex) {
        band = new Array<UFNclControlBase>();
        parts.push(band);
      } else {
        band = parts[child.MetaData.Bounds.PartIndex];
      }

      band.push(child);
    });

    return parts;
  }

  private calcMinHeight(withMargin: boolean): number {
    let size: number = 0;
    let partSize: number = 0;
    let h: number = 0;
    this.Parts.forEach((band) => {
      partSize = 0;
      h = 0;
      band.forEach((value) => {
        h = withMargin ? value.ComputedMinHeightWithMargin : value.ComputedMinHeight;
        if (h > partSize) {
          partSize = h;
        }
      });
      size += partSize;
    });
    if (
      this instanceof NclSplitterPanel &&
      ((this.MetaData.FrgtData as FrgtSplitterPanelData).Orientation === SplitterPanelOrientation.spoLeft ||
        (this.MetaData.FrgtData as FrgtSplitterPanelData).Orientation === SplitterPanelOrientation.spoRight)
    ) {
      let minHeights: number[] = [];
      this.Parts.map((part) => part.map((p) => minHeights.push(withMargin ? p.ComputedMinHeightWithMargin : p.ComputedMinHeight)));
      size = Math.max(...minHeights);
    }

    return size;
  }

  protected computeMinHeight(withMargin: boolean): number {
    return Math.max(this.calcMinHeight(withMargin), this.VCX.MinRowHeight * this.Size);
  }
}

export class NclPanel<T extends CSNclPanelMetadata, S extends UFUpdateControl> extends NclContainerBase<T, S> {
  protected createDefaultState(): S {
    return new UFUpdateControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() }) as S;
  }

  protected internalGetVerticalLines(): FrgtGridLinesStyle {
    return this.Ncl.FrgtData.VerticalLines;
  }

  public internalGetHorizontalLines(): FrgtGridLinesStyle {
    return this.Ncl.FrgtData.HorizontalLines;
  }

  get MarginXFactor(): number {
    return 0;
  }

  get MarginYFactor(): number {
    return 0;
  }

  public static getScrollOption(frgt: FrgtPanelBaseData): ScrollOption {
    if (frgt.Scroll) {
      return ScrollOption.Enabled;
    }
    return ScrollOption.Disabled;
  }

  protected internalComputeMinHeight(): number {
    let result = 0;

    result += Math.max(this.VCX.MinRowHeight * this.Size, super.internalComputeMinHeight());

    return result;
  }

  protected computeMinHeight(withMargin: boolean): number {
    const previous = this.vr.calcFullHeight;

    if (
      !this.vr.calcFullHeight &&
      !([Align.Client, Align.Left, Align.Right].includes(this.Ncl.Bounds.Align) && (this.MetaData.FrgtData as FrgtPanelBaseData).Scroll === 1)
    ) {
      this.vr.calcFullHeight = true;
    }

    let height = super.computeMinHeight(withMargin);

    if (withMargin) {
      height += (this.Parts.length - 1) * this.VCX.Data.MarginY * 2;
    }

    if (
      !this.vr.calcFullHeight &&
      (this.MetaData.FrgtData as FrgtPanelBaseData).Scroll === 1 &&
      [Align.Client, Align.Left, Align.Right].includes(this.Ncl.Bounds.Align)
    ) {
      height = this.VCX.LabelControl.getHeight(1) * this.Size;
    }

    if (previous === false) {
      this.vr.calcFullHeight = false;
    }

    return height;
  }
}

export class NclListView extends UFNclControl<CSNclListViewMetadata, UpdateListView> {
  public maxRowCount: number;
  public iconPerRow: number;

  constructor(ncl: CSNclListViewMetadata, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    this.maxRowCount = this.Ncl.FrgtData.Size;
  }
  protected createDefaultState(): UpdateListView {
    return new UpdateListView({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  get MarginXFactor(): number {
    return 0;
  }

  get MarginYFactor(): number {
    return 0;
  }

  public isLite(): boolean {
    return this.ncl.FrgtData.LiteHeader ? true : false;
  }

  public setVCX(vcx: VisualContext, forceRefresh: boolean) {
    this.internalSetVCX(vcx, forceRefresh);
  }

  public executeSetPosition(position: number) {
    if (this.state.Position != position) {
      this.internalSetData<ListViewDataRequest>({ Position: position } as ListViewDataRequest, true);
    }
  }

  public executeShortcut(args?: Array<any>) {
    this.appendFunction({ Name: cJSonDefaultAcceptExecute, Args: args }, true);
  }

  public setMaxRowCount(maxRowCount: number) {
    maxRowCount = Math.max(Math.round(maxRowCount), this.Ncl.FrgtData.Size);
    if (this.maxRowCount != maxRowCount) {
      //this.internalSetData({ MaxRowCount: maxRowCount } as DataGridDataRequest, true);
      this.maxRowCount = maxRowCount;
    }
  }
}

export class NclCalendar extends UFNclControl<CSNclCalendarMetadata, UpdateCalendar> {
  constructor(ncl: CSNclCalendarMetadata, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    //this.maxRowCount = this.Ncl.FrgtData.Size;
  }
  protected createDefaultState(): UpdateCalendar {
    return new UpdateCalendar({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  get MarginXFactor(): number {
    return 0;
  }

  get MarginYFactor(): number {
    return 0;
  }

  public setVCX(vcx: VisualContext, forceRefresh: boolean) {
    this.internalSetVCX(vcx, forceRefresh);
  }

  public ChangeActiveDateRange(StartDate: Date, EndDate: Date) {
    let Reload: boolean = false;
    if (!this.state.ActiveStartDate) {
      Reload = true;
    }
    if (!this.state.ActiveEndDate) {
      Reload = true;
    }

    if (StartDate < new Date(this.state.ActiveStartDate)) {
      Reload = true;
    }

    if (EndDate > new Date(this.state.ActiveEndDate)) {
      Reload = true;
    }

    if (Reload) {
      //console.log("Načítám pro " + StartDate.toLocaleDateString() + " end:" + EndDate.toLocaleDateString());
      this.appendFunction(
        { Name: cJSonChangeActiveDateRange, Args: [this.ConvertToIndependentFormat(StartDate), this.ConvertToIndependentFormat(EndDate)] },
        true
      );
      //this.resetToState;
    }
  }

  public executeShowSetting(args?: Array<any>) {
    this.appendFunction({ Name: cJSonFunctionShowSetting, Args: args }, true);
  }

  public executeDeleteAppointment(SerieUI: string, K2Pk: string) {
    this.appendFunction({ Name: cJSonFunctionDeleteAppointment, Args: [SerieUI, K2Pk] }, true);
  }

  public executeDeleteOnlineAppointment(ProviderUI: string, AppointmentId: string, AppType: number) {
    this.appendFunction({ Name: cJSonFunctionDeleteOnlineAppointment, Args: [ProviderUI, AppointmentId, AppType] }, true);
  }

  public executeShowDocumentByK2PK(SerieUI: string, K2Pk: string) {
    this.appendFunction({ Name: cJSonFunctionShowDocumentByK2PK, Args: [SerieUI, K2Pk] }, true);
  }

  public executeEditOnlineAppointment(ProviderUI: string, AppointmentId: string, AppType: number) {
    this.appendFunction({ Name: cJSonFunctionEditOnlineAppointment, Args: [ProviderUI, AppointmentId, AppType] }, true);
  }

  public ConvertToIndependentFormat(aDate: Date): string {
    if (aDate == null) {
      return " 0000-00-00 00:00:00:000";
    } else {
      var lDateAsStr, lMonth, lDate: string;
      var lMonthAsN: number;
      lMonthAsN = aDate.getMonth() + 1;
      lMonth = ("00" + lMonthAsN.toString()).slice(-2);
      lDate = ("00" + aDate.getDate().toString()).slice(-2);
      lDateAsStr = aDate.getFullYear() + "-" + lMonth + "-" + lDate;

      var lTimeAsStr, lHour, lMin, lSec, lMili: string;
      lHour = ("00" + aDate.getHours().toString()).slice(-2);
      lMin = ("00" + aDate.getMinutes().toString()).slice(-2);
      lSec = ("00" + aDate.getSeconds().toString()).slice(-2);
      lMili = ("000" + aDate.getMilliseconds().toString()).slice(-3);
      lTimeAsStr = lHour + ":" + lMin + ":" + lSec + ":" + lMili;

      return lDateAsStr + " " + lTimeAsStr;
    }
  }

  public DragAnDropAppointment(ProviderUI: string, K2Pk: string, oldstart: Date, start: Date, end: Date, AppointmentId: string, AppType: number) {
    //this.vr.addToChangeList(this.MetaData.ControlUID);
    //		this.resetToState;
    this.appendFunction(
      {
        Name: cJSonFunctionDragAndDropAppointment,
        Args: [
          ProviderUI,
          K2Pk,
          0,
          this.ConvertToIndependentFormat(oldstart),
          this.ConvertToIndependentFormat(start),
          this.ConvertToIndependentFormat(end),
          AppointmentId,
          AppType,
        ],
      },
      true
    );
  }

  public contextMenu(actualDate: Date) {
    this.appendFunction({ Name: cJSonFunctionContextMenu, Args: [this.ConvertToIndependentFormat(actualDate)] }, true);
  }
}

export class NclContainer extends NclContainerBase<CSNclContainerMetadata, UFUpdateControl> {
  protected createDefaultState(): UFUpdateControl {
    return new UFUpdateControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }
}

export class NclLibraryReference extends NclContainer {
  protected computeMinHeight(withMargin: boolean): number {
    let height = 0;

    const previous = this.vr.calcFullHeight;

    if (this.vr.calcFullHeight === false) {
      this.vr.calcFullHeight = true;
    }

    this.Parts.map((part) =>
      part.map((p) => {
        if (withMargin) {
          height = p.ComputedMinHeightWithMargin;
        } else {
          height = p.ComputedMinHeight;
        }
      })
    );

    if (previous === false) {
      this.vr.calcFullHeight = false;
    }

    return height;
  }
}

export class NclStackPanel extends NclContainer {}

export class NclPage extends UFNclControl<CSNclPageMetadata, UpdatePageControl> {
  private content: UFNclControlBase;

  constructor(ncl: CSNclPageMetadata, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (ncl.Content) {
      this.content = NclContainer.createControl(ncl.Content, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.content);
    }
  }

  protected createDefaultState(): UpdatePageControl {
    return new UpdatePageControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  static create(
    controlUID: string,
    pageUID: string,
    parent: UFNclControlBase,
    vr: ViewRealizer,
    vrAttachDetachFce: ViewRealizerAttachDetachControlFce
  ): NclPage {
    let page = new NclPage(
      {
        ControlUID: controlUID,
        PageUID: pageUID,
        IsDynamic: 1,
        Bounds: { Align: Align.Client, BandsCount: 0, FromBandIndex: 0, InteriorBandsCount: 0, PartIndex: 0 },
        FrgtData: { Size: 1, HorizontalAlignment: HorizontalAlignment.fhaCenter, VerticalAlignment: VerticalAlignment.fvaCenter },
      } as CSNclPageMetadata,
      parent,
      vr,
      vrAttachDetachFce
    );
    let dockVr: ViewRealizer = ViewRealizerManager.getViewRealizerByDock(pageUID);
    page.content = new NclDockControl(pageUID, page, vr, vrAttachDetachFce, dockVr ? dockVr.getRealizerUID() : "");
    return page;
  }

  public willUnMount(onlyListener: boolean) {
    super.willUnMount(onlyListener);
    if (this.content instanceof NclDockControl) this.content.willUnMount(onlyListener);
  }

  get Content(): UFNclControlBase {
    return this.content;
  }

  get Depth(): number {
    return this.vr.getDepth();
  }

  get MarginXFactor(): number {
    return 0;
  }

  get MarginYFactor(): number {
    return 0;
  }

  public getTabParent(): NclBaseTabControl<CSNclTabControlMetadata, UpdateTabControl> {
    if (this.parent instanceof NclBaseTabControl) {
      return this.parent;
    }

    return null;
  }

  public showContextMenu() {
    if (this.parent instanceof NclVRTabControl) {
      this.appendFunction({ Name: cJSonFunctionContextMenu }, true);
    }
  }
}

export class NclDataLabel extends UFNclControl<CSNclDataLabelMetadata, UpdateDataLabel> implements ClientContextMenuEmitor {
  protected createDefaultState(): UpdateDataLabel {
    return new UpdateDataLabel({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  protected internalComputeMinHeight(): number {
    let size: number = this.Size;

    if (this.state.GlyphId) {
      size = Math.max(this.VCX.InputControl.getInputHeight(1, true, false), this.VCX.LabelControl.getHeight(size));
    } else {
      size = this.VCX.LabelControl.getHeight(size);
    }

    if (this.ncl.FrgtData.Orientation === Orientation.foVertical && this.ncl.FrgtData.TitleDisplayMode !== DisplayMode.fpdmNone) {
      size += this.VCX.LabelControl.getHeight(1);
    }

    if (this.Ncl.FrgtData.BottomLine) {
      size += 1;
    }

    return size;
  }

  public contextMenu() {
    this.appendFunction({ Name: cJSonFunctionContextMenu }, true);
  }

  public click() {
    if (this.ncl.HasAction) {
      this.appendFunction({ Name: cJSonFunctionExecute }, true);
    }
  }

  public appendActionTo(menu: CSNclMenuMetadata): void {
    appendCallToPhone(this.state.Text, menu);
  }
}

function appendCallToPhone(value: string, menu: CSNclMenuMetadata) {
  if (menu && menu.Actions) {
    if (isPhoneNumber(value)) {
      let item = {
        ControlUID: `${menu.ControlUID}_call`,
        GlyphId: "wui*call.center.call",
        Caption: value,
        __type: ControlType.ClientMenuItem,
        action: () => {
          call(value);
        },
      } as CSNclClientMenuItemMetadata;
      menu.Actions.push(item);
    }
  }
}

class NclUndefinedControl extends UFNclControl<CSUFNclControlMetadata, UFUpdateControl> {
  protected createDefaultState(): UFUpdateControl {
    return new UFUpdateControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }
}

export class NclSplitterPanel extends NclContainerBase<CSNclSplitterPanelMetadata, UpdateSplitterPanel> {
  protected createDefaultState(): UpdateSplitterPanel {
    return new UpdateSplitterPanel({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  public setRatio(ratio: number) {
    if (this.state.Ratio != ratio) {
      this.internalSetData<SplitterDataRequest>({ Ratio: ratio } as SplitterDataRequest, false);
    }
  }

  public toggleCollapsed() {
    this.internalSetData<SplitterDataRequest>({ Collapsed: !this.state.Collapsed } as SplitterDataRequest, true);
  }

  public get MarginXFactor(): number {
    return 0;
  }

  public get MarginYFactor(): number {
    return 0;
  }

  protected computeMinHeight(withMargin: boolean): number {
    let firstPanelHeight = 0;
    let secondPanelHeight = 0;

    if (this.Children.get(0)) {
      if (!this.vr.calcFullHeight && this.Children.get(0) instanceof NclPanel) {
        firstPanelHeight += this.VCX.LabelControl.getHeight(this.Children.get(0).Size);
      } else {
        firstPanelHeight += this.Children.get(0).ComputedMinHeightWithMargin;
      }
    }

    if (this.Children.get(1)) {
      if (!this.vr.calcFullHeight && this.Children.get(1) instanceof NclPanel) {
        secondPanelHeight += this.VCX.LabelControl.getHeight(this.Children.get(1).Size);
      } else {
        secondPanelHeight += this.Children.get(1).ComputedMinHeightWithMargin;
      }
    }

    if (this.Ncl.FrgtData.Orientation === SplitterPanelOrientation.spoTop || this.Ncl.FrgtData.Orientation === SplitterPanelOrientation.spoBottom) {
      return firstPanelHeight + secondPanelHeight + this.VCX.sizeMap(7) + this.VCX.Data.MarginY * 2; // vyska splitteru + gap
    } else {
      return Math.max(firstPanelHeight, secondPanelHeight);
    }
  }
}

export abstract class NclBaseTabControl<T extends CSNclTabControlMetadata, S extends UpdateTabControl> extends UFNclControl<T, S> {
  private _Pages: List<NclPage>;
  private btns: Array<NclCommandItem>;
  private isMainTabControl: boolean = false;

  constructor(ncl: T, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    this.isMainTabControl = Context.getApplication().registerMainTabControl(this);
    this.initPages(ncl);
    if (ncl.Btns && ncl.Btns.length > 0) {
      this.btns = new Array<NclCommandItem>();
      let btn: NclCommandItem;
      ncl.Btns.map((item) => {
        item.FrgtData.DisplayStyle = TUFActionDisplayStyle.ufadsButtonSmall;
        btn = new NclCommandItem(item, this, vr, vrAttachDetachFce);
        this.addNestedControl(btn);
        this.btns.push(btn);
      });
    }
  }

  willUnMount(onlyListener: boolean) {
    super.willUnMount(onlyListener);
    Context.getApplication().unRegisterMainTabControl(this);
  }

  get CompanyColor(): string {
    let clr = Context.getApplication().getCompanyColor();

    if (this.isMainTabControl && clr > 0) {
      return this.VCX.ColorMap.getColor(Context.getApplication().getCompanyColor());
    }
    return undefined;
  }

  get MarginXFactor(): number {
    return 1;
  }

  get MarginYFactor(): number {
    return 1;
  }

  private initPages(ncl: T) {
    if (ncl.Pages) {
      let page: NclPage;
      let children = new Array<NclPage>();
      for (var i = 0; i < ncl.Pages.length; i++) {
        page = new NclPage(ncl.Pages[i], this, this.vr, this.vrAttachDetachFce);
        children.push(page);
        this.addNestedControl(page);
      }

      this._Pages = List<NclPage>(children);
    } else {
      this._Pages = List<NclPage>();
    }
  }

  protected getPages(): List<NclPage> {
    return this._Pages;
  }

  get Pages(): List<NclPage> {
    return this.getPages();
  }

  get Btns(): Array<NclCommandItem> {
    return this.btns;
  }

  public changeCurrentPage(page: string) {
    if (page !== this.state.CurrentPage) {
      this.internalSetData<TabControlDataRequest>({ CurrentPage: page } as TabControlDataRequest, true);
    }
  }

  protected internalCollectData(collector: Array<ControlDataRequest>) {
    super.internalCollectData(collector);
    this.internalCollectChildrenUpdate(collector);
  }

  protected internalCollectChildrenUpdate(collector: Array<ControlDataRequest>) {
    if (this.state.CurrentPage) {
      let ctrl = this.vr.getControlByUID(this.state.CurrentPage);
      if (ctrl) ctrl.collectData(collector);
    }
  }

  protected computeMinHeight(withMargin: boolean) {
    let minHeight = 0;

    this.Pages.map((page) => {
      if (page.Content.ComputedMinHeight > minHeight) {
        if (withMargin) {
          minHeight = page.Content.ComputedMinHeightWithMargin;
        } else {
          minHeight = page.Content.ComputedMinHeight;
        }
      }
    });

    minHeight += this.VCX.ExpanderControl.GetHFHeight() + this.VCX.sizeMap(6); // header

    if (withMargin) {
      minHeight += this.VCX.Data.MarginY * 2 * 2;
    }

    minHeight += 1; // border-bottom

    return minHeight;
  }
}

export class NclTabControl extends NclBaseTabControl<CSNclTabControlMetadata, UpdateTabControl> {
  protected createDefaultState(): UpdateTabControl {
    return new UpdateTabControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }
}

export class NclMultiContent extends NclBaseTabControl<CSNclTabControlMetadata, UpdateTabControl> {
  protected createDefaultState(): UpdateTabControl {
    return new UpdateTabControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  public get MarginXFactor(): number {
    return 0;
  }

  public get MarginYFactor(): number {
    return 0;
  }

  protected computeMinHeight(withMargin: boolean): number {
    const previous = this.vr.calcFullHeight;

    if (this.vr.calcFullHeight === false && ![Align.Client, Align.Left, Align.Right].includes(this.Ncl.Bounds.Align)) {
      this.vr.calcFullHeight = true;
    }

    let minHeight = 0;

    this.Pages.map((page) => {
      if (this.state.CurrentPage === (page.MetaData as CSNclPageMetadata).PageUID) {
        minHeight = page.Content.ComputedMinHeightWithMargin;
      }
    });

    if (previous === false) {
      this.vr.calcFullHeight = false;
    }

    minHeight = Math.max(this.VCX.LabelControl.getHeight(this.Size), minHeight);

    return minHeight;
  }
}

export class NclDockControl extends UFNclControl<CSUFNclControlMetadata, UpdateDockControl> {
  private vrADFce: ViewRealizerAttachDetachControlFce;
  private dockRealizerRUID: string;

  constructor(controlUID: string, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce, dockRealizerUID: string) {
    super(
      {
        ControlUID: controlUID,
        Bounds: { Align: Align.Client, BandsCount: 0, FromBandIndex: 0, InteriorBandsCount: 0, PartIndex: 0 },
        FrgtData: { Size: 1, HorizontalAlignment: HorizontalAlignment.fhaCenter, VerticalAlignment: VerticalAlignment.fvaCenter },
      } as CSUFNclControlMetadata,
      parent,
      vr,
      null
    );
    this.dockRealizerRUID = dockRealizerUID;
    this.vrADFce = vrAttachDetachFce;
    this.vrAttachDetachFce = NclDockControl.dockAttachDettach;
    this.vrAttachDetachFce.call(this.vr, this, true);
  }

  private static dockAttachDettach(control: UFNclControlBase, attach: boolean) {
    let dock: NclDockControl = control as NclDockControl;
    if (dock.vrADFce) dock.vrADFce.call(dock.vr, dock, attach);
    let dockVr: ViewRealizer = ViewRealizerManager.getViewRealizer(dock.dockRealizerRUID);
    if (dockVr) {
      if (attach) {
        dockVr.setDockControl(dock);
      } else {
        dockVr.setDockControl(null);
      }
    }
  }

  close() {
    if (this.dockRealizerRUID !== "") {
      let dockVr: ViewRealizer = ViewRealizerManager.getViewRealizer(this.dockRealizerRUID);
      if (dockVr) {
        dockVr.closeRequest();
      }
    }
  }

  public isDocked(): boolean {
    return this.state.DockRealizerUID === this.dockRealizerRUID;
  }

  public dockViewRealizer(realizerUID?: string): Promise<void> {
    if (realizerUID) {
      this.dockRealizerRUID = realizerUID;
    }
    this.state = this.state.merge({ DockRealizerUID: this.dockRealizerRUID }) as UpdateDockControl;
    if (this.Listener && (this.Listener as DockListener).dock) {
      return (this.Listener as DockListener).dock(this.state);
    } else {
      return Promise.resolve();
    }
  }

  public undockViewRealizer(): Promise<void> {
    if (this.Listener && (this.Listener as DockListener).undock) {
      return (this.Listener as DockListener).undock();
    } else {
      return Promise.resolve();
    }
  }

  protected createDefaultState(): UpdateDockControl {
    return new UpdateDockControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }
}

export class NclVRTabControl extends NclBaseTabControl<CSNclVRTabControlMetadata, UpdateVRTabControl> {
  private reloadPages: boolean;
  private pages: List<NclPage>;

  protected createDefaultState(): UpdateVRTabControl {
    return new UpdateVRTabControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  constructor(ncl: CSNclVRTabControlMetadata, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    this.reloadPages = true;
  }

  get CompanyColor(): string {
    let clr = Context.getApplication().getCompanyColor();
    if (clr > 0) return this.VCX.ColorMap.getColor(clr);

    return undefined;
  }

  public closePage(page: string) {
    this.Pages.forEach((value) => {
      if (value.Content.MetaData.ControlUID === page && value.Content instanceof NclDockControl) {
        value.Content.close();
        return;
      }
    });
  }

  protected getPages(): List<NclPage> {
    if (this.reloadPages) {
      if (this.pages == null) {
        this.pages = super.getPages();
      }

      if (this.state.RemovedTabs != null && this.state.RemovedTabs.size > 0) {
        this.state.RemovedTabs.map((ctrlId) => {
          let pageNdx = this.pages.findIndex((value) => {
            return value.Ncl.ControlUID === ctrlId;
          });
          if (pageNdx > -1) {
            let page = this.pages.get(pageNdx);
            if (page) {
              page.willUnMount(false);
              this.removeNestedControl(page);
              this.pages = this.pages.remove(pageNdx);
            }
          }
        });
      }

      if (this.state.AddedTabs != null && this.state.AddedTabs.size > 0) {
        this.state.AddedTabs.map(async (tab: List<string>) => {
          let page: NclPage = null;
          let tabIndex = this.pages.findIndex((value: NclPage, key: number) => {
            return value.Ncl.PageUID === tab.get(1);
          });

          if (tabIndex == -1) {
            page = NclPage.create(tab.get(0), tab.get(1), this, this.vr, this.vrAttachDetachFce);
            this.addNestedControl(page);
            this.pages = this.pages.push(page);
          } else {
            throw new Error("Page already exist.");
          }
        });
      }
      this.state = this.state.withMutations((state) => {
        state.set("AddedTabs", null);
        state.set("RemovedTabs", null);
      }) as UpdateVRTabControl;
      this.reloadPages = false;
    }
    return this.pages;
  }

  protected internalCanUpdate(newState: UpdateVRTabControl): boolean {
    let result: boolean = super.internalCanUpdate(newState);

    if (result && ((newState.AddedTabs != null && newState.AddedTabs.size > 0) || (newState.RemovedTabs != null && newState.RemovedTabs.size > 0))) {
      this.reloadPages = true;
    }

    return result;
  }
}

abstract class NclActionBase<T extends CSNclCommandItemMetadata, S extends UpdateCommandItem> extends UFNclControl<T, S> {
  public executeCommand(args?: Array<any>) {
    this.appendFunction({ Name: cJSonFunctionExecute, Args: args }, true);
  }
}

export class NclBreaker extends UFNclControl<CSNclBreakerMetadata, UFUpdateControl> {
  protected createDefaultState(): UpdateCommandItem {
    return new UpdateCommandItem({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID(), Decorate: undefined });
  }

  get MarginXFactor(): number {
    return 0;
  }

  get MarginYFactor(): number {
    return 0;
  }
}

export class NclCommandItem extends NclActionBase<CSNclCommandItemMetadata, UpdateCommandItem> {
  constructor(ncl: CSNclCommandItemMetadata, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    ncl.Bounds.Align = Align.Client; ///
    super(ncl, parent, vr, vrAttachDetachFce);
  }

  protected createDefaultState(): UpdateCommandItem {
    return new UpdateCommandItem({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID(), Decorate: undefined });
  }

  protected internalComputeMinHeight(): number {
    return this.VCX.InputControl.getEditHeight(1);
  }

  public get MarginXFactor(): number {
    return 0;
  }

  public get MarginYFactor(): number {
    return 0;
  }

  protected computeMinHeight(withMargin: boolean): number {
    if (this.Parent instanceof NclInnerSection) {
      return this.VCX.sizeMap(23);
    }

    return super.computeMinHeight(withMargin);
  }
}

export class NclButton extends NclActionBase<CSNclButtonMetadata, UpdateCommandItem> {
  protected createDefaultState(): UpdateCommandItem {
    return new UpdateCommandItem({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID(), Decorate: undefined });
  }

  protected internalComputeMinHeight(): number {
    let result = 0;

    if (this.Ncl.Bounds.Align === Align.Top || this.Ncl.Bounds.Align === Align.Bottom) {
      result = this.VCX.InputControl.getInputHeight(this.Size, true, false);
    } else {
      result = this.VCX.LabelControl.getHeight(this.Size);
    }

    if (
      this.ncl.FrgtData.ShowCaption === 1 &&
      (this.ncl.FrgtData.IconPosition === IconPosition.ipBottom || this.ncl.FrgtData.IconPosition === IconPosition.ipTop)
    ) {
      result += this.VCX.LabelControl.getHeight(1);
    }

    return result;
  }
}

export class NclCheckBox extends UFNclControl<CSNclCheckBoxMetaData, UpdateCheckBox> {
  public check() {
    this.internalSetData<CheckBoxDataRequest>({ Checked: !this.state.Checked } as CheckBoxDataRequest, true, true, RealizerOperations.Accept);
  }

  public contextMenu() {
    this.appendFunction({ Name: cJSonFunctionContextMenu }, true);
  }

  public createDefaultState(): UpdateCheckBox {
    return new UpdateCheckBox({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  protected internalInEditMode(): boolean {
    return !this.state.ReadOnly;
  }

  protected computeMinHeight(withMargin: boolean): number {
    return this.VCX.sizeMap(18) * this.Size;
  }
}

export class NclHeader extends NclControl<CSNclHeaderMetaData, UpdateControl> {
  private toolbar: NclToolBar;
  private separator: NclActionSeparator;
  private rQuickButtons: Array<NclCommandItem>;
  private locatorPanel: NclLocatorPanel;
  private lQuickButton: NclCommandItem;

  constructor(ncl: CSNclHeaderMetaData, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (!(parent instanceof NclHeaderedControl)) {
      throw Error("Bad parent");
    }
    if (ncl.ToolBar) {
      this.toolbar = new NclToolBar(ncl.ToolBar, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.toolbar);
    }

    if (ncl.Separator) {
      this.separator = new NclActionSeparator(ncl.Separator, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.separator);
    }

    this.rQuickButtons = new Array<NclCommandItem>();
    if (ncl.RQuickButtons && ncl.RQuickButtons.length > 0) {
      let action: NclCommandItem;
      ncl.RQuickButtons.map((value) => {
        action = new NclCommandItem(value, this, vr, vrAttachDetachFce);
        this.rQuickButtons.push(action);
        this.addNestedControl(action);
      });
    }

    if (ncl.LQuickButton) {
      this.lQuickButton = new NclCommandItem(ncl.LQuickButton, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.lQuickButton);
    }

    if (ncl.LocatorPanel) {
      this.locatorPanel = new NclLocatorPanel(ncl.LocatorPanel, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.locatorPanel);
    }
  }

  protected createDefaultState(): UpdateControl {
    return new UpdateControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  public get Headered(): NclHeaderedControl<CSNclHeaderedMetadata, UpdateHeadered> {
    return this.parent as NclHeaderedControl<CSNclHeaderedMetadata, UpdateHeadered>;
  }

  public get ToolBar(): NclToolBar {
    return this.toolbar;
  }

  public get Separator(): NclActionSeparator {
    return this.separator;
  }

  public get RQuickButtons(): Array<NclCommandItem> {
    return this.rQuickButtons;
  }

  public get LocatorPanel(): NclLocatorPanel {
    return this.locatorPanel;
  }

  public get LQuickButton(): NclCommandItem {
    return this.lQuickButton;
  }

  protected internalComputeMinHeight(): number {
    return this.VCX.ExpanderControl.GetHFHeight();
  }
}

export abstract class NclHeaderedControl<T extends CSNclHeaderedMetadata, S extends UpdateHeadered> extends UFNclControl<T, S> {
  private header: NclHeader;
  constructor(ncl: T, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (ncl.Header) {
      this.header = new NclHeader(ncl.Header, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.header);
    }
  }

  protected createDefaultState(): S {
    return new UpdateHeadered({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() }) as S;
  }

  public abstract isLite(): boolean;

  public isShowHeader(): boolean {
    return this.Header != undefined;
  }

  public get Header(): NclHeader {
    return this.header;
  }

  protected internalComputeMinHeight(): number {
    let result: number = 0;

    if (this.isShowHeader() && this.Header) {
      result = this.Header.ComputedMinHeight;
    }

    return result;
  }
}

export class NclTreeView extends NclHeaderedControl<CSNCLTreeViewMetadata, UpdateHeadered> {
  private content: NclInnerTreeView;

  constructor(ncl: CSNCLTreeViewMetadata, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (ncl.Content) {
      this.content = new NclInnerTreeView(ncl.Content, this, this.vr, this.vrAttachDetachFce);
      this.addNestedControl(this.content);
    }
  }

  protected createDefaultState(): UpdateHeadered {
    return new UpdateHeadered({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  get Content(): NclInnerTreeView {
    return this.content;
  }

  get MarginXFactor(): number {
    return 0;
  }

  get MarginYFactor(): number {
    return 0;
  }

  public isLite(): boolean {
    return false;
  }

  public setVCX(vcx: VisualContext, forceRefresh: boolean) {
    this.internalSetVCX(vcx, forceRefresh);
  }

  public doubleClick() {
    this.appendFunction({ Name: cJSonTreeViewDblClickExecute }, true);
  }

  protected computeMinHeight(withMargin: boolean): number {
    let height = 0;

    if (this.isShowHeader() && this.Header) {
      height += this.Header.ComputedMinHeightWithMargin;
    }

    height += this.VCX.sizeMap(21) * this.Size;

    return height;
  }
}

abstract class NclInnerColumnsListBase<
  T extends CSNclInnerDataGridMetadata | CSNclInnerTreeViewMetadata,
  S extends UpdateInnerDataGrid | UpdateInnerTreeView
> extends NclControl<T, S> {
  private columnMoveRequest: InnerColumnsListDataRequest;
  private colNdx: number = undefined;

  public get ColNdx(): number {
    return this.colNdx;
  }

  public set ColNdx(value: number) {
    this.colNdx = value;
  }

  public updateState(data: CSUpdateControl) {
    let upd = data as CSUpdateInnerColumnsList;
    if ((upd.ColumnsProportion && upd.ComputedColumnsVersion === undefined) || (upd.AutoAdjustWidth && this.state.AutoAdjustWidth)) {
      let upd = data as CSUpdateInnerColumnsList;
      upd.ColumnsVersion = Date.now();
    }
    super.updateState(data);
  }

  public setColumnsWidth(diffs: Array<number>, columnsProportion: ColumnsProportion) {
    if (!columnsProportion) return;
    let data: Array<Array<number>> = [];
    diffs.map((value, i) => {
      if (columnsProportion.length > i) {
        let v = GetColumnWidthEm(columnsProportion[i].Width + value, this.VCX.GridControl);
        data.push([i, v]);
      }
    });

    this.internalSetData({ WidthColumns: data } as InnerColumnsListDataRequest, false, false, RealizerOperations.Update);
  }

  public columnMove(from: number, to: number, callToServer: boolean): boolean {
    if (!this.state.ColumnsProportion) return false;
    if (from <= this.state.ColumnsProportion.length && to < this.state.ColumnsProportion.length) {
      if (!this.columnMoveRequest) this.columnMoveRequest = { ColumnsMove: [] } as InnerColumnsListDataRequest;

      this.columnMoveRequest.ColumnsMove.push([from, Math.max(to, -1)]);
      this.internalSetData(this.columnMoveRequest, callToServer, false, RealizerOperations.Update);
      return true;
    }
    return false;
  }

  public reCalculateColumnWidths(forWidth: number) {
    let adaptableWidth: number = 0;
    let occupyWidth: number = 0;
    let lW: number = 0;
    let columns: ColumnsProportion = [];

    if (this instanceof NclInnerTreeView) {
      if (this.state.MainColumnWidthEmW > 0 && this.state.ComputedColumnsVersion !== this.state.ColumnsVersion) {
        let mainCol = {
          Size: this.state.MainColumnWidthEmW,
          MultiplierKind: TUFCharCountMultiplierKind.ccmkEm,
          Adaptable: false,
          Alignment: TAlignment.taLeftJustify,
          Caption: "",
          DisplayStyleRT: TUFContextDisplayStyle.cdsText,
        } as ColumnProportionEm;
        mainCol.Width = GetColumnWidth(mainCol, this.VCX.GridControl);
        occupyWidth += mainCol.Width;
        if (mainCol.Adaptable) {
          adaptableWidth += mainCol.Width;
        }
        columns.push(mainCol);
      }
      forWidth = forWidth - 1.5 * this.VCX.GridControl.Font._MWidth; //expand button
    }

    if (this.state.ColumnsProportion && this.state.ColumnsProportion.length > 0) {
      this.state.ColumnsProportion.map((value: ColumnProportionEm) => {
        lW = GetColumnWidth(value, this.VCX.GridControl);
        occupyWidth += lW;
        if (value.Adaptable) {
          adaptableWidth += lW;
        }
        columns.push(Object.assign({}, value, { Width: lW }));
      });
    }

    if (this.state.AutoAdjustWidth && forWidth > 0) {
      let fWidth: number = forWidth - this.state.ColumnsProportion.length * this.VCX.GridControl.LineWidth;
      let adaptPix: number = 0;
      let lastNdx: number = 0;
      let maxAdaptW: number = 0;
      if (fWidth != occupyWidth && adaptableWidth > 0) {
        adaptPix = 1 + (fWidth - occupyWidth) / adaptableWidth;
        occupyWidth = 0;
        lastNdx = -1;
        maxAdaptW = 0;

        columns.map((value: ColumnProportionEm, index: number) => {
          if (value.Adaptable) {
            value.Width = Math.max(Math.round(value.Width * adaptPix), this.VCX.GridControl.GetExteriorCellWidth(this.VCX.GridControl.GetRowHeight(1)));
            if (value.Width > maxAdaptW) {
              lastNdx = index;
              maxAdaptW = value.Width;
            }
          }
          occupyWidth += value.Width;
        });

        occupyWidth += 2;
        if (lastNdx > 0) {
          columns[lastNdx].Width = Math.max(
            columns[lastNdx].Width + (forWidth - occupyWidth),
            this.VCX.GridControl.GetExteriorCellWidth(this.VCX.GridControl.GetRowHeight(1))
          );
        }
      }
    }

    this.updateState({ ColumnsProportion: columns, ComputedColumnsVersion: this.state.ColumnsVersion } as CSUpdateInnerColumnsList);
  }

  protected initDataRequest() {
    super.initDataRequest();
    this.columnMoveRequest = null;
  }
}

export class K2TreeViewItem implements ClientData {
  private _parent: K2TreeViewItem;
  private nodes: Array<K2TreeViewItem>;
  private _key: string;
  private data: CSTreeDataItem;

  constructor(key: string, data: CSTreeDataItem, parent: K2TreeViewItem) {
    this._parent = parent;
    this._key = key;
    this.update(data);
    if (this._parent) this._parent.addAsChild(this);
  }

  public get parent(): K2TreeViewItem {
    return this._parent;
  }

  //property for UI

  public get key(): string {
    return this._key;
  }

  public get index(): number {
    if (this.data) {
      return this.data.Index;
    }
    return -1;
  }

  public get Data() {
    return this.data;
  }

  public get children(): K2TreeViewItem[] {
    return this.nodes;
  }

  public set children(data) {
    this.nodes = data;
  }

  public get columns(): CSTreeColumn[] {
    if (this.data) {
      return this.data.Columns;
    }
    return null;
  }

  public get expanded(): boolean {
    return this.data && this.data.Expanded === true;
  }

  public getExpandedKeys(): string[] {
    let result = new Array<string>();
    if (this.expanded) {
      result.push(this.key);
    }
    if (this.children) {
      this.nodes.forEach((item) => {
        result.push(...item.getExpandedKeys());
      });
    }
    return result;
  }

  //property for UI

  public move(newParent: K2TreeViewItem) {
    if (newParent && newParent !== this.parent) {
      if (this._parent && this.parent.children) {
        let index = this.parent.children.indexOf(this);
        if (index > -1) {
          this.parent.children.splice(index, 1);
        }
      }
      this._parent = newParent;
      this.parent.addAsChild(this);
    }
  }

  private addAsChild(child: K2TreeViewItem) {
    if (!this.nodes) {
      this.nodes = new Array<K2TreeViewItem>();
    }

    this.nodes.push(child);

    this.nodes.sort((a, b) => {
      return a.index - b.index;
    });
  }

  public delete(): boolean {
    if (this._parent && this._parent.children) {
      let ndx = this._parent.children.indexOf(this);
      if (ndx >= 0) {
        this._parent.children.splice(ndx, 1);
        return true;
      }
    }
    return false;
  }

  update(src: CSTreeDataItem) {
    if (src) {
      if (!this.data) {
        this.data = src;
      } else {
        let oldIndex = this.data.Index;
        if (src.Expanded !== undefined && this.data.Expanded !== src.Expanded) {
          this.data.Expanded = src.Expanded;
        }

        if (src.Index !== undefined && this.data.Index !== src.Index) {
          this.data.Index = src.Index;
          if (this.data.Index !== oldIndex && this.parent && this.parent.nodes) {
            this.parent.nodes.sort((a, b) => {
              return a.index - b.index;
            });
          }
        }

        if (src.ParentKey !== undefined && this.data.ParentKey !== src.ParentKey) {
          this.data.ParentKey = src.ParentKey;
        }

        if (src.HasChildren !== undefined && this.data.HasChildren !== src.HasChildren) {
          this.data.HasChildren = src.HasChildren;
        }

        if (src.Columns !== undefined) {
          if (src.Columns.length === this.data.Columns.length) {
            src.Columns.forEach((column, index) => {
              if (column.CondFormatting && this.data.Columns[index].CondFormatting) {
                Object.assign(this.data.Columns[index].CondFormatting, column.CondFormatting);
                delete column.CondFormatting;
              }
              Object.assign(this.data.Columns[index], column);
            });
          } else {
            this.data.Columns = src.Columns; //when add or remove column server send all new columns
          }
        }
      }

      if (!this.nodes || src.HasChildren) {
        if (this.data.HasChildren !== TTreeDataHasChildNodes.chnNo) this.nodes = new Array<K2TreeViewItem>();
        else this.nodes = undefined;
      }
    }
  }
}

export enum TreeOperations {
  next = 1,
  prior = 2,
  firstPage = 3,
  lastPage = 4,
  expand = 5,
  collaps = 6,
}

export class NclInnerTreeView extends NclInnerColumnsListBase<CSNclInnerTreeViewMetadata, UpdateInnerTreeView> implements ClientContextMenuEmitor {
  private _tree: NclTreeView;
  private root: K2TreeViewItem;
  private map: Map<string, K2TreeViewItem>;
  private rowBmk: string;

  constructor(ncl: CSNclInnerTreeViewMetadata, parent: NclTreeView, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    this._tree = parent;
    this.root = new K2TreeViewItem("", null, null);
    this.map = new Map<string, K2TreeViewItem>();
  }

  public get Tree(): NclTreeView {
    return this._tree;
  }

  public get Root(): K2TreeViewItem {
    return this.root;
  }

  public get RowBmk(): string {
    return this.rowBmk;
  }

  appendActionTo(menu: CSNclMenuMetadata): void {
    if (this.RowBmk && this.ColNdx >= 0 && this.map != null) {
      let row = this.map.get(this.RowBmk);
      if (row && this.ColNdx < row.columns.length) {
        let cell = row.columns[this.ColNdx];
        if (cell) {
          appendCallToPhone(cell.Text, menu);
        }
      }
    }
  }

  protected createDefaultState(): UpdateInnerTreeView {
    return new UpdateInnerTreeView({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  public executeExpand(value: string) {
    this.click(value, 0, 1, false);

    this.appendFunction({ Name: cJSonFunctionToggleNodeExecute, Args: null }, true);
  }

  public invokeAction(op: TreeOperations) {
    // if (this.invalidData > 0) return;
    if (this.map && this.map.has(this.RowBmk)) {
      let current = this.map.get(this.RowBmk);
      if (current) {
        switch (op) {
          case TreeOperations.firstPage:
            if (this.Root && this.Root.children && this.Root.children.length > 0) {
              this.click(this.Root.children[0].key, this.ColNdx, 1, true);
            }
            break;
          case TreeOperations.lastPage:
            this.last(this.Root);
            break;
          case TreeOperations.next:
            this.next(current);
            break;
          case TreeOperations.prior:
            this.prior(current);
            break;
          case TreeOperations.expand:
            if (!current.expanded) {
              this.executeExpand(current.key);
            }
            break;
          case TreeOperations.collaps:
            if (current.expanded) {
              this.executeExpand(current.key);
            } else {
              if (current.parent && current.parent.expanded) {
                this.executeExpand(current.parent.key);
              }
            }
            break;
          default:
            break;
        }
      }
    }
  }

  private last(item: K2TreeViewItem) {
    if (item && item.children && item.children.length > 0) {
      let last = item.children[item.children.length - 1];
      if (last.expanded) {
        this.last(last);
      } else {
        this.click(last.key, this.ColNdx, 1, true);
      }
    }
  }

  private next(item: K2TreeViewItem, deeper: boolean = true) {
    if (item) {
      if (deeper && item.children && item.children.length > 0 && item.expanded === true) {
        this.click(item.children[0].key, this.ColNdx, 1, true);
      } else {
        if (item.parent && item.parent.children && item.parent.children.length > 0 && item.index + 1 < item.parent.children.length) {
          this.click(item.parent.children[item.index + 1].key, this.ColNdx, 1, true);
        } else {
          this.next(item.parent, false);
        }
      }
    }
  }

  private prior(item: K2TreeViewItem, deeper: boolean = true) {
    if (item) {
      if (item.index > 0 && item.parent && item.parent.children && item.parent.children.length > 0) {
        let prior = item.parent.children[item.index - 1];
        if (prior && prior.expanded && prior.children && prior.children.length > 0) {
          this.click(prior.children[prior.children.length - 1].key, this.ColNdx, 1, true);
        } else {
          this.click(prior.key, this.ColNdx, 1, true);
        }
      } else {
        this.click(item.parent.key, this.ColNdx, 1, true);
      }
    }
  }

  public executeMove(nodeBmk: string, toNodeBmk: string, mode: TTreeDataMoveNodeMode) {
    this.appendFunction({ Name: cJSonFunctionMoveNodeExecute, Args: [nodeBmk, toNodeBmk, mode] }, true);
  }

  public applyModification(changes: Array<ModifyTreeItem>): boolean {
    if (changes && changes.length > 0) {
      let item: K2TreeViewItem;
      let parent: K2TreeViewItem;
      let data: CSTreeDataItem;
      let unprocessed: ModifyTreeItem[] = [];
      changes.map((value) => {
        if (value.ModifyType !== TDataItemModifyType.tdimNew) {
          if (value.Key && this.map.has(value.Key)) {
            item = this.map.get(value.Key);
          } else {
            Log.warn(`TreeItem with key:${value.Key} not found.`);
          }
        }

        if (value.Data) {
          data = value.Data;
          if (typeof data === "string") {
            data = parseData(data);
          }
        }

        switch (value.ModifyType) {
          case TDataItemModifyType.tdimDelete:
            if (item) {
              this.map.delete(item.key);
              item.delete();
            }
            break;
          case TDataItemModifyType.tdimNew:
            if (data) {
              if (data.ParentKey) {
                if (this.map.has(data.ParentKey)) {
                  parent = this.map.get(data.ParentKey);
                } else {
                  unprocessed.push(value);
                  return;
                }
              } else {
                parent = this.root;
              }

              item = new K2TreeViewItem(value.Key, data, parent);
              this.map.set(item.key, item);
            }
            break;
          case TDataItemModifyType.tdimModify:
            if (item && data) {
              item.update(data);
              if (data.ParentKey !== undefined) {
                //move
                let newParent = null;
                if (this.map.has(data.ParentKey)) {
                  newParent = this.map.get(data.ParentKey);
                } else {
                  newParent = this.root;
                }
                if (newParent) {
                  item.move(newParent);
                }
              }
            }
            break;
          default:
            break;
        }
      });
      if (unprocessed.length > 0) {
        return this.applyModification(unprocessed);
      }
      return true;
    }

    return false;
  }

  public updateState(data: CSUpdateControl) {
    if ((data as CSUpdateInnerTreeView).Data) {
      let upd = data as CSUpdateInnerTreeView;
      if (this.applyModification(upd.Data)) {
        upd.DataVersion = Date.now();
        delete upd.Data;
      }
    }
    super.updateState(data);
  }

  public contextMenu(rowBmk: string, colIndex: number) {
    this.updatePositions(rowBmk, colIndex, true);

    if (!rowBmk) this.appendFunction({ Name: cJSonFunctionContextMenu, Args: [-1] }, true);
    //row index can be -1 for heading
    else this.appendFunction({ Name: cJSonFunctionContextMenu }, true);
  }

  public click(value: string, columnIndex: number, clickCount: number, callToServer: boolean = true) {
    let update = this.updatePositions(value, columnIndex, !callToServer);
    if (clickCount == 1 && callToServer && update) {
      this.vr.sendRequest(RealizerOperations.Update, this);
    }

    if (clickCount === 2 && callToServer) {
      this._tree.doubleClick();
    }
  }

  protected afterSetState(canUpdate: boolean, oldState: UpdateInnerTreeView) {
    let newCol: number;
    let newRBmk: string;
    if (canUpdate) {
      if (this.state.CurrentColumn !== oldState.CurrentColumn) {
        newCol = this.state.CurrentColumn;
      }
      if (this.state.CurrentBookmark !== oldState.CurrentBookmark) {
        newRBmk = this.state.CurrentBookmark;
      }
    }

    super.afterSetState(canUpdate, oldState);
    this.updatePositions(newRBmk, newCol, true, false);
  }

  private updatePositions(rowBmk: string, colIndex: number, forceUpdate: boolean, prepareDataToServer: boolean = true): boolean {
    let newColNdx = colIndex >= 0 ? colIndex : this.ColNdx;
    let newRowBmk = rowBmk ? rowBmk : this.rowBmk;
    let update: boolean = false;

    if (this.rowBmk != newRowBmk) {
      if (prepareDataToServer) this.internalSetData<TreeViewDataRequest>({ CurrentBookmark: newRowBmk } as TreeViewDataRequest, false);
      update = true;
    }

    if (this.ColNdx !== newColNdx) {
      if (prepareDataToServer) this.internalSetData({ CurrentColumn: newColNdx } as InnerColumnsListDataRequest, false, false, RealizerOperations.None);
      update = true;
    }

    if (update && forceUpdate) {
      let oldRow = this.rowBmk;
      this.rowBmk = newRowBmk;
      let oldCol = this.ColNdx;
      this.ColNdx = newColNdx;
      let listener: TreeViewListener = this.Listener as TreeViewListener;

      if (listener && listener.updatePosition) {
        this.Listener.updatePosition(oldRow, this.rowBmk, oldCol, this.ColNdx);
      }
    }

    return update;
  }
}

export class NclAggregationPanel extends NclControl<CSNclAggregationPanel, UpdateAggregationPanel> {
  private container: NclDataGridBase<CSNclDataGridBaseMetadata, UpdateDataGrid>;

  constructor(
    ncl: CSNclAggregationPanel,
    parent: NclControlBase,
    container: NclDataGridBase<CSNclDataGridBaseMetadata, UpdateDataGrid>,
    vr: ViewRealizer,
    vrAttachDetachFce: ViewRealizerAttachDetachControlFce
  ) {
    super(ncl, parent, vr, vrAttachDetachFce);
    this.container = container;
  }

  public updateState(data: CSUpdateControl) {
    super.updateState(data);
  }

  contextMenu(index: number) {
    this.appendFunction({ Name: cJSonFunctionContextMenu, Args: [index] }, true);
  }

  protected createDefaultState(): UpdateAggregationPanel {
    return new UpdateAggregationPanel({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }
}

export class NclDataGridFooter extends NclControl<CSNclDataGridFooter, UpdateControl> {
  private leftToolbar: NclToolBar;
  private rightToolbar: NclToolBar;

  constructor(
    ncl: CSNclDataGridFooter,
    parent: NclDataGridBase<CSNclDataGridBaseMetadata, UpdateDataGrid>,
    vr: ViewRealizer,
    vrAttachDetachFce: ViewRealizerAttachDetachControlFce
  ) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (ncl.LeftToolbar) {
      this.leftToolbar = new NclToolBar(ncl.LeftToolbar, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.leftToolbar);
    }

    if (ncl.RightToolbar) {
      this.rightToolbar = new NclToolBar(ncl.RightToolbar, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.rightToolbar);
    }
  }

  get LeftToolbar(): NclToolBar {
    return this.leftToolbar;
  }

  get RightToolbar(): NclToolBar {
    return this.rightToolbar;
  }

  protected createDefaultState(): UpdateControl {
    return new UpdateControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  get MarginYFactor(): number {
    return 0;
  }

  protected internalComputeMinHeight(): number {
    return this.VCX.sizeMap(25);
  }
}

export class NclGanttFooter extends NclControl<CSNclGanttFooter, UpdateControl> {
  private leftToolbar: NclToolBar;

  constructor(
    ncl: CSNclGanttFooter,
    parent: NclGantt /*<CSNclGanttMetadata,UpdateHeadered>*/,
    vr: ViewRealizer,
    vrAttachDetachFce: ViewRealizerAttachDetachControlFce
  ) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (ncl.LeftToolbar) {
      this.leftToolbar = new NclToolBar(ncl.LeftToolbar, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.leftToolbar);
    }
  }

  get LeftToolbar(): NclToolBar {
    return this.leftToolbar;
  }

  protected createDefaultState(): UpdateControl {
    return new UpdateControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  get MarginYFactor(): number {
    return 0;
  }
}

export class NclDataGridContent extends NclControl<CSNclDataGridContent, UpdateControl> {
  private dataGrid: NclInnerDataGrid;

  constructor(
    ncl: CSNclDataGridContent,
    parent: NclDataGridBase<CSNclDataGridBaseMetadata, UpdateDataGrid>,
    vr: ViewRealizer,
    vrAttachDetachFce: ViewRealizerAttachDetachControlFce
  ) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (ncl.DataGrid) {
      this.dataGrid = new NclInnerDataGrid(ncl.DataGrid, this, parent, vr, vrAttachDetachFce);
      this.addNestedControl(this.dataGrid);
    }
  }

  get MarginXFactor(): number {
    return 0;
  }

  get MarginYFactor(): number {
    return 0;
  }

  get DataGrid(): NclInnerDataGrid {
    return this.dataGrid;
  }

  protected createDefaultState(): UpdateControl {
    return new UpdateControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  protected internalComputeMinHeight(): number {
    let result = super.internalComputeMinHeight();

    if (this.DataGrid) {
      result = this.DataGrid.ComputedMinHeightWithMargin;
    }

    return result;
  }
}

export class NclGanttContent extends NclControl<CSNclGanttContent, UpdateControl> {
  private ganttInner: NclInnerGantt;

  constructor(
    ncl: CSNclGanttContent,
    parent: NclGantt /*<CSNclGanttMetadata,UpdateHeadered>*/,
    vr: ViewRealizer,
    vrAttachDetachFce: ViewRealizerAttachDetachControlFce
  ) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (ncl.GanttInner) {
      this.ganttInner = new NclInnerGantt(ncl.GanttInner, this, parent, vr, vrAttachDetachFce);
      this.addNestedControl(this.ganttInner);
    }
  }

  get MarginXFactor(): number {
    return 0;
  }

  get MarginYFactor(): number {
    return 0;
  }

  get GanttInner(): NclInnerGantt {
    return this.ganttInner;
  }

  protected createDefaultState(): UpdateControl {
    return new UpdateControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  protected internalComputeMinHeight(): number {
    let result = super.internalComputeMinHeight();

    if (this.GanttInner) {
      result = this.GanttInner.ComputedMinHeightWithMargin;
    }

    return result;
  }
}

interface LastOptions {
  currentBookmark: string;
  topBookmark: string;
  operation: GridOperations;
}

class LocalGridCache {
  private control: NclInnerDataGrid;

  private data: Array<CSDataItem>;
  private view: Array<CSDataItem>;

  private rowNdx: number;
  private __topNdxOfView: number;
  private startViewNdx: number;
  private viewVersion: number;
  private last: LastOptions;

  private setPosition: (row?: number, col?: number) => void;

  constructor(control: NclInnerDataGrid, setPosition: (row?: number, col?: number) => void) {
    this.control = control;
    this.setPosition = setPosition;
    this.data = [];
    this.view = [];
    this.__topNdxOfView = 0;
    this.startViewNdx = 0;
  }

  public isEmpty(): boolean {
    return !this.data || this.data.length === 0;
  }

  public hasData(rowNdx: number): boolean {
    if (!this.isEmpty() && rowNdx > 0 && rowNdx < this.data.length) return true;
    return false;
  }

  public getDataItem(rowNdx: number): CSDataItem {
    if (this.hasData(rowNdx)) return this.data[rowNdx];
    return undefined;
  }

  private get topNdxOfView(): number {
    return this.__topNdxOfView;
  }

  private setTopNdxOfView(value: number) {
    if (this.__topNdxOfView !== value) {
      this.__topNdxOfView = value;
    }
  }

  public get viewData(): Array<CSDataItem> {
    if (this.isEnabled()) {
      let dataVer = (this.control.State as UpdateInnerDataGrid).DataVersion;
      if (this.viewVersion !== dataVer) {
        if (this.maxRowCount > 0 && this.data) {
          let endW = Math.min(this.topNdxOfView + this.startViewNdx + this.maxRowCount + this.viewDelta, this.data.length);
          let startW = Math.max(endW - (this.maxRowCount + 2 * this.viewDelta), 0);
          if (endW > 0 && endW <= this.data.length && startW >= 0 && startW < this.data.length && endW > startW) {
            this.view = this.data.slice(startW, endW);
            this.setTopNdxOfView(Math.max(this.topNdxOfView - (startW - this.startViewNdx), 0));
            this.startViewNdx = startW;

            this.viewVersion = dataVer;
          }
        }
      }
      return this.view;
    }

    return this.data;
  }

  public getRowNdx(): number {
    return this.rowNdx;
  }

  public getViewRowNdx(): number {
    return this.convertToLocalRowNdx(this.rowNdx);
  }

  public getTopNdxOfView(): number {
    return this.topNdxOfView;
  }

  private get maxRowCount(): number {
    if (this.control && this.control.Container) {
      return this.control.Container.MaxRowCount;
    }
    return 0;
  }

  private get viewDelta(): number {
    return Math.max(Math.round(this.maxRowCount / 2), 30);
  }

  private getItemByKey(key: string): { index: number; data: CSDataItem } {
    if (key) {
      let i = this.data.findIndex((value) => value && value.Key === key);
      if (i >= 0) return { index: i, data: this.data[i] };
    }
    return undefined;
  }

  public applyModification(changes: Array<ModifyItem>): boolean {
    let result: boolean = false;
    let deleteCount: number = 0;
    let appendCount: number = 0;
    let isCurrSet: boolean = true;
    if (changes && changes.length > 0) {
      isCurrSet = false;
      let data: CSDataItem;
      let item: { index: number; data: CSDataItem };
      changes = changes.sort((a, b) => a.ModifyType - b.ModifyType);
      changes.map((value) => {
        if (value.ModifyType !== TDataItemModifyType.tdimNew) {
          item = this.getItemByKey(value.Key);

          if (!item) {
            Log.warn(`Item with key:${value.Key} not found.`);
          }
        }

        if (value.Changes) {
          data = value.Changes;
          if (typeof data === "string") {
            data = parseData(data);
          }
        }

        if (this.last && value.Key === this.last.currentBookmark && value.ModifyType !== TDataItemModifyType.tdimDelete) {
          this.rowNdx = data.Row;
          isCurrSet = true;
        }

        switch (value.ModifyType) {
          case TDataItemModifyType.tdimDelete:
            deleteCount++;
            if (item) {
              this.data[item.index] = undefined;
            }
            break;
          case TDataItemModifyType.tdimNew:
            if (data) {
              data.Key = value.Key;
              this.data[data.Row] = data;
              appendCount++;
            }
            break;
          case TDataItemModifyType.tdimModify:
            if (item && data) {
              if (data.Columns) {
                if (data.Columns.length === item.data.Columns.length) {
                  data.Columns.forEach((column, index) => {
                    if (column.CondFormatting && item.data.Columns[index].CondFormatting) {
                      item.data.Columns[index].CondFormatting = Object.assign({}, item.data.Columns[index].CondFormatting, column.CondFormatting);
                      delete column.CondFormatting;
                    }
                    if (item.data.Columns[index].MultiTexts) {
                      column.MultiTexts.map((multitext, i) => {
                        item.data.Columns[index].MultiTexts[i] = { ...item.data.Columns[index].MultiTexts[i], ...multitext };
                      });
                    } else {
                      Object.assign(item.data.Columns[index], column);
                    }
                  });
                } else {
                  item.data.Columns = data.Columns; //when add or remove column server send all new columns
                }
              }
              if (data.Row != undefined) {
                if (data.Row !== item.data.Row) {
                  [this.data[item.index], this.data[data.Row]] = [this.data[data.Row], this.data[item.index]];
                  item.data.Row = data.Row;
                }
              }
            }
            break;
          default:
            break;
        }
      });

      if (deleteCount > 0) {
        let i = 0;
        while (i < this.data.length && this.data[i] == undefined) {
          this.data.splice(i, 1);
          i++;
        }
        if (deleteCount > i) {
          i = this.data.length - 1;
          while (i >= 0 && this.data[i] == undefined) {
            this.data.splice(i, 1);
            i--;
          }
        }
      }
      result = true;
    }

    if (this.last) {
      //when didn't received data and lastCurrent is set, must set current to first or last
      if (this.data && this.data.length > 0) {
        if (this.last.operation === GridOperations.swipeUp) {
          if (isCurrSet == false) {
            this.rowNdx = changes && changes.length > 0 ? 0 : this.data.length - 1;
          }
          if (deleteCount > 0) {
            this.setTopNdxOfView(Math.max(this.topNdxOfView - deleteCount + this.startViewNdx, 0));
            this.startViewNdx = Math.max(this.startViewNdx - deleteCount, 0);
          } else {
            let item = this.getItemByKey(this.last.topBookmark);
            if (item) {
              this.setTopNdxOfView(item.index);
            } else {
              this.setTopNdxOfView(Math.max(this.data.length - this.maxRowCount, 0));
            }
          }
        }
        if (this.last.operation === GridOperations.swipeDown) {
          if (isCurrSet == false) this.rowNdx = changes && changes.length > 0 ? this.data.length - 1 : 0;
          if (appendCount > 0) {
            this.startViewNdx = Math.max(this.startViewNdx - appendCount, 0);
            this.setTopNdxOfView(Math.max(this.topNdxOfView + appendCount, 0));
          } else {
            this.setTopNdxOfView(0);
          }
        }
      }
      this.last = undefined;
      result = true;
    }

    return result;
  }

  private convertToLocalRowNdx(rowNdx: number): number {
    return rowNdx - this.startViewNdx;
  }

  public isEnabled(): boolean {
    return this.data.length > 0 && (this.data.length > this.maxRowCount || Context.DeviceInfo.ExplicitMaxRowCount > 0);
  }

  public updatePositions(rowIndex: number, colIndex: number, forceUpdate: boolean, prepareDataToServer: boolean = true) {
    let update: boolean = false;
    let newRowNdx = rowIndex >= 0 ? rowIndex : this.rowNdx;
    let newColNdx = colIndex >= 0 ? colIndex : this.control.ColNdx;

    if (this.control.ColNdx !== newColNdx) {
      update = true;
      if (prepareDataToServer) this.setPosition(undefined, newColNdx);
    }

    if (this.rowNdx !== newRowNdx) {
      update = true;
      if (prepareDataToServer) this.setPosition(newRowNdx);
    }

    if (update && forceUpdate) {
      let oldRow = this.rowNdx;
      this.rowNdx = newRowNdx;
      let oldCol = this.control.ColNdx;
      this.control.ColNdx = newColNdx;
      let listener: DataGridListener = this.control.Listener as DataGridListener;
      if (listener && listener.updatePosition) {
        let newR = this.convertToLocalRowNdx(this.rowNdx);
        let oldR = this.convertToLocalRowNdx(oldRow);
        if (newR < 0 || newR > this.viewData.length) {
          if (this.moveViewTo(newR, this.rowNdx > oldRow) === false) return;
          newR = this.convertToLocalRowNdx(this.rowNdx);
          oldR = this.convertToLocalRowNdx(oldRow);
        }
        this.control.Listener.updatePosition(oldR, newR, oldCol, this.control.ColNdx);
      }
    }
  }

  public moveView(op: GridOperations, diff: number): boolean {
    switch (op) {
      case GridOperations.next:
        return this.moveViewTo(this.topNdxOfView + diff, false);
      case GridOperations.prior:
        return this.moveViewTo(this.topNdxOfView - diff, false);
      default:
        break;
    }
  }

  public moveViewTo(newViewNdx: number, lastInView: boolean): boolean {
    if (!this.isEnabled()) return undefined;

    // NclInnerDataGrid.log("Before moveViewTo", this.viewData, this.topNdxOfView, this.getViewRowNdx(), this.maxRowCount);
    if (lastInView) {
      newViewNdx = newViewNdx - (this.maxRowCount - 1);
    }
    let lastTopNdx = this.topNdxOfView;

    if (newViewNdx > this.topNdxOfView) {
      this.setTopNdxOfView(newViewNdx);
      //Load next
      if (newViewNdx + this.maxRowCount > this.view.length) {
        if (this.startViewNdx + this.maxRowCount + 2 * this.viewDelta >= this.data.length) {
          this.last = { operation: GridOperations.swipeUp } as LastOptions;
          if (this.data.length > this.rowNdx) this.last.currentBookmark = this.data[this.rowNdx].Key;
          if (this.data.length > lastTopNdx) this.last.topBookmark = this.data[lastTopNdx].Key;
          // NclInnerDataGrid.log("SwipeUp", this.viewData, this.topNdxOfView, this.getViewRowNdx(), this.maxRowCount);

          this.control.invokeAction(this.last.operation);
          return undefined;
        }
        // NclInnerDataGrid.log("Next from memory", this.viewData, this.topNdxOfView, this.getViewRowNdx(), this.maxRowCount);
        this.control.updateState({ DataVersion: Date.now() } as UpdateInnerDataGrid);
        return false;
      } else {
        // NclInnerDataGrid.log("Next", this.viewData, this.topNdxOfView, this.getViewRowNdx(), this.maxRowCount);
        return true;
      }
    } else {
      this.setTopNdxOfView(newViewNdx);
      //Load previous
      if (newViewNdx < 0) {
        if (this.startViewNdx > 0) {
          // NclInnerDataGrid.log("Prior from memory", this.viewData, this.topNdxOfView, this.getViewRowNdx(), this.maxRowCount);
          this.control.updateState({ DataVersion: Date.now() } as UpdateInnerDataGrid);
          return false;
        }
        this.last = { operation: GridOperations.swipeDown } as LastOptions;

        if (this.data.length > this.rowNdx) this.last.currentBookmark = this.data[this.rowNdx].Key;
        // NclInnerDataGrid.log("SwipeDown", this.viewData, this.topNdxOfView, this.getViewRowNdx(), this.maxRowCount);
        this.control.invokeAction(this.last.operation);
        return undefined;
      } else {
        // NclInnerDataGrid.log("Prior", this.viewData, this.topNdxOfView, this.getViewRowNdx(), this.maxRowCount);
        return true;
      }
    }
  }

  public isInVisibleView(ndx: number): number {
    if (!this.isEnabled()) return 0;
    if (ndx < this.topNdxOfView) return -1;
    if (ndx > this.topNdxOfView + this.maxRowCount - 1) return 1;
    return 0;
  }
}

export class NclInnerDataGrid extends NclInnerColumnsListBase<CSNclInnerDataGridMetadata, UpdateInnerDataGrid> implements ClientContextMenuEmitor {
  private container: NclDataGridBase<CSNclDataGridBaseMetadata, UpdateDataGrid>;
  private quickFilter: NclQuickFilter;
  private clmVersion: number;
  private rowHeight: number;
  private cache: LocalGridCache;
  private timer: any;

  constructor(
    ncl: CSNclInnerDataGridMetadata,
    parent: NclControlBase,
    container: NclDataGridBase<CSNclDataGridBaseMetadata, UpdateDataGrid>,
    vr: ViewRealizer,
    vrAttachDetachFce: ViewRealizerAttachDetachControlFce
  ) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (container.Ncl.QuickFilter) {
      this.quickFilter = new NclQuickFilter(container.Ncl.QuickFilter, this, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.quickFilter);
    }
    this.container = container;
    this.cache = new LocalGridCache(this, (row, col) => {
      if (row != undefined) this.internalSetData({ Position: row } as InnerDataGridDataRequest, false, false, RealizerOperations.None);
      if (col != undefined) this.internalSetData({ CurrentColumn: col } as InnerDataGridDataRequest, false, false, RealizerOperations.None);
    });
  }

  appendActionTo(menu: CSNclMenuMetadata): void {
    if (this.rowNdx >= 0 && this.ColNdx >= 0) {
      let data = this.cache.getDataItem(this.rowNdx);
      if (data && data.Columns && this.ColNdx < data.Columns.length) {
        let cell = data.Columns[this.ColNdx];
        if (cell) {
          appendCallToPhone(cell.Text, menu);
        }
      }
    }
  }
  public getRowHeightMultiplier(): number {
    return this.container ? this.container.Ncl.FrgtData.RowHeightMultiplier : 1;
  }

  public isHideHeading(): boolean {
    return this.container ? this.container.Ncl.FrgtData.HideHeading : false;
  }

  public getRowHeight(): number {
    if (this.state.ColumnsVersion == undefined) return undefined;
    if (this.rowHeight && this.state.ColumnsVersion === this.clmVersion) return this.rowHeight;

    let max: number = -1;
    let rhm = this.VCX.GridControl.GetRowHeight(this.getRowHeightMultiplier());

    this.clmVersion = this.state.ColumnsVersion;
    if (this.state.ColumnsProportion) {
      this.state.ColumnsProportion.map((column) => {
        if (this.VCX.calcMFMeasure(column.MFMeasure)) {
          if (column.MFMeasure.Height > max) max = column.MFMeasure.Height;
        }
      });
    }

    this.rowHeight = Math.max(rhm, max);

    return this.rowHeight;
  }

  public get QuickFilter(): NclQuickFilter {
    return this.quickFilter;
  }
  /**
   * Index of actual row in data cache
   */
  private get rowNdx(): number {
    return this.cache.getRowNdx();
  }

  /**
   * Index of actual row in view
   */
  public get viewRowNdx(): number {
    return this.cache.getViewRowNdx();
  }

  public get topNdxOfView(): number {
    return this.cache.getTopNdxOfView();
  }

  public get data(): Array<CSDataItem> {
    return this.cache.viewData;
  }

  public updateState(data: CSUpdateControl) {
    if ((data as CSUpdateInnerDataGrid).Data) {
      let upd = data as CSUpdateInnerDataGrid;
      if (this.cache.applyModification(upd.Data)) {
        upd.DataVersion = Date.now();
      }
      delete upd.Data;
    }
    super.updateState(data);
    // NclInnerDataGrid.log("updateState", this.data, this.topNdxOfView, this.viewRowNdx, this.container.MaxRowCount);
  }
  //   public static log(prefix: string, data: Array<CSDataItem>, topNdxOfView: number, current: number, maxRowCount: number) {
  //     //return;
  //     if (data && topNdxOfView >= 0 && topNdxOfView < data.length) {
  //       if (data[topNdxOfView].Columns.length > 2) {
  //         console.log(`${prefix}
  //         Top: ${data[topNdxOfView].Columns[1].Text}...
  //         Current:${data.length > current && current >= 0 ? data[current].Columns[1].Text : "mimo"}
  //         Bottom:${topNdxOfView + maxRowCount - 1 < data.length ? data[topNdxOfView + maxRowCount - 1].Columns[1].Text : "mimo"}`);
  //       } else {
  //         console.log(`${prefix}
  // Top: ${data[topNdxOfView].Columns[1].MultiTexts[1]}...
  // Current:${data.length > current && current >= 0 ? data[current].Columns[1].MultiTexts[1] : "mimo"}
  // Bottom:${topNdxOfView + maxRowCount - 1 < data.length ? data[topNdxOfView + maxRowCount - 1].Columns[1].MultiTexts[1] : "mimo"}`);
  //       }
  //     }
  //   }

  protected afterSetState(canUpdate: boolean, oldState: UpdateInnerDataGrid) {
    let newRow: number;
    let newCol: number;
    if (canUpdate) {
      if (this.state.Position !== oldState.Position) {
        newRow = this.state.Position;
      }

      newCol = this.state.CurrentColumn;
    }

    this.cache.updatePositions(newRow, newCol, true, false);

    super.afterSetState(canUpdate, oldState);
  }

  protected createDefaultState(): UpdateInnerDataGrid {
    return new UpdateInnerDataGrid({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  get MarginXFactor(): number {
    return 0;
  }

  get MarginYFactor(): number {
    return 0;
  }

  public contextMenu(rowIndex: number, colIndex: number) {
    this.cache.updatePositions(rowIndex, colIndex, true);

    if (rowIndex === -1) this.appendFunction({ Name: cJSonFunctionContextMenu, Args: [rowIndex] }, true);
    //row index can be -1 for heading
    else this.appendFunction({ Name: cJSonFunctionContextMenu }, true);
  }

  public click(rowIndex: number, columnIndex: number, clickCount: number = undefined) {
    this.cache.updatePositions(rowIndex, columnIndex, clickCount === undefined);

    if (clickCount === 1) {
      this.vr.sendRequest(RealizerOperations.Update, this);
    }

    if (clickCount === 2) {
      this.container.doubleClick();
    }
  }

  get Container(): NclDataGridBase<CSNclDataGridBaseMetadata, UpdateDataGrid> {
    return this.container;
  }

  protected internalComputeMinHeight(): number {
    let result = super.internalComputeMinHeight();

    let gridLineWidth = 1;
    result = (this.VCX.GridControl.GetRowHeight(this.getRowHeightMultiplier()) + gridLineWidth) * this.container.Ncl.FrgtData.Size /*+ FixedRowCount*/;
    return result;
  }

  public isCacheEnabled(): boolean {
    return this.cache.isEnabled();
  }

  public moveView(op: GridOperations, rowCount?: number): boolean {
    return this.cache.moveView(op, rowCount);
  }

  public moveViewTo(rowNdx: number, lastInView: boolean): boolean {
    return this.cache.moveViewTo(rowNdx, lastInView);
  }

  public isInVisibleView(ndx: number): number {
    return this.cache.isInVisibleView(ndx);
  }

  public invokeAction(op: GridOperations) {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = undefined;
    }
    if (Context.getApplication().isBusy()) return;

    let diff = 0;
    if (op === GridOperations.next) {
      if (this.rowNdx + 1 < this.data.length) diff = 1;
    } else if (op === GridOperations.prior) {
      if (this.rowNdx - 1 > 0) diff = -1;
    }

    if (diff === 0) {
      this.container.appendFunction({ Name: cJSonFunctionGridOperation, Args: [op] }, true);
    } else {
      this.cache.updatePositions(this.rowNdx + diff, this.ColNdx, true, true);
      this.timer = setTimeout(() => {
        this.vr.sendRequest(RealizerOperations.Update, this);
      }, 350);
    }
  }

  public executeCommandByNumber = (commandNumber: number) => {
    this.cache.updatePositions(this.rowNdx, this.ColNdx, false);
    this.container.appendFunction({ Name: cJSonExecuteCommandByNumber, Args: [commandNumber] });
  };
}

export class NclInnerGantt extends NclControl<CSNclInnerGanttMetadata, UpdateInnerGantt> {
  private container: NclGantt; // NclGantt<CSNclGanttMetadata,UpdateHeadered>;
  private maxRowCount: number;
  private dataItems: Highcharts.GanttPointOptionsObject[] = [];
  private seriesDataItems: Highcharts.SeriesGanttOptions[] = [];
  private categories: string[] = [];
  private yAxisOptions: Highcharts.YAxisOptions;

  constructor(
    ncl: CSNclInnerGanttMetadata,
    parent: NclControlBase,
    container: NclGantt /*<CSNclGanttMetadata,UpdateHeadered>*/,
    vr: ViewRealizer,
    vrAttachDetachFce: ViewRealizerAttachDetachControlFce
  ) {
    super(ncl, parent, vr, vrAttachDetachFce);
    this.container = container;
    this.maxRowCount = -1;
  }

  protected createDefaultState(): UpdateInnerGantt {
    return new UpdateInnerGantt({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  get MarginXFactor(): number {
    return 0;
  }

  get MarginYFactor(): number {
    return 0;
  }

  public setMaxRowCount(maxRowCount: number) {
    maxRowCount = Math.max(Math.round(maxRowCount), this.Container.Ncl.FrgtData.Size);
    if (this.maxRowCount != maxRowCount) {
      this.internalSetData({ MaxRowCount: maxRowCount } as GanttDataRequest, true);
      this.maxRowCount = maxRowCount;
    }
  }

  public contextMenu(rowIndex: number, colIndex: number) {
    this.appendFunction({ Name: cJSonFunctionContextMenu, Args: [rowIndex, colIndex] }, true);
  }

  public rowClick(clickCount: number, rowIndex: number) {
    if (this.state.Position !== rowIndex) {
      this.internalSetData(
        { Position: rowIndex } as GanttDataRequest,
        clickCount === 1,
        false,
        clickCount === 1 ? RealizerOperations.Update : RealizerOperations.None
      );
    }
    if (clickCount === 2) {
      this.container.doubleClick();
    }
  }

  get Container(): NclGantt {
    //<CSNclGanttMetadata,UpdateHeadered>{
    return this.container;
  }

  protected internalComputeMinHeight(): number {
    let result = super.internalComputeMinHeight();

    let gridLineWidth = 1;
    result = (this.VCX.GridControl.GetRowHeight(1) + gridLineWidth) * (this.container.Ncl.FrgtData.Size + 2) /*+ FixedRowCount*/;
    return result;
  }

  public defaultAccept(args?: Array<any>) {
    this.appendFunction({ Name: cJSonDefaultAcceptExecute, Args: args }, true);
  }

  public change(
    updatedData: string[][] //(value: string, accept: boolean = false)
  ) {
    //var updatedData= [ [newPointId, 'datefrom', Date.UTC(2020, 9, 3) ],
    //				   [newPointId, 'dateto', Date.UTC(2020, 9, 7)]
    //				 ];

    //if(this.state.ReadOnly||this.state.Text===value) return;
    this.internalSetData(
      {
        //Position: 1
        //MaxRowCount
        UpdatedData: updatedData,
      } as GanttDataRequest,
      true,
      false,
      RealizerOperations.Accept
    );
  }

  public set DataItems(dataItems: Highcharts.GanttPointOptionsObject[]) {
    this.dataItems = dataItems;
  }

  public get DataItems() {
    return this.dataItems;
  }

  public set SeriesDataItems(seriesDataItems: Highcharts.SeriesGanttOptions[]) {
    this.seriesDataItems = seriesDataItems;
  }

  public get SeriesDataItems() {
    return this.seriesDataItems;
  }

  public set Categories(categories: string[]) {
    this.categories = categories;
  }

  public get Categories() {
    return this.categories;
  }

  public set YAxisOptions(options: Highcharts.YAxisOptions) {
    this.yAxisOptions = options;
  }

  public get YAxisOptions() {
    return this.yAxisOptions;
  }
}

abstract class NclDataGridBase<T extends CSNclDataGridBaseMetadata, S extends UpdateDataGrid> extends NclHeaderedControl<T, S> {
  private content: NclDataGridContent;
  private footer: NclDataGridFooter;
  private aggregationPanel: NclAggregationPanel;
  private maxRowCount: number;

  constructor(ncl: T, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    this.maxRowCount = -1;

    if (ncl.Content) {
      this.content = new NclDataGridContent(ncl.Content, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.content);
    }

    if (ncl.Footer) {
      this.footer = new NclDataGridFooter(ncl.Footer, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.footer);
    }

    if (ncl.AggregationPanel) {
      this.aggregationPanel = new NclAggregationPanel(ncl.AggregationPanel, this, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.aggregationPanel);
    }
  }

  protected createDefaultState(): S {
    return new UpdateDataGrid({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() }) as S;
  }

  get AggregationPanel(): NclAggregationPanel {
    return this.aggregationPanel;
  }

  get Content(): NclDataGridContent {
    return this.content;
  }

  get Footer(): NclDataGridFooter {
    return this.footer;
  }

  get MaxRowCount(): number {
    return this.maxRowCount;
  }

  public setAsActiveControl(isActive: boolean) {
    if (this.Content && this.Content.DataGrid && this.Content.DataGrid.setAsActiveControl) {
      this.Content.DataGrid.setAsActiveControl(isActive);
    } else {
      super.setAsActiveControl(isActive);
    }
  }

  public changeSortBy(column: number, append: boolean) {
    this.appendFunction({ Name: cJSonFunctionGridChangeSortBy, Args: [column, append] }, true);
  }

  public doubleClick() {
    this.appendFunction({ Name: cJSonDataGridDblClickExecute }, true);
  }

  public refreshMaxRowCount() {
    if (this.maxRowCount <= 0) return;
    this.setMaxRowCount(this.maxRowCount);
  }

  public setMaxRowCount(maxRowCount: number) {
    maxRowCount = Math.round(maxRowCount);

    if (Context.DeviceInfo.ExplicitMaxRowCount < this.Ncl.FrgtData.Size) {
      maxRowCount = Math.max(maxRowCount, this.Ncl.FrgtData.Size);
    }

    if (this.maxRowCount != maxRowCount) {
      let explicitValue = Math.max(Context.DeviceInfo.ExplicitMaxRowCount, maxRowCount);
      this.internalSetData({ MaxRowCount: explicitValue } as InnerDataGridDataRequest, true);
      this.maxRowCount = maxRowCount;
    }
  }

  protected internalComputeMinHeight(): number {
    let result = super.internalComputeMinHeight();

    if (!this.Ncl.FrgtData.HideHeading) {
      result += this.VCX.sizeMap(21);
    }

    if (this.Content) {
      result += this.content.ComputedMinHeight;
    }

    if (this.Footer && this.showFooter()) {
      result += this.footer.ComputedMinHeight;
    }

    return result;
  }

  abstract showFooter(): boolean;
}

export class NclDataGrid extends NclDataGridBase<CSNclDataGridMetadata, UpdateDataGrid> {
  isShowHeader(): boolean {
    return super.isShowHeader() && !this.Ncl.FrgtData.HideHeader;
  }

  showFooter(): boolean {
    return !this.Ncl.FrgtData.HideFooter;
  }

  public isLite(): boolean {
    return this.Ncl.FrgtData.LiteHeader ? true : false;
  }
}

export class NclSimpleDataGrid extends NclDataGrid {
  // extends NclDataGridBase<CSNclSimpleDataGridMetadata, UpdateBaseGrid>{

  showFooter(): boolean {
    return false;
  }

  isShowHeader(): boolean {
    return false;
  }
}

export class NclViewBase<T extends CSNclViewMetadata, S extends UpdateHeadered> extends NclHeaderedControl<T, S> {
  private content: NclPanel<CSNclPanelMetadata, UFUpdateControl>;
  private setEBRequest: ViewDataRequest;
  private currentExplicitBounds: ExplicitBounds;
  private name: string;
  private _isNotificationBox: boolean;

  constructor(ncl: T, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (ncl.Content) {
      this.content = new NclPanel<CSNclPanelMetadata, UFUpdateControl>(ncl.Content, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.content);
    }
    if (vr.isForm()) this.currentExplicitBounds = ncl.FormExplicitBounds;
    else this.currentExplicitBounds = ncl.ExplicitBounds;

    if (!this.currentExplicitBounds) {
      this.currentExplicitBounds = {} as ExplicitBounds;
    }
  }

  get CurrentExplicitBounds() {
    return this.currentExplicitBounds;
  }

  public getName(): string {
    if (!this.name) {
      this.name = this.MetaData.Name; //origin name of component received from server
      let rid = this.getRectInDock();
      if (rid && rid.AnchorControlUID !== "") {
        let vr: ViewRealizer = this instanceof NclFloaterView ? this.vr : this.vr.getPriorRealizer();
        if (vr) {
          let ctrl = vr.getControlByUID(rid.AnchorControlUID);
          if (ctrl) {
            this.name = `${ctrl.MetaData.Name}.${this.MetaData.Name}`; //name of component calculate in klient for better identify component in selenium
          }
        }
      }
    }

    return this.name;
  }

  public get isNotificationBox(): boolean {
    if (this._isNotificationBox === undefined) {
      this._isNotificationBox = this.MetaData.Name === "NotificationBox";
    }
    return this._isNotificationBox;
  }

  public getAutoCloseTime(): number {
    return this.vr.getAutoCloseTime();
  }

  public getAutoCloseTimeRemaining(): number {
    return this.vr.getAutoCloseTimeRemaining();
  }

  public callAutoClose() {
    this.appendFunction({ Name: cJSonFunctionAutoClose });
    this.vr.sendRequest(RealizerOperations.None, this);
  }

  public get Content(): NclControlBase {
    return this.content;
  }

  public isLite(): boolean {
    return false;
  }

  public callAutoUpdate() {
    this.vr.callAutoUpdate(this);
  }

  get MarginXFactor(): number {
    return 0;
  }

  get MarginYFactor(): number {
    return 0;
  }

  public closeRequest() {
    this.vr.closeRequest();
  }

  public isForbiddenHotKey(hotKey: string) {
    let hk = hotKey.toUpperCase();
    if (hk === "TAB" || hk === "SHIFT+TAB") {
      return true;
    }
    return false;
  }

  isShowHeader(): boolean {
    let rect: RectInDock = this.getRectInDock();
    return super.isShowHeader() && rect && rect.FrameStyle < FrameStyle.frsNone;
  }

  public getRectInDock(): RectInDock {
    return this.vr.getRectInDock();
  }

  showView(): Promise<void> {
    if (this.Listener && (this.Listener as ViewListener).show) {
      return (this.Listener as ViewListener).show();
    } else {
      return Promise.resolve();
    }
  }

  closeView(): Promise<void> {
    if (this.Listener && (this.Listener as ViewListener).close) {
      return (this.Listener as ViewListener).close();
    } else {
      return Promise.resolve();
    }
  }

  startAutoUpdate() {
    if (this.Listener && (this.Listener as ViewListener).startAutoUpdate) {
      (this.Listener as ViewListener).startAutoUpdate();
    }
  }

  stopAutoUpdate() {
    if (this.Listener && (this.Listener as ViewListener).stopAutoUpdate) {
      (this.Listener as ViewListener).stopAutoUpdate();
    }
  }

  public clearExplicitBoundsRequest() {
    this.initDataRequest();
  }

  public moveView(x: number, y: number) {
    this.internalSetEBRequest({ Left: Math.round(x), Top: Math.round(y) } as ExplicitBounds);
  }

  public resizeView(height: number, width: number) {
    this.internalSetEBRequest({ Height: Math.round(height), Width: Math.round(width) } as ExplicitBounds);
  }

  public maximizeView(value: boolean) {
    this.internalSetEBRequest({ Maximized: value } as ExplicitBounds);
  }

  protected initDataRequest() {
    super.initDataRequest();
    this.setEBRequest = null;
  }

  private internalSetEBRequest(value: ExplicitBounds) {
    let bounds: ExplicitBounds;
    if (!this.setEBRequest) {
      this.setEBRequest = {} as ViewDataRequest;
    }

    if (this.vr.isForm()) {
      if (!this.setEBRequest.FormExplicitBounds) {
        this.setEBRequest.FormExplicitBounds = {} as ExplicitBounds;
      }
      bounds = this.setEBRequest.FormExplicitBounds;
    } else {
      if (!this.setEBRequest.ExplicitBounds) {
        this.setEBRequest.ExplicitBounds = {} as ExplicitBounds;
      }
      bounds = this.setEBRequest.ExplicitBounds;
    }

    Object.assign(this.currentExplicitBounds, value); // save new values for next open
    Object.assign(bounds, value);

    if (this.VCX.Data.Placement?.MaximizeAll === 1) {
      bounds.Maximized = false;
    }
    this.internalSetData(this.setEBRequest, false);
  }

  public getExplicitPosition(): ModalPosition {
    if (this.currentExplicitBounds && this.currentExplicitBounds.Left + this.currentExplicitBounds.Top > 0) {
      return { x: this.currentExplicitBounds.Left, y: this.currentExplicitBounds.Top };
    }
    return undefined;
  }

  public isMaximized(): boolean {
    if (this.ncl.ExplicitBounds?.Maximized || this.ncl.FormExplicitBounds?.Maximized || this.VCX.Data.Placement?.MaximizeAll == 1) {
      return true;
    }
    return false;
  }

  public getExplicitSize(): Size {
    if (this.currentExplicitBounds && this.currentExplicitBounds.Height + this.currentExplicitBounds.Width > 0) {
      return { height: this.currentExplicitBounds.Height, width: this.currentExplicitBounds.Width };
    }
    return undefined;
  }

  public defaultExplicitBounds() {
    this.currentExplicitBounds = {} as ExplicitBounds;
    this.clearExplicitBoundsRequest();
    this.appendFunction({ Name: cJSonFunctionDefaultExplicitBounds }, true);
  }

  protected computeMinHeight(withMargin: boolean): number {
    let size = super.computeMinHeight(withMargin);

    if (this.content) {
      if (withMargin) {
        size += this.content.ComputedMinHeightWithMargin;
      } else {
        size += this.content.ComputedMinHeight;
      }
    }

    size += this.VCX.Data.MarginY * 2;

    return size;
  }

  calcFullHeight = () => {
    let height = 0;
    this.vr.calcFullHeight = true;
    height = this.ComputedMinHeightWithMargin;
    this.vr.calcFullHeight = false;

    return height;
  };
}

export class NclView extends NclViewBase<CSNclViewMetadata, UpdateHeadered> {}

export class NclInplaceView extends NclViewBase<CSNclViewMetadata, UpdateHeadered> {
  protected computeMinHeight(withMargin: boolean): number {
    return this.VCX.GridControl.GetRowHeight(1);
  }

  public isForbiddenHotKey(hotKey: string) {
    let hk = hotKey.toUpperCase();
    if (hk === "TAB" || hk === "SHIFT+TAB") {
      return false;
    }
    return false;
  }

  get MarginXFactor(): number {
    return 0;
  }

  get MarginYFactor(): number {
    return 0;
  }
}

export class NclExpander extends NclHeaderedControl<CSNclExpanderMetadata, UpdateExpander> {
  private flowPanel: NclPanel<CSNclPanelMetadata, UFUpdateControl>;

  constructor(ncl: CSNclExpanderMetadata, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (ncl.Content) {
      this.flowPanel = new NclPanel<CSNclPanelMetadata, UFUpdateControl>(ncl.Content, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.flowPanel);
    }
  }

  public get Content(): NclPanel<CSNclPanelMetadata, UFUpdateControl> {
    return this.flowPanel;
  }

  public isLite(): boolean {
    return this.ncl.FrgtData.LiteHeader ? true : false;
  }

  protected createDefaultState(): UpdateExpander {
    return new UpdateExpander({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  protected computeMinHeight(withMargin: boolean): number {
    let result = withMargin ? this.Header.ComputedMinHeightWithMargin : this.Header.ComputedMinHeight;

    if (!this.state.Collapsed) {
      result += Math.max(
        this.VCX.MinRowHeight * this.Size,
        this.Content ? (!withMargin ? this.Content.ComputedMinHeight : this.Content.ComputedMinHeightWithMargin) : 0
      );

      result += this.MarginYFactor * this.VCX.Data.MarginY * 2 * 2;
    }

    result += 1; // border-bottom

    return result;
  }

  public isCollapsed(): boolean {
    return this.state.Collapsed;
  }
}

export class NclPreviewPanel extends NclContainerBase<CSNclPreviewPanelMetadata, UFUpdateControl> {
  protected createDefaultState(): UFUpdateControl {
    return new UFUpdateControl({ ControlUID: this.MetaData.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  protected computeMinHeight(withMargin: boolean): number {
    let height = super.computeMinHeight(withMargin);

    height += this.VCX.Data.TitleControl.Font.FontSize + 2 * 8; // header + padding

    height += this.VCX.Data.MarginY * 3; // 2 * gap + padding-bottom

    if (withMargin) {
      height += (this.Parts.length - 1) * this.VCX.Data.MarginY * 2;
    }

    return height;
  }
}

export enum EditCheckValueResult {
  default = 0,
  block = 1,
  newValue = 2,
}

export interface CheckResult {
  Value?: string;
  ToPosition?: number;
  Result: EditCheckValueResult;
}

export class NclInput extends UFNclControl<CSNclInputMetadata, UpdateInput> implements ClientContextMenuEmitor {
  private toolBar: NclToolBar;
  private inPlaceView: boolean;

  constructor(ncl: CSNclInputMetadata, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (ncl.ToolBar) {
      this.toolBar = new NclToolBar(ncl.ToolBar, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.toolBar);
    }
  }

  appendActionTo(menu: CSNclMenuMetadata): void {
    appendCallToPhone(this.state.Text, menu);
  }

  public isDateOrTime() {
    return this.Ncl.InputType === TNclInputType.nitDateTime || this.Ncl.InputType === TNclInputType.nitDate || this.Ncl.InputType === TNclInputType.nitTime;
  }

  public isVisibleTitle() {
    if (this.Ncl.FrgtData.ShowLabel !== 0) {
      return true;
    }

    return false;
  }

  public get ToolBar(): NclToolBar {
    return this.toolBar;
  }

  public isEmpty(): boolean {
    switch (this.ncl.InputType) {
      case TNclInputType.nitNumeric:
        return this.state.Text === "0";
      case TNclInputType.nitDateTime:
        return this.state.Text === "0000-00-00T00:00:00.000" || this.state.Text === "0000-00-00 00:00:00.000";
      case TNclInputType.nitDate:
        return this.state.Text === "0000-00-00";
      case TNclInputType.nitTime:
        return this.state.Text === "00:00:00.000";
      case TNclInputType.nitString:
        return this.state.Text === "";
    }
    return false;
  }

  public change(value: string, accept: boolean = false) {
    if (this.state.ReadOnly) return;

    if (this.state.Text === value) {
      this.initDataRequest();
      return;
    }

    if (this.state.IsUpperCase) {
      value = value.toUpperCase();
    }

    this.internalSetData({ Text: value } as InputDataRequest, accept, true, accept ? RealizerOperations.Accept : RealizerOperations.None);
  }

  public nextPriorValue(next: boolean, value: string) {
    this.appendFunction({ Name: cJSonFunctionNextPriorValue, Args: [next, value] }, true);
  }

  public accept() {
    if (this.state.ReadOnly || !this.IsPreparedDataRequest) return;
    this.vr.sendRequest(RealizerOperations.Accept, this);
  }

  protected createDefaultState(): UpdateInput {
    return new UpdateInput({ ControlUID: this.MetaData.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  protected internalComputeMinHeight(): number {
    let size: number = this.Size;
    size = this.VCX.InputControl.getInputHeight(size, this.ncl.FrgtData.ShowFrame, this.ncl.FrgtData.ShowLabel && this.isVisibleTitle());
    return size;
  }

  public contextMenu() {
    this.appendFunction({ Name: cJSonFunctionContextMenu }, true);
  }

  public checkInput(value: string, puttingValue: string, selection: InputSelectionText, replaceAll?: boolean): CheckResult {
    let result: CheckResult = { Result: EditCheckValueResult.block };
    let reg: RegExp | null = this.getInRegularExpr();
    let separator = Context.getApplication().getLocalSeparator(this.Ncl.InputType);
    let newValue: string | null = null;
    let puttingLength: number = puttingValue.length;
    let clearReg: RegExp = null;

    let postfix: string = "";
    let prefix: string = "";

    switch (this.ncl.InputType) {
      case TNclInputType.nitNumeric:
        clearReg = this.getThousandSeparatorByFormat();
        if (puttingValue.length > 1) {
          let match = puttingValue.match(/\.|,/g);
          if (match && match.length > 0 && match[0] !== separator) {
            puttingValue = puttingValue.replace(match[0], separator);
          }
        }
        if ((puttingValue === "." || puttingValue === ",") && puttingValue !== separator) {
          puttingValue = separator;
        }
        if (reg && reg.test(puttingValue)) {
          if (replaceAll === true) {
            newValue = puttingValue;
          } else {
            newValue = NclInput.createNewValue(value, puttingValue, selection, separator, clearReg, false);
          }
        }
        break;
      case TNclInputType.nitString:
        result.Result = EditCheckValueResult.default;
        return result;
      case TNclInputType.nitDateTime:
        if (!replaceAll && !reg.test(value)) {
          newValue = puttingValue;
          break;
        } else {
          if (puttingValue.length > 2 || selection.start !== selection.end) {
            newValue = value;
          } else {
            let ndx = value.indexOf(" ");
            if (ndx > 0) {
              if (selection.start < ndx) {
                postfix = ` ${value.substring(ndx + 1)}`;
                value = value.substring(0, ndx);
                separator = Context.getApplication().getLocalSeparator(TNclInputType.nitDate);
              } else {
                prefix = `${value.substring(0, ndx)} `;
                value = value.substring(ndx + 1);
                separator = Context.getApplication().getLocalSeparator(TNclInputType.nitTime);
              }
            } else {
              separator = Context.getApplication().getLocalSeparator(TNclInputType.nitDate);
            }
          }
        }
      case TNclInputType.nitDate:
      case TNclInputType.nitTime:
        if (this.Ncl.InputType !== TNclInputType.nitDateTime) {
          if (!replaceAll && !reg.test(value)) {
            replaceAll = true; //pokud hodnota inputu neodpovída regulárnímu výrazu, tak se maže a píše od začátku, jinak se přepisuje
          }
        }

        let putValue: string = puttingValue;
        let skipSeparator = false;
        if (puttingValue.length > 2 && puttingValue.indexOf(separator) < 0) {
          let vals = puttingValue.match(/.{1,2}/g);
          if (vals) {
            putValue = vals.join(separator);
          }
        } else {
          let segments: string[] = value.split(separator);
          if (segments.length > 0) {
            let pos = 0;
            for (let i = 0; i < segments.length; i++) {
              pos += 2;
              if (selection.start === pos) {
                skipSeparator = true;
                break;
              }
              pos++; //separator
              if (selection.start < pos) break;
            }
          }
        }

        puttingLength = putValue.length;

        if (replaceAll === true) {
          newValue = putValue;
        } else {
          newValue = NclInput.createNewValue(value, putValue, selection, separator, clearReg, skipSeparator);
          if (this.Ncl.InputType == TNclInputType.nitDateTime) {
            newValue = `${prefix}${newValue}${postfix}`;
          }
        }

        if (putValue !== separator) {
          let parts = newValue.split(separator);
          if (parts && parts.length < 3 && parts[parts.length - 1].length === 2) {
            newValue += separator;
            puttingLength += separator.length;
          }
        }
        break;
      default:
        console.error(`Invalid input type.`);
        break;
    }
    if (!reg || !newValue) return result;
    let checkValue = clearReg !== null ? newValue.replace(clearReg, "") : newValue; //when exist any separator, for check use raw value, but for user use newValue
    if (!checkValue || !reg.test(checkValue)) return result;

    result.Value = newValue;
    result.ToPosition = selection.start + puttingLength;
    result.Result = EditCheckValueResult.newValue;
    this.change(newValue, false); //numeric and date field must set new value to server request, string set in input component onchange event
    return result;
  }

  private static createNewValue(
    value: string,
    puttingValue: string,
    selection: InputSelectionText,
    separator: string,
    clearReg: RegExp,
    skipSeparator: boolean = true
  ): string | null {
    let newValue = value;
    if (selection.start < 0) return null;

    if (!value) return puttingValue;

    if (selection.start == selection.end) {
      let replaceChar = newValue.substr(selection.start, 1);
      if (replaceChar === puttingValue) return newValue;

      if ((separator === replaceChar && skipSeparator) || (clearReg && replaceChar.match(clearReg))) {
        selection.start += 1; //when replaced char is separators then inc selection position
        selection.end += 1;
      }
      if (separator !== replaceChar || skipSeparator) selection.end += 1;
    }
    newValue = [newValue.slice(0, selection.start), puttingValue, newValue.slice(selection.end)].join("");

    return newValue;
  }

  private getInRegularExpr(): RegExp | null {
    let separator = Context.getApplication().getLocalSeparator(this.Ncl.InputType);
    switch (this.ncl.InputType) {
      case TNclInputType.nitTime:
        return new RegExp(
          `^((([01]?\\d|2[0-3])(${separator}?([0-5]?\\d)?)${separator}([0-5]?\\d)?)|(${separator}([0-5]?\\d)?)${separator}?([0-5]?\\d)?|([01]?\\d|2[0-3]))$`
        );
      case TNclInputType.nitDate:
        return new RegExp(
          `^(((([0-3]?\\d)(\\${separator}?(0?[1-9]|1\\d)?)\\${separator}(\\d{1,4})?))|(\\${separator}(0?[1-9]|1[0-2])?)\\${separator}?(\\d{1,4})?|([0-3]?\\d))$`
        );
      case TNclInputType.nitDateTime:
        let date_separator = Context.getApplication().getLocalSeparator(TNclInputType.nitDate);
        let time_separator = Context.getApplication().getLocalSeparator(TNclInputType.nitTime);

        return new RegExp(
          `^(((([0-3]?\\d)(\\${date_separator}?(0?[1-9]|1\\d)?)\\${date_separator}(\\d{1,4})?))|(\\${date_separator}(0?[1-9]|1[0-2])?)\\${date_separator}?(\\d{1,4})?|([0-3]?\\d)) ?((([01]?\\d|2[0-3])(${time_separator}?([0-5]?\\d)?)${time_separator}([0-5]?\\d)?)|(${time_separator}([0-5]?\\d)?)${time_separator}?([0-5]?\\d)?|([01]?\\d|2[0-3]))?$`
        );
      case TNclInputType.nitNumeric:
        return new RegExp(`^-?[0-9]*\\${separator}?[0-9]${this.getDecimalsRegExpByFormat()}$`);
      default:
        break;
    }

    return null;
  }

  private getDecimalsRegExpByFormat(): string {
    let decimals = this.getDecimalsCountByFormat();
    if (decimals > 0) {
      return `{0,${decimals}}`;
    }

    return "";
  }

  // public getLocaleFormat():string{
  //     switch (this.ncl.InputType) {
  //         case TNclInputType.nitDate:
  //             return this.state.Format.replace(new RegExp('/', 'g'), this.getLocalSeparator()).toUpperCase();
  //         case TNclInputType.nitTime:
  //             return this.state.Format.replace(new RegExp('n', 'g'), 'm').replace(new RegExp(':', 'g'), this.getLocalSeparator());
  //         default:
  //             break;
  //     }
  //     return '';
  // }

  public getThousandSeparatorByFormat(): RegExp {
    let n = 1234.5;
    let str = n.toLocaleString();
    if (str.length === 6) return null;
    let sep = str.substring(1, 2);
    if (sep.charCodeAt(0) === 160 || sep.charCodeAt(0) === 32) {
      return /\s/g;
    } else return new RegExp(sep, "g");
  }

  public getDecimalsCountByFormat(): number {
    if (this.state.Format) {
      let f = this.state.Format.split(".");
      if (f.length === 2) {
        return f[1].length;
      }
    }

    return 0;
  }

  public getTimeByFormat(format: string, value: string) {
    let newValue = format;
    let timeParts = value.split(/[.:]/);
    let formatParts = newValue.split(/[.:]/);

    for (let i = 0; i < formatParts.length; i++) {
      newValue = newValue.replace(formatParts[i], timeParts[i]);
    }

    return newValue;
  }

  protected get InPlaceView(): boolean {
    if (this.inPlaceView === undefined && this.vr.getRoot()) {
      this.inPlaceView = this.vr.getRoot() instanceof NclInplaceView;
    }

    return this.inPlaceView;
  }

  get MarginXFactor(): number {
    return this.InPlaceView ? 0 : 1;
  }

  get MarginYFactor(): number {
    return this.InPlaceView ? 0 : 1;
  }
}

export abstract class NclImageBase<T extends CSNclImageMetadata, S extends UpdateImage> extends UFNclControl<T, S> {}

interface ImageItem {
  prefix: string;
  isStatic: boolean;
  extension?: string;
  folder?: string;
  isSvg?: boolean;
  withsize?: boolean;
  language?: boolean;
}

interface ImageAddressResult {
  url: string;
  altUrl?: string;
}

export const InlineSVGGlyphsPattern = "^svg\\*";

const GlyphIdParam = "glyphId=";
const RequiredSizeParam = "requiredSize=";
const sizes: number[] = [16, 24, 32, 48, 64, 256];
export class NclImage extends UFNclControl<CSNclImageMetadata, UpdateImage> {
  private static repository: Map<string, ImageItem>;
  private static dynamicGlyphsPattern: string;
  private static svgGlyphsPattern: string;
  private static allGlpyhpsWithSize: string;
  private static allGlyphsPattern: string;

  public static getRepository(): Map<string, ImageItem> {
    if (!NclImage.repository) {
      let map = new Map<string, ImageItem>();
      map.set("chr", { prefix: "chr", isStatic: true, folder: "chr", extension: ".png", isSvg: false, withsize: true });
      map.set("zoo", { prefix: "zoo", isStatic: true, folder: "zoo", extension: ".png", isSvg: false, withsize: true });
      map.set("mui", { prefix: "mui", isStatic: true, folder: "mui", extension: ".png", isSvg: false, withsize: true });
      map.set("ui", { prefix: "ui", isStatic: true, folder: "ui", extension: ".png", isSvg: false, withsize: true });

      map.set("wicon", { prefix: "wicon", isStatic: true, folder: "wicon", extension: ".svg", isSvg: true, withsize: false });
      map.set("stdbmp", { prefix: "stdbmp", isStatic: true, folder: "Standard.bmp", extension: ".bmp", isSvg: false, withsize: false });
      map.set("wui", { prefix: "wui", isStatic: true, folder: "wui", extension: ".svg", isSvg: true, withsize: false });
      map.set("flags", { prefix: "flags", isStatic: true, folder: "flags", extension: ".svg", isSvg: true, withsize: false });
      map.set("wuil", { prefix: "wuil", isStatic: true, folder: "wuil", extension: ".svg", isSvg: true, withsize: false, language: true });
      //dynamic
      map.set("svgl", { prefix: "svgl", isStatic: false, isSvg: true });
      map.set("svgch", { prefix: "svgch", isStatic: false, isSvg: true });
      map.set("k2", { prefix: "k2", isStatic: false });
      NclImage.repository = map;
    }

    return NclImage.repository;
  }

  private static getDynamicGlyphsPattern(): string {
    if (!NclImage.dynamicGlyphsPattern) {
      let str: string = "";
      this.getRepository().forEach((value) => {
        if (!value.isStatic) {
          if (str != "") {
            str += `|`;
          }
          str += `^${value.prefix}\\*`;
        }
      });
      NclImage.dynamicGlyphsPattern = str;
    }
    return NclImage.dynamicGlyphsPattern;
  }

  private static getSVGGlyphsPattern(): string {
    if (!NclImage.svgGlyphsPattern) {
      let str: string = "";
      this.getRepository().forEach((value) => {
        if (value.isSvg) {
          if (str != "") {
            str += `|`;
          }
          str += `^${value.prefix}\\*`;
        }
      });
      NclImage.svgGlyphsPattern = str;
    }
    return NclImage.svgGlyphsPattern;
  }

  private static getAllGlpyhpsWithSize(): string {
    if (!NclImage.allGlpyhpsWithSize) {
      let str: string = "";
      this.getRepository().forEach((value) => {
        if (value.withsize) {
          if (str != "") {
            str += `|`;
          }
          str += `^${value.prefix}\\*`;
        }
      });
      NclImage.allGlpyhpsWithSize = str;
    }
    return NclImage.allGlpyhpsWithSize;
  }

  private static getAllGlyphsPattern(): string {
    if (!NclImage.allGlyphsPattern) {
      let str: string = "";
      this.getRepository().forEach((value) => {
        if (str != "") {
          str += `|`;
        }
        str += `^${value.prefix}\\*`;
      });
      NclImage.allGlyphsPattern = str;
    }
    return NclImage.allGlyphsPattern;
  }

  private static isDynamicImg(value: GlyphId): boolean {
    if (value) {
      let re: RegExp = new RegExp(NclImage.getDynamicGlyphsPattern());

      if (re.exec(value)) {
        return true;
      }
    }

    return false;
  }

  public static isSVG(value: GlyphId): boolean {
    if (value) {
      let re: RegExp = new RegExp(NclImage.getSVGGlyphsPattern() + "|" + InlineSVGGlyphsPattern);

      if (re.exec(value)) {
        return true;
      }
    }

    return false;
  }

  public static isInlineSVG(value: GlyphId): boolean {
    if (value) {
      let re: RegExp = new RegExp(InlineSVGGlyphsPattern);

      if (re.exec(value)) {
        return true;
      }
    }

    return false;
  }

  private static encodeGlyphId(value: string): string {
    if (!value) return value;
    let index = value.indexOf("*");
    if (index > 1) {
      let str = value.substring(index + 1);
      return `${value.substring(0, index)}*${encodeURIComponent(str)}`;
    }

    return value;
  }

  public static getSourceUrl(value: GlyphId, requiredSize?: number, forceDynamicMethod: boolean = false): ImageAddressResult {
    if (value.includes("\\")) {
      value = value.split("\\").join("/");
    }

    let url: string;
    let altUrl: string;

    if (forceDynamicMethod || NclImage.isDynamicImg(value)) {
      url = `${Context.getApplication().getPictureServerUrl(false)}${GlyphIdParam}${NclImage.encodeGlyphId(value)}`;
      let rSize: number = NclImage.correctRequiredSize(requiredSize, value);
      if (rSize) {
        url += "&" + RequiredSizeParam + rSize;
      }
    } else {
      let rSize: number = NclImage.correctRequiredSize(requiredSize, value);
      let sizeFolder: string = rSize ? `${rSize}/` : "";
      let strs = value.split("*");
      if (strs.length > 1) {
        let item = NclImage.getRepository().get(strs[0]);
        if (item) {
          let lngFolder = item.language == true ? `${Context.getApplication().getCurrentK2LanguageImgFolder()}/` : "";
          url = `${Context.getApplication().getPictureServerUrl(true)}/${lngFolder}${item.folder}/${sizeFolder}${NclImage.encodeGlyphId(strs[1])}`;
          if (item.language === true) {
            altUrl = `${Context.getApplication().getPictureServerUrl(true)}/${DEFAULT_LANG_IMG}/${item.folder}/${sizeFolder}${NclImage.encodeGlyphId(strs[1])}`;
          }

          if (!url.endsWith(item.extension)) {
            url += item.extension;
          }
        } else {
          return NclImage.getSourceUrl(value, requiredSize, true);
        }
      } else {
        return NclImage.getSourceUrl(value, requiredSize, true);
      }
    }

    return { url: url, altUrl: altUrl };
  }

  private static correctRequiredSize(requiredSize: number, value: GlyphId): number {
    let result: number;
    if (requiredSize) {
      if (value.match(NclImage.getAllGlpyhpsWithSize())) {
        for (let index = sizes.length - 1; index >= 0; index--) {
          result = sizes[index];
          if (result <= requiredSize) {
            break;
          }
        }
      }
    }

    return result;
  }

  public static IsStaticGlyphId(value: string): boolean {
    return !NclImage.isDynamicImg(value);
  }

  public get MarginXFactor(): number {
    return 0;
  }

  public get MarginYFactor(): number {
    return 0;
  }

  protected internalComputeMinHeight(): number {
    return Math.max(this.VCX.InputControl.getInputHeight(1, true, false), this.VCX.LabelControl.getHeight(this.Size));
  }
  protected createDefaultState(): UpdateImage {
    return new UpdateImage({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }
}

export class NclFilePreview extends UFNclControl<CSNclImageMetadata, UpdateFilePreview> {
  protected createDefaultState(): UpdateFilePreview {
    return new UpdateFilePreview({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }
}

export class NclGroupBox extends NclContainerBase<CSNclGroupBoxMetaData, UFUpdateControl> {
  protected createDefaultState(): UFUpdateControl {
    return new UFUpdateControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  protected computeMinHeight(withMargin: boolean): number {
    let result = super.computeMinHeight(withMargin);
    result += this.VCX.ExpanderControl.GetHFHeight(); // Výška dle headerfontu
    result += this.VCX.Data.MarginY * 2; // Výška odsazení headeru

    if (withMargin) {
      result += (this.Parts.length - 1) * this.VCX.Data.MarginY * 2;
    }

    return result;
  }
}

export class NclSpace extends UFNclControl<CSUFNclControlMetadata, UFUpdateControl> {
  protected createDefaultState(): UFUpdateControl {
    return new UFUpdateControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  protected internalComputeMinHeight(): number {
    if (this.Ncl.FrgtData.Size === 0) return 0;

    return this.VCX.LabelControl.getHeight(this.Size);
  }
}

export class NclTabToolBar extends UFNclControl<CSNclTabToolBarMetadata, UFUpdateControl> {
  private toolBars: Array<NclToolBar>;

  constructor(ncl: CSNclTabToolBarMetadata, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (ncl.ToolBars) {
      this.toolBars = Array<NclToolBar>();
      ncl.ToolBars.map((bar) => {
        let tb = new NclToolBar(bar, this, this.vr, this.vrAttachDetachFce);
        this.toolBars.push(tb);
        this.addNestedControl(tb);
      });
    }
  }

  public get ToolBars(): Array<NclToolBar> {
    return this.toolBars;
  }

  protected createDefaultState(): UFUpdateControl {
    return new UFUpdateControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  protected internalComputeMinHeight(): number {
    return this.VCX.sizeMap(45) + this.Size * this.VCX.sizeMap(15);
    return this.VCX.InputControl.getInputHeight(this.Size * 0.7, false, true) * 1.2;
  }
}

export class NclToolBar extends NclControl<CSNclToolBarMetadata, UpdateControl> {
  private actions: Array<UFNclControlBase>;
  private menuBtn: NclCommandItem;
  private hasMainMenu: boolean;

  constructor(ncl: CSNclToolBarMetadata, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (ncl.Actions) {
      let parentName: string = "X";
      if ((parent instanceof NclInput || parent instanceof NclTabToolBar) && parent.Ncl.Name) {
        parentName = parent.Ncl.Name;
      }
      this.actions = new Array<UFNclControlBase>();
      ncl.Actions.map((action) => {
        action.Name = parentName + action.Name;
        let act = NclContainer.createControl(action, this, vr, this.vrAttachDetachFce);
        if (act) {
          this.addNestedControl(act);
          this.actions.push(act);
        }
      });
    }
    if (ncl.MenuBtn) {
      this.menuBtn = NclContainer.createControl(ncl.MenuBtn, this, vr, vrAttachDetachFce) as NclCommandItem;
      this.addNestedControl(this.menuBtn);
    }
  }

  removeAction(cmdSuffix: string) {
    let index = this.actions.findIndex((value) => {
      return value.MetaData.Name.endsWith(cmdSuffix);
    });
    if (index >= 0) {
      this.actions.splice(index, 1);
    }
  }

  public get HasMainMenu(): boolean {
    if (this.hasMainMenu === undefined) {
      if (this.menuBtn) {
        if (this.parent instanceof NclTabToolBar) {
          this.hasMainMenu = true;
        } else {
          this.hasMainMenu = false;
        }
      } else {
        this.hasMainMenu = false;
      }
    }

    return this.hasMainMenu;
  }

  public get Actions(): Array<UFNclControlBase> {
    return this.actions;
  }

  public get MenuBtn(): NclCommandItem {
    return this.menuBtn;
  }

  protected createDefaultState(): UpdateControl {
    return new UpdateControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  protected internalComputeMinHeight(): number {
    return this.VCX.InputControl.getEditHeight(1);
  }

  public get MarginXFactor(): number {
    return 0;
  }

  public get MarginYFactor(): number {
    return 0;
  }
}

export class NclActionSeparator extends UFNclControl<CSUFNclControlMetadata, UFUpdateControl> {
  constructor(ncl: CSUFNclControlMetadata, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    ncl.Bounds.Align = Align.Client; ///
    super(ncl, parent, vr, vrAttachDetachFce);
  }
  protected createDefaultState(): UFUpdateControl {
    return new UFUpdateControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  protected internalComputeMinHeight(): number {
    // let size = this.VCX.InputControl.getInputHeight(this.Size, true, false);
    // size += this.VCX.LabelControl.getHeight(1);
    return 1;
  }

  public get MarginYFactor(): number {
    return 0;
  }
}

export class NclFloaterAccessor extends NclContainerBase<CSNclFloaterAccessorMetadata, UFUpdateControl> {
  protected createDefaultState(): UFUpdateControl {
    return new UFUpdateControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  public show() {
    this.appendFunction({ Name: cJsonFunctionShowFloater }, true);
  }

  hide() {
    this.appendFunction({ Name: cJsonFunctionHideFloater }, true);
  }

  get MarginYFactor(): number {
    return 1;
  }

  get MarginXFactor(): number {
    return 1;
  }

  protected computeMinHeight(withMargin: boolean): number {
    let minHeight = 0;

    if (this.Ncl.Bounds.Align === Align.Top || this.Ncl.Bounds.Align === Align.Bottom) {
      minHeight = this.VCX.InputControl.getInputHeight(this.Size, true, false);
    } else {
      minHeight = this.VCX.LabelControl.getHeight(this.Size);
    }

    return minHeight;
  }
}

export class NclFloaterView extends NclViewBase<CSNclFloaterViewMetadata, UpdateHeadered> {
  private okCommand: NclCommandItem;

  constructor(ncl: CSNclFloaterViewMetadata, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (ncl.Header) {
      this.okCommand = new ClientNclCommandItem("", "wui*ok", this, this.okExecute, this, true, { viewRealizer: vr, attachDettachFce: vrAttachDetachFce });
      this.Header.RQuickButtons.push(this.okCommand);
    }
  }
  protected setState(newState: UpdateHeadered, canUpdate: boolean) {
    if (newState !== this.state) {
      if (this.state.Visible !== newState.Visible) {
        if (newState.Visible) {
          ViewRealizer.getNearestListener(this.vr).showModal(this.vr.getRealizerUID(), this.MetaData.ControlUID);
        } else {
          this.Content.willUnMount(true); //odpojeni ncl od komponenty, protoze pokud se pri zavirani dela animace tak behem ni se nastavi celemu conentu visible na false a okno zmizi. cast ncl je stale aktivni a viditelna cast stejne konci.
          this.closeView().then(() => {
            super.setState(newState, canUpdate); // mohu nastavit state az po zavreni, kvuli animaci
            ViewRealizer.getNearestListener(this.vr).closeModal(this.vr.getRealizerUID(), this.MetaData.ControlUID);
          });
          return;
        }
      }
    }
    super.setState(newState, canUpdate);
  }

  public closeRequest() {
    this.hide();
  }

  private okExecute(ctrl: ClientNclCommandItem) {
    this.hide();
  }

  hide() {
    if (this.parent instanceof NclFloaterAccessor) {
      this.parent.hide();
    }
  }

  public getRectInDock(): RectInDock {
    return this.Ncl.RectInDock;
  }
}

export class NclOpenDialog extends NclViewBase<CSNclOpenDialogMetadata, UpdateHeadered> {
  private ok: NclButton;
  private cancel: NclButton;

  constructor(ncl: CSNclOpenDialogMetadata, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (ncl.OKBtn) {
      this.ok = new NclButton(ncl.OKBtn, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.ok);
    }

    if (ncl.CancelBtn) {
      this.cancel = new NclButton(ncl.CancelBtn, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.cancel);
    }
  }

  public get OK(): NclButton {
    return this.ok;
  }

  public get Cancel(): NclButton {
    return this.cancel;
  }

  public acceptFiles(files: Array<CSFile>) {
    if (files && files.length > 0) {
      this.internalSetData({ Files: files } as OpenDialogDataRequest, false);
    }
  }

  protected createDefaultState(): UpdateHeadered {
    return new UpdateHeadered({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  protected computeMinHeight(withMargin: boolean): number {
    let result = super.computeMinHeight(withMargin);
    result += this.VCX.LabelControl.getHeight(12); // Výška file area
    return result;
  }
}

export abstract class NclEmptyViewDialog<T extends CSNclViewMetadata, S extends UpdateHeadered> extends NclViewBase<T, S> {
  protected abstract internalAfterViewUpdated(): any;

  afterViewUpdated() {
    this.internalAfterViewUpdated();
  }
}

export class NclSilentOpenDialog extends NclViewBase<CSNclOpenDialogMetadata, UpdateHeadered> {
  private contnet: NclSilentOpenDialogContent;

  constructor(ncl: CSNclOpenDialogMetadata, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (ncl.Content) {
      this.contnet = new NclSilentOpenDialogContent(ncl.Content as CSNclPanelMetadata, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.contnet);
    }
  }

  public get Content(): NclControlBase {
    return this.contnet;
  }

  isShowHeader(): boolean {
    return false;
  }
}

export class NclSilentOpenDialogContent extends NclPanel<CSNclPanelMetadata, UpdateOpenDialogContent> {
  private repeatBtn: ClientNclButton;
  private closeBtn: ClientNclButton;

  constructor(ncl: CSNclPanelMetadata, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    this.repeatBtn = new ClientNclButton("", "wui*node.open", this, undefined, this, true, { viewRealizer: vr, attachDettachFce: vrAttachDetachFce });
    this.closeBtn = new ClientNclButton("", "wui*close", this, this.handleClose, this, true, { viewRealizer: vr, attachDettachFce: vrAttachDetachFce });
  }

  protected createDefaultState(): UpdateOpenDialogContent {
    return new UpdateOpenDialogContent({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  public get RepeatBtn(): ClientNclButton {
    return this.repeatBtn;
  }

  public get CloseBtn(): NclControlBase {
    return this.closeBtn;
  }

  private handleClose = (ctrl: ClientNclButton) => {
    if (!ctrl) return;
    let __this = ctrl.Parent as NclSilentOpenDialogContent;
    if (__this) {
      __this.appendFunction({ Name: cJSonFunctionCloseView }, true);
    }
  };
  public beginUpload(expectedFilesCount: number) {
    this.appendFunction({ Name: cJSonFunctionODBeginUploadFile, Args: [expectedFilesCount] }, true);
  }

  public endUpload() {
    this.appendFunction({ Name: cJSonFunctionODEndUploadFile, Args: undefined }, true);
  }

  public cancelUpload() {
    this.appendFunction({ Name: cJSonFunctionODCancelUploadFile, Args: undefined }, true);
  }

  public uploadfile(file: CSFile) {
    if (!file) return;
    this.internalSetData({ File: file } as SilentOpenDialogDataRequest, true);
  }
}

export class NclDeviceConnectorDialog extends NclEmptyViewDialog<CSNclDeviceConnectorDialogMetadata, UpdateHeadered> {
  private result(result: DeviceConnectorDataRequest) {
    this.internalSetData(result, true);
  }

  protected internalAfterViewUpdated() {
    if (this.state.Visible === true) {
      Context.getApplication().BusyIndicator.setBusyIndicator(true, "Prosím čekejte...", `Komunikace s device connectorem.`, "wait", true);
      if (!Context.DeviceConnector.isConnected) {
        if (!this.Ncl.DeviceData.RequestMessage && !this.Ncl.DeviceData.DisconnectRequest) {
          Context.DeviceConnector.connect(this.Ncl.DeviceData.ConnectionString)
            .then((value) => {
              this.result(value);
              Context.getApplication().BusyIndicator.setBusyIndicator(false);
            })
            .catch((reason) => {
              this.result({ ResultType: TDeviceConnectResult.dcrError, ResultMessage: reason } as DeviceConnectorDataRequest);
              Context.getApplication().BusyIndicator.setBusyIndicator(false);
            });
        } else {
          this.result({
            ResultType: TDeviceConnectResult.dcrError,
            ResultMessage: "Device connector is not connected.",
          } as DeviceConnectorDataRequest);
        }
      } else {
        if (this.Ncl.DeviceData.DisconnectRequest == true) {
          Context.DeviceConnector.disconnect()
            .then((value) => {
              this.result(value);
              Context.getApplication().BusyIndicator.setBusyIndicator(false);
            })
            .catch((reason) => {
              this.result({ ResultType: TDeviceConnectResult.dcrError, ResultMessage: reason } as DeviceConnectorDataRequest);
              Context.getApplication().BusyIndicator.setBusyIndicator(false);
            });
        } else if (this.Ncl.DeviceData.RequestMessage) {
          Context.DeviceConnector.sendRequest(this.Ncl.DeviceData.RequestMessage)
            .then((value) => {
              this.result(value);
              Context.getApplication().BusyIndicator.setBusyIndicator(false);
            })
            .catch((reason) => {
              this.result({ ResultType: TDeviceConnectResult.dcrError, ResultMessage: reason } as DeviceConnectorDataRequest);
              Context.getApplication().BusyIndicator.setBusyIndicator(false);
            });
        }
      }
    }
  }
}

export class NclGPSDialog extends NclEmptyViewDialog<CSNclGPSDialogMetadata, UpdateHeadered> {
  protected internalAfterViewUpdated() {
    if (navigator.geolocation) {
      let gpsReader: GPSReader = Context.getApplication().getGPSReader();
      switch (this.Ncl.FrgtData.Request) {
        case TGPSRequest.gpsrStart:
          try {
            gpsReader.startWatchCurrentPosition(this.ncl.FrgtData.Accuracy);
            this.callCommand(cmdOKView);
          } catch (er) {
            this.sendResult({ GPSErrMsg: er.message } as GPSDataRequest);
          }
          break;
        case TGPSRequest.gpsrCheck:
          if (gpsReader.isWatching()) {
            gpsReader.acquireActualPosition(this.sendResult.bind(this), this.ncl.FrgtData.Accuracy);
          } else {
            this.sendResult({ GPSErrMsg: `Functionality for watching position isn't turn on.` } as GPSDataRequest);
          }
          break;
        case TGPSRequest.gpsrStop:
          if (gpsReader.isWatching()) {
            try {
              gpsReader.stopWatchCurrentPosition();
              this.callCommand(cmdOKView);
            } catch (er) {
              this.sendResult({ GPSErrMsg: er.message } as GPSDataRequest);
            }
            this.sendResult({ GPSErrMsg: undefined } as GPSDataRequest);
          } else {
            this.sendResult({ GPSErrMsg: `Functionality for watching position isn't turn on.` } as GPSDataRequest);
          }
          break;
        default:
          this.sendResult({ GPSErrMsg: `Unknown gps request. (${this.ncl.FrgtData.Request})` } as GPSDataRequest);
          break;
      }
    } else {
      this.sendResult({ GPSErrMsg: "Geolocation is not supported by this browser." } as GPSDataRequest);
    }
  }

  private sendResult(request: GPSDataRequest) {
    this.internalSetData(request, true);
  }
}

export class NclVirtualKeyboardDialog extends NclViewBase<CSNclVirtualKeyboardDialogMetadata, UpdateVirtualKeyboard> {
  private keyControls: Map<string, UFNclControlBase>;
  private input: ClientNclInput;

  public static NUM_CLEAR = "num-clear";
  public static NUM_CLEAR_ALL = "num-clear-all";
  public static OK = "OK";
  public static CANCEL = "CANCEL";
  public static INPUT = "INPUT";
  public static NUM = "num";
  public static UPPER_CASE = "upper-case";
  public static LOWER_CASE = "lower-case";
  public static ALPHABET = "alphabet";

  constructor(ncl: CSNclVirtualKeyboardDialogMetadata, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    this.generateNclControls();
  }

  protected createDefaultState(): UpdateVirtualKeyboard {
    return new UpdateVirtualKeyboard({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  private generateNclControls() {
    this.keyControls = new Map<string, UFNclControlBase>();

    this.input = new ClientNclInput(this.ncl.FrgtData.MainMessage, ``, this, true, { attachDettachFce: this.vrAttachDetachFce, viewRealizer: this.vr }, 200);

    this.keyControls.set(NclVirtualKeyboardDialog.INPUT, this.input);

    //numeric
    for (let i = 0; i < 10; i++) {
      //this.appendKeyBtn(i.toString(), `wui*number.${i.toString()}`, this.handleKeyExecute);
      this.appendKeyBtn(i.toString(), `svgch*${i.toString()}`, this.handleKeyExecute);
    }

    this.appendKeyBtn(",", `wui*number.decimalpoint`, (ctrl) => {
      let __this = ctrl.Parent as NclVirtualKeyboardDialog;
      if (__this && __this.input) {
        let txt = __this.input.Text;
        if (this.Ncl.FrgtData.IsNumeric) {
          if (txt == "") this.input.pressKey(`0` + (ctrl.State as CSUpdateCommandItem).Title);
          if (txt.indexOf(",") < 0) {
            this.input.pressKey((ctrl.State as CSUpdateCommandItem).Title);
          }
        } else {
          this.input.pressKey((ctrl.State as CSUpdateCommandItem).Title);
        }
      }
    });

    this.appendKeyBtn(NclVirtualKeyboardDialog.NUM_CLEAR, `wui*number.clear`, (ctrl) => {
      let __this = ctrl.Parent as NclVirtualKeyboardDialog;
      if (__this && __this.input) {
        __this.input.pressKey("");
      }
    });

    this.appendKeyBtn(NclVirtualKeyboardDialog.NUM_CLEAR_ALL, `wui*number.clear.all`, (ctrl) => {
      let __this = ctrl.Parent as NclVirtualKeyboardDialog;
      if (__this && __this.input && __this.input.Listener) {
        if (!(__this.input.Listener as InputListener).setText) {
          this.updateState({ Text: "" } as UpdateInput);
        } else {
          (__this.input.Listener as InputListener).setText("", 0);
        }
      }
    });

    if (this.Ncl.FrgtData.IsNumeric !== 1) {
      //qwerty
      let alphabet = "abcdefghijklmnopqrstuvwxyz";
      for (let i = 0; i < alphabet.length; i++) {
        this.appendKeyBtn(alphabet[i], `wui*letter.${alphabet[i]}2`, this.handleKeyExecute);
      }

      alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      for (let i = 0; i < alphabet.length; i++) {
        this.appendKeyBtn(alphabet[i], `wui*letter.${alphabet[i]}`, this.handleKeyExecute);
      }

      this.appendKeyBtn(NclVirtualKeyboardDialog.NUM, `wui*numbers_key`, (ctrl) => {
        this.setAlphabetMode(AlphabetMode.numeric);
      });

      this.appendKeyBtn(NclVirtualKeyboardDialog.ALPHABET, `wui*letters_key`, (ctrl) => {
        this.setAlphabetMode(AlphabetMode.unknown);
      });

      this.appendKeyBtn(NclVirtualKeyboardDialog.UPPER_CASE, `wui*caps_lock`, (ctrl) => {
        this.setAlphabetMode(AlphabetMode.upperCase);
      });

      this.appendKeyBtn(NclVirtualKeyboardDialog.LOWER_CASE, `wui*caps_lock_off`, (ctrl) => {
        this.setAlphabetMode(AlphabetMode.unknown);
      });

      this.appendKeyBtn("=", `svgch*=`, this.handleKeyExecute);
      this.appendKeyBtn(" ", ``, this.handleKeyExecute);
      this.appendKeyBtn("/", `svgch*/`, this.handleKeyExecute);
      this.appendKeyBtn("?", `svgch*?`, this.handleKeyExecute);
      this.appendKeyBtn("!", `svgch*!`, this.handleKeyExecute);
      this.appendKeyBtn("@", "svgch*@", this.handleKeyExecute);
      this.appendKeyBtn("#", "svgch*#", this.handleKeyExecute);
      this.appendKeyBtn("$", "svgch*$", this.handleKeyExecute);
      this.appendKeyBtn("%", "svgch*%", this.handleKeyExecute);
      this.appendKeyBtn("&", "svgch*&", this.handleKeyExecute);
      this.appendKeyBtn("-", "svgch*-", this.handleKeyExecute);
      this.appendKeyBtn("+", "svgch*+", this.handleKeyExecute);
      this.appendKeyBtn("(", "svgch*(", this.handleKeyExecute);
      this.appendKeyBtn(")", "svgch*)", this.handleKeyExecute);
      this.appendKeyBtn("*", "svgch**", this.handleKeyExecute);
      this.appendKeyBtn(`"`, `svgch*"`, this.handleKeyExecute);
      this.appendKeyBtn("'", "svgch*'", this.handleKeyExecute);
      this.appendKeyBtn(":", "svgch*:", this.handleKeyExecute);
      this.appendKeyBtn(";", "svgch*;", this.handleKeyExecute);
      this.appendKeyBtn(".", "svgch*.", this.handleKeyExecute);
      this.appendKeyBtn("_", "svgch*_", this.handleKeyExecute);
    }

    this.appendKeyBtn(NclVirtualKeyboardDialog.OK, `wui*OK`, (ctrl) => {
      let vr = ViewRealizerManager.getViewRealizer(ctrl.getRealizerUID());
      if (vr) {
        let __this = vr.getRoot() as NclVirtualKeyboardDialog;
        if (__this) {
          __this.internalSetData({ InputText: __this.input.Text } as VirtualKeyboardRequest, false);
          __this.callCommand(cmdOKView);
        }
      }
    });

    this.appendKeyBtn(NclVirtualKeyboardDialog.CANCEL, `wui*close`, (ctrl) => {
      let vr = ViewRealizerManager.getViewRealizer(ctrl.getRealizerUID());
      if (vr) vr.closeRequest();
    });
  }

  protected internalSetVCX(vcx: VisualContext, forceRefresh: boolean) {
    super.internalSetVCX(vcx, forceRefresh);
    if (this.keyControls) {
      this.keyControls.forEach((value) => {
        value?.setVCX(vcx, forceRefresh);
      });
    }
  }

  private handleKeyExecute = (ctrl: ClientNclButton) => {
    let __this = ctrl.Parent as NclVirtualKeyboardDialog;
    if (__this && __this.input) {
      this.input.pressKey((ctrl.State as CSUpdateCommandItem).Title);
    }
  };

  private appendKeyBtn(key: string, glyphId: GlyphId, executor: ClientExecuteFce<ClientNclButton>) {
    if (this.keyControls.has(key)) return;
    this.keyControls.set(
      key,
      new ClientNclButton(key, glyphId, this, executor, this, true, { attachDettachFce: this.vrAttachDetachFce, viewRealizer: this.vr })
    );
  }

  private setAlphabetMode(value: AlphabetMode) {
    this.updateState({ Mode: value } as CSUpdateVirtualKeyboard);
  }

  public getAlphabetMode(): AlphabetMode {
    return this.state.Mode;
  }

  public getKeyControlByValue(value: string) {
    return this.keyControls.get(value);
  }

  protected afterSetState(canUpdate: boolean, oldState: UpdateVirtualKeyboard) {
    if (this.input && this.state.OldValue !== (this.input.State as UpdateInput).SuffixText) {
      this.input.updateState({ SuffixText: this.state.OldValue } as CSUpdateInput);
    }

    super.afterSetState(canUpdate, oldState);
  }
}

export class NclCodeReaderDialog extends NclViewBase<CSNclCodeReaderDialogMetadata, UpdateHeadered> {
  private result: string;
  private ok: ClientNclButton;
  private cancel: ClientNclButton;

  constructor(ncl: CSNclCodeReaderDialogMetadata, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    this.generateNclControls();
  }

  public get OK(): ClientNclButton {
    return this.ok;
  }

  public get CANCEL(): ClientNclButton {
    return this.cancel;
  }

  public setResult(code: string) {
    if (code && code !== this.result) {
      this.result = code;

      if (this.ncl.FrgtData.ImmediatelyAccept) {
        this.acceptAndClose(code);
        return;
      }
      this.ok.updateState({ Enabled: true } as CSUpdateControl);
    }
  }

  private acceptAndClose(value: string) {
    this.internalSetData({ Result: value } as CodeReaderRequest, false);
    this.callCommand(cmdOKView);
  }

  private generateNclControls() {
    this.ok = new ClientNclButton(
      NclVirtualKeyboardDialog.OK,
      "wui*OK",
      this,
      (ctrl) => {
        let vr = ViewRealizerManager.getViewRealizer(ctrl.getRealizerUID());
        if (vr) {
          let __this = vr.getRoot() as NclCodeReaderDialog;
          if (__this) {
            __this.acceptAndClose(__this.result);
          }
        }
      },
      this,
      false,
      { attachDettachFce: this.vrAttachDetachFce, viewRealizer: this.vr }
    );

    this.addNestedControl(this.ok);

    this.cancel = new ClientNclButton(
      NclVirtualKeyboardDialog.CANCEL,
      `wui*close`,
      this,
      (ctrl) => {
        let vr = ViewRealizerManager.getViewRealizer(ctrl.getRealizerUID());
        if (vr) vr.closeRequest();
      },
      this,
      true,
      { attachDettachFce: this.vrAttachDetachFce, viewRealizer: this.vr }
    );
    this.addNestedControl(this.cancel);
  }

  protected createDefaultState(): UpdateHeadered {
    return new UpdateHeadered({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }
}

export class NclWebView extends UFNclControl<CSNclWebViewMetadata, UpdateImage> {
  protected createDefaultState(): UpdateImage {
    return new UpdateImage({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }
}

export class NclFormattableInput extends UFNclControl<CSNclFormattableInputMetadata, UpdateFormattableInput> {
  protected createDefaultState(): UpdateFormattableInput {
    return new UpdateFormattableInput({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  protected internalInEditMode(): boolean {
    return !this.state.ReadOnly;
  }

  public change(value: string, accept: boolean = false) {
    if (this.state.ReadOnly) return;

    if (this.state.Text === value) {
      this.initDataRequest();
      return;
    }

    this.internalSetData({ Text: value } as InputDataRequest, accept, true, accept ? RealizerOperations.Accept : RealizerOperations.None);
  }

  public isVisibleTitle() {
    if (this.Ncl.FrgtData.ShowLabel !== 0) {
      return true;
    }

    return false;
  }

  protected internalComputeMinHeight(): number {
    let size: number = this.Size;
    size = this.VCX.InputControl.getInputHeight(size, this.ncl.FrgtData.ShowFrame, this.ncl.FrgtData.ShowLabel && this.isVisibleTitle());
    return size;
  }

  // TODO if defHtml tak projít kontrolou a očistit od HTML kódu
}

export class NclDynamicContent extends NclContainerBase<CSNclDynamicContentMetadata, UpdateDynamicContent> {
  private children: List<UFNclControlBase>;
  private parts: Array<Array<UFNclControlBase>>;

  public updateState(data: CSUpdateControl) {
    let oldContent: UFNclControlBase[] = null;
    let newStructure: CSUFNclControlMetadata = null;
    if ((data as CSUpdateDynamicContent).Structure) {
      oldContent = this.Children.toArray();
      this.children = this.Children.clear();
      newStructure = (data as CSUpdateDynamicContent).Structure;
      (data as CSUpdateDynamicContent).Structure = null;
      (data as CSUpdateDynamicContent).DynamicContentId = newStructure.ControlUID;
    }
    super.updateState(data);

    if (oldContent) {
      oldContent.forEach((control) => {
        control.willUnMount(false);
      });
    }
    if (newStructure) {
      this.children = this.children.push(NclContainer.createControl(newStructure, this, this.vr, this.vrAttachDetachFce));
      this.parts = NclContainerBase.splitToParts(this.children);
      (data as CSUpdateDynamicContent).DynamicContentId = "";
      this.updateState(data);
    }
  }

  protected getChildren(): List<UFNclControlBase> {
    if (this.children == null) {
      this.children = super.getChildren();
    }
    return this.children;
  }

  protected getParts(): Array<Array<UFNclControlBase>> {
    if (this.parts == null) {
      this.parts = super.getParts();
    }

    return this.parts;
  }

  protected createDefaultState(): UpdateDynamicContent {
    return new UpdateDynamicContent({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }
}

export class NclQuickFilter extends NclControl<CSNclQuickFilterMetadata, UpdateQuickFilter> {
  private filters: Array<UFNclControlBase>;
  private container: NclInnerDataGrid;

  constructor(
    ncl: CSNclQuickFilterMetadata,
    parent: NclControlBase,
    container: NclInnerDataGrid,
    vr: ViewRealizer,
    vrAttachDetachFce: ViewRealizerAttachDetachControlFce
  ) {
    super(ncl, parent, vr, vrAttachDetachFce);
    this.container = container;
  }

  public updateState(data: CSUpdateControl) {
    if ((data as CSUpdateQuickFilter).Controls) {
      if (this.filters) {
        this.filters.forEach((control) => {
          this.removeNestedControl(control);
        });

        this.filters = null;
        this.setState(this.state.with({ Controls: null } as CSUpdateQuickFilter), true); // update for recreate all components
      }

      this.filters = [];
      let control: UFNclControlBase;
      (data as CSUpdateQuickFilter).Controls.map((ctrl) => {
        control = NclContainer.createControl(ctrl, this, this.vr, this.vrAttachDetachFce);
        this.filters.push(control);
        this.addNestedControl(control);
      });
    }
    super.updateState(data);
    if (this.container && this.container.Container && data.Visible !== undefined) {
      this.container.Container.refreshMaxRowCount();
    }
  }

  public get Filters(): Array<UFNclControlBase> {
    return this.filters;
  }

  protected createDefaultState(): UpdateQuickFilter {
    return new UpdateQuickFilter({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }
}

/* Client NCL parts */

type ClientExecuteFce<T> = (ctrl: T) => any;

export class ClientNclCommandItem extends NclCommandItem {
  private executeFce: ClientExecuteFce<ClientNclCommandItem> = null;
  private executor: any;

  constructor(
    caption: string,
    glyphId: GlyphId,
    executor: any,
    executeFce: ClientExecuteFce<ClientNclCommandItem>,
    parent: NclControlBase,
    enabled: boolean,
    context: VRContext
  ) {
    super(
      {
        FrgtData: {
          Icon: "",
          Decorate: DataActionDecorate.dadeBase,
          FillWidth: 1,
          HorizontalAlignment: HorizontalAlignment.fhaLeft,
          IconPosition: IconPosition.ipLeft,
          ShowCaption: 0,
          ShowIcon: 1,
          DisplayStyle: TUFActionDisplayStyle.ufadsButtonTile,
          Size: 1,
          BandsCount: 1,
          TabStop: 0,
          VerticalAlignment: VerticalAlignment.fvaCenter,
          ZoomFactor: 100,
          __type: ControlType.CommandAction,
        } as FrgtCommandItemData,
        Bounds: { Align: Align.Client, FromBandIndex: 0, PartIndex: 0, BandsCount: 0, InteriorBandsCount: 0 },
        ControlUID: parent.MetaData.ControlUID + "" + Math.random(),
      } as CSNclCommandItemMetadata,
      parent,
      context.viewRealizer,
      context.attachDettachFce
    );
    this.updateState({ Visible: true, Title: caption, Enabled: enabled, GlyphId: glyphId } as CSUpdateCommandItem);
    this.executeFce = executeFce;
    this.executor = executor;
  }

  executeCommand() {
    if (this.executeFce && this.state.Enabled !== false) {
      this.executeFce.call(this.executor, this);
    }
  }
}

export class ClientNclButton extends NclButton {
  private executeFce: ClientExecuteFce<ClientNclButton> = null;
  private executor: any;

  constructor(
    caption: string,
    glyphId: GlyphId,
    executor: any,
    executeFce: ClientExecuteFce<ClientNclButton>,
    parent: NclControlBase,
    enabled: boolean,
    context: VRContext
  ) {
    super(
      {
        FrgtData: {
          Icon: "",
          Decorate: DataActionDecorate.dadeDecorate,
          FillWidth: 1,
          HorizontalAlignment: HorizontalAlignment.fhaLeft,
          IconPosition: IconPosition.ipLeft,
          ShowCaption: 0,
          ShowIcon: 1,
          DisplayStyle: TUFActionDisplayStyle.ufadsButtonTile,
          Size: 1,
          BandsCount: 1,
          TabStop: 0,
          VerticalAlignment: VerticalAlignment.fvaCenter,
          ZoomFactor: 100,
          __type: ControlType.Button,
        } as FrgtButtonData,
        Bounds: { Align: Align.Client, FromBandIndex: 0, PartIndex: 0, BandsCount: 0, InteriorBandsCount: 0 },
        ControlUID: parent.MetaData.ControlUID + "" + Math.random(),
      } as CSNclButtonMetadata,
      parent,
      context.viewRealizer,
      context.attachDettachFce
    );
    this.updateState({ Visible: true, Title: caption, Enabled: enabled, GlyphId: glyphId } as CSUpdateCommandItem);
    this.executeFce = executeFce;
    this.executor = executor;
  }

  public setExecuteFce(fce: ClientExecuteFce<ClientNclButton>) {
    if (!this.executeFce) this.executeFce = fce;
  }

  executeCommand() {
    if (this.executeFce && this.state.Enabled !== false) {
      this.executeFce.call(this.executor, this);
    }
  }
}

export class ClientNclInput extends NclInput {
  constructor(caption: string, glyphId: GlyphId, parent: NclControlBase, enabled: boolean, context: VRContext, zoomFactor: number = 100) {
    super(
      {
        InputType: TNclInputType.nitString,
        FrgtData: {
          Icon: "",
          Size: 1,
          HorizontalAlignment: HorizontalAlignment.fhaLeft,
          VerticalAlignment: VerticalAlignment.fvaCenter,
          ZoomFactor: zoomFactor,
          BandsCount: 1,
          Watermark: "",
          TabStop: 1,
          ShowLabel: 1,
          ShowFrame: 1,
          DisableLabelHighlight: 0,
          IsPassword: 0,
          BackgroundColorEditMode: { ColorType: 0, CustomColor: clNone, AsString: "", __type: "" },
          BackgroundColorReadMode: { ColorType: 0, CustomColor: clNone, AsString: "", __type: "" },
          BackgroundColorDisabledMode: { ColorType: 0, CustomColor: clNone, AsString: "", __type: "" },
          __type: ControlType.Input,
        } as FrgtInputData,
        Bounds: { Align: Align.Top, FromBandIndex: 0, PartIndex: 0, BandsCount: 0, InteriorBandsCount: 0 },
        ControlUID: parent.MetaData.ControlUID + "" + Math.random(),
        SuffixDisplayAs: TUFDisplayValueAs.dvaText,
        PrefixDisplayAs: TUFDisplayValueAs.dvaText,
      } as CSNclInputMetadata,
      parent,
      context.viewRealizer,
      context.attachDettachFce
    );
    this.updateState({ Visible: true, Title: caption, Enabled: enabled, GlyphId: glyphId } as CSUpdateCommandItem);
  }

  public get Text(): string {
    return this.state.Text ? this.state.Text : "";
  }

  public set Text(value: string) {
    if (this.Text !== value) {
      this.updateState({ Text: value } as UpdateInput);
    }
  }

  public pressKey(key: string) {
    let isBackspace: boolean = !key || key === "";
    let oldValue: string = this.state.Text;
    let newValue: string = key;
    let newPosition: number = key.length;
    if (oldValue && oldValue.length > 0 && (this.Listener as InputListener).getSelectionStart && (this.Listener as InputListener).getSelectionEnd) {
      let start = (this.Listener as InputListener).getSelectionStart();
      let end = (this.Listener as InputListener).getSelectionEnd();
      if (start >= 0 && end >= 0) {
        if (start === end) {
          if (start === 0) {
            if (isBackspace) return;
            newValue = `${key}${oldValue}`;
            newPosition = key.length;
          } else if (start === oldValue.length) {
            if (isBackspace) {
              newValue = oldValue.substring(0, oldValue.length - 1);
            } else {
              newValue = `${oldValue}${key}`;
            }
            newPosition = newValue.length;
          } else {
            if (isBackspace) {
              newValue = oldValue.substring(0, start - 1) + oldValue.substring(start);
              newPosition = start - 1;
            } else {
              newValue = oldValue.substring(0, start) + key + oldValue.substring(start);
              newPosition = start + key.length;
            }
          }
        } else if (end > start) {
          newValue = oldValue.substring(0, start) + key + oldValue.substring(end);
          newPosition = start + key.length;
        }
      }
    }

    if (this.Text !== newValue) {
      if (!(this.Listener as InputListener).setText) {
        this.updateState({ Text: newValue } as UpdateInput);
      } else {
        (this.Listener as InputListener).setText(newValue, newPosition);
      }
    }
  }
}

export class NclMenuView extends NclViewBase<CSNclMenuViewMetadata, UpdateHeadered> {
  private menu: NclMenu;

  constructor(ncl: CSNclMenuViewMetadata, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (ncl.Menu) {
      this.menu = new NclMenu(ncl.Menu, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.menu);
    }
  }

  public get Content(): NclControlBase {
    return this.menu;
  }

  internalComputeMinHeight(): number {
    let h = super.internalComputeMinHeight();
    if (this.menu) {
      h += this.menu.internalComputeMinHeight();
    }
    return h;
  }

  isShowHeader(): boolean {
    return super.isShowHeader() && Context.DeviceInfo.StyleOfModalWindowShow === TBehaviorTypeByDevice.btbdMobile;
  }

  public isOnlyActionsInFirstLevel(maxCount: number): boolean {
    let result: boolean = true;
    if (this.menu.Actions.count() > maxCount) return false;
    this.menu.Actions.map((item) => {
      if (item instanceof NclMenuContainer) {
        result = false;
        return;
      }
    });

    return result;
  }
}

export abstract class NclMenuItemBase<T extends CSNclMenuItemBaseMetadata, S extends UpdateControl> extends NclControl<T, S> {
  static createByNcl(
    ncl: CSNclMenuItemBaseMetadata,
    parent: NclMenuContainer<CSNclMenuContainerMetadata, UpdateMenuContainer>,
    vr: ViewRealizer,
    vrAttachDetachFce: ViewRealizerAttachDetachControlFce
  ): NclMenuItemBase<CSNclMenuItemBaseMetadata, UpdateControl> {
    switch (ncl.__type) {
      case ControlType.Menu:
        return new NclMenu(ncl as CSNclMenuMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.MenuItem:
        return new NclMenuItem(ncl as CSNclMenuItemMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.ClientMenuItem:
        return new NclClientMenuItem(ncl as CSNclMenuItemMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.MenuDivider:
        return new NclMenuDivider(ncl as CSNclMenuMetadata, parent, vr, vrAttachDetachFce);
      case ControlType.MenuGroup:
        return new NclMenuGroup(ncl as CSNclMenuGroupMetadata, parent, vr, vrAttachDetachFce);
    }
    throw new Error("Invalid type of menu control: " + ncl.__type);
  }

  internalComputeMinHeight(): number {
    return this.VCX.LabelControl.getHeight(2);
  }

  public abstract execute(): void;

  get MarginXFactor(): number {
    return 1 / 3;
  }

  get MarginYFactor(): number {
    return 1 / 3;
  }
}

export abstract class NclMenuContainer<T extends CSNclMenuContainerMetadata, S extends UpdateMenuContainer> extends NclMenuItemBase<T, S> {
  private actions: List<NclMenuItemBase<CSNclMenuItemBaseMetadata, UpdateControl>>;

  constructor(ncl: T, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (ncl.Actions) {
      let list = new Array<NclMenuItemBase<CSNclMenuItemBaseMetadata, UpdateControl>>();
      let act: NclMenuItemBase<CSNclMenuItemBaseMetadata, UpdateControl>;
      ncl.Actions.forEach((item) => {
        act = NclMenuItemBase.createByNcl(item, this, vr, vrAttachDetachFce);
        list.push(act);
        this.addNestedControl(act);
      });

      this.actions = List<NclMenuItemBase<CSNclMenuItemBaseMetadata, UpdateControl>>(list);
    }
  }

  public get Actions(): List<NclMenuItemBase<CSNclMenuItemBaseMetadata, UpdateControl>> {
    return this.actions;
  }

  public execute(forceClose?: boolean, forceOpen?: boolean, closeOthers?: boolean) {
    if (this.Parent instanceof NclMenuContainer) {
      if (closeOthers) {
        this.Parent.Actions.forEach((element) => {
          if (element instanceof NclMenuContainer && element !== this) {
            if ((element.State as UpdateMenuContainer).isOpen) {
              element.updateState({ isOpen: false } as UpdateMenuContainer);
              this.closeAllSubMenuContainer(element);
            }
          } else if (element instanceof NclMenuContainer && element === this && (element.State as UpdateMenuContainer).isOpen) {
            this.closeAllSubMenuContainer(element);
          }
        });
      }
      if (forceClose) {
        this.updateState({ isOpen: false } as UpdateMenuContainer);
      } else if (forceOpen) {
        this.updateState({ isOpen: true } as UpdateMenuContainer);
      } else {
        this.updateState({ isOpen: !(this.State as UpdateMenuContainer).isOpen } as UpdateMenuContainer);
      }
    }
  }

  private closeAllSubMenuContainer(element: NclMenuItemBase<CSNclMenuItemBaseMetadata, UpdateControl>) {
    if (element instanceof NclMenuContainer) {
      element.actions.forEach((subElement) => {
        if ((subElement.State as UpdateMenuContainer).isOpen) {
          subElement.updateState({ isOpen: false } as UpdateMenuContainer);
          this.closeAllSubMenuContainer(subElement);
        }
      });
    }
  }

  public getMenuWidth(): number {
    const widestMenuItem = this.getMaxCharCaption();
    const caption = this.VCX.GridControl.Font.computeTextWidth(widestMenuItem?.caption);
    const iconSpace: number = this.VCX.GridControl.Font._MWidth * 2;
    const hotkey = this.VCX.GridControl.Font.computeTextWidth(widestMenuItem?.hotkey) + 10; // zohledneni marginu

    return caption + iconSpace + (widestMenuItem?.hasHotkey ? hotkey : 0) + (widestMenuItem?.expand ? 20 : 0) + 20;
  }

  public getMenuHeight(): number {
    let result: number = 0;
    this.Actions.forEach((action) => {
      if (action instanceof NclMenuDivider) {
        result += 2 * action.VCX.sizeMap(3);
      } else {
        result += action.ComputedMinHeightWithMargin;
      }
    });

    return result;
  }

  private getMaxCharCaption() {
    if (this.Ncl.Actions.length < 1) return null;

    let menuItem: { caption: string; hasHotkey: boolean; charCount: number; hotkey: string; expand: boolean }[] = [];

    this.Ncl.Actions.map((item) => {
      const itemWithHotkey = (item as CSNclMenuItemMetadata).HotKey;

      if (itemWithHotkey && itemWithHotkey !== "") {
        menuItem.push({
          caption: item.Caption,
          hasHotkey: true,
          charCount: item.Caption.length + itemWithHotkey.length,
          hotkey: itemWithHotkey,
          expand: false,
        });
      } else {
        if ((item as CSNclMenuContainerMetadata).Actions && (item as CSNclMenuContainerMetadata).Actions.length > 0) {
          menuItem.push({ caption: item.Caption, hasHotkey: false, charCount: item.Caption.length, hotkey: "", expand: true });
        } else {
          menuItem.push({ caption: item.Caption, hasHotkey: false, charCount: item.Caption.length, hotkey: "", expand: false });
        }
      }
    });

    menuItem.sort((a, b) => {
      return b.charCount - a.charCount;
    });

    return menuItem[0];
  }

  get MarginXFactor(): number {
    return 0;
  }

  get MarginYFactor(): number {
    return 0;
  }
}

export class NclMenu extends NclMenuContainer<CSNclMenuMetadata, UpdateMenuContainer> {
  constructor(ncl: CSNclMenuMetadata, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    NclMenu.initClientActions(ncl);
    super(ncl, parent, vr, vrAttachDetachFce);
  }

  protected createDefaultState(): UpdateMenuContainer {
    return new UpdateMenuContainer({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID(), isOpen: true } as CSUpdateMenuContainer);
  }

  internalComputeMinHeight(): number {
    let h: number = 0;
    h = this.getMenuHeight();
    return h;
  }

  private static initClientActions(ncl: CSNclMenuMetadata) {
    if (ncl.SourceControlUID) {
      let emitVR = Context.getApplication().getActiveRealizer();
      if (emitVR) {
        let src: any = emitVR.getControlByUID(ncl.SourceControlUID);
        if (src && (src as ClientContextMenuEmitor).appendActionTo) {
          (src as ClientContextMenuEmitor).appendActionTo(ncl);
        }
      }
    }
  }
}

export class NclMenuGroup extends NclMenuContainer<CSNclMenuGroupMetadata, UpdateMenuContainer> {
  protected createDefaultState(): UpdateMenuContainer {
    return new UpdateMenuContainer({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }
}

export class NclMenuItem extends NclMenuItemBase<CSNclMenuItemMetadata, UpdateControl> {
  protected createDefaultState(): UpdateControl {
    return new UpdateControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  public execute() {
    this.appendFunction({ Name: cJSonFunctionExecute }, true);
  }
}

class NclClientMenuItem extends NclMenuItem {
  protected createDefaultState(): UpdateControl {
    return new UpdateControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID(), Visible: true, Enabled: true });
  }

  public execute() {
    if ((this.ncl as CSNclClientMenuItemMetadata).action) {
      (this.ncl as CSNclClientMenuItemMetadata).action();
    }
    if (this.parent instanceof NclMenuView) {
      this.parent.closeView();
    }
  }
}

export class NclMenuDivider extends NclMenuItemBase<CSNclMenuDividerMetadata, UpdateControl> {
  protected createDefaultState(): UpdateControl {
    return new UpdateControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  internalComputeMinHeight(): number {
    return this.VCX.InputControl.getInputHeight(1, true, false) / 6;
  }

  public execute() {}
}

export class NclLocatorPanel extends NclContainerBase<CSNclLocatorPanelMetadata, UFUpdateControl> {
  private switchBtn: NclCommandItem;

  constructor(ncl: CSNclLocatorPanelMetadata, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (ncl.SwitchBtn) {
      this.switchBtn = new NclCommandItem(ncl.SwitchBtn, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.switchBtn);
    }
  }

  public get SwitchBtn(): NclCommandItem {
    return this.switchBtn;
  }

  public getLastLocatrInput(): NclInput {
    if (this.Children && this.Children.count() > 0) {
      let child: UFNclControlBase;
      for (let index = 0; index < this.Children.count(); index++) {
        child = this.Children.get(index);
        if (child.State.Visible && child.State.Enabled !== false && child instanceof NclInput) {
          return child;
        }
      }
    }
    return null;
  }

  protected createDefaultState(): UFUpdateControl {
    return new UFUpdateControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }
}

export class NclSignInput extends UFNclControl<CSNclSignInputMetadata, UpdateSignInput> {
  protected createDefaultState(): UpdateSignInput {
    return new UpdateSignInput({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  get ComputedMinHeight(): number {
    return this.VCX.InputControl.getInputHeight(this.ncl.FrgtData.Size, true, true);
  }

  public change(value: SignData, accept: boolean = false) {
    if (this.state.SignData === value) {
      this.initDataRequest();
      return;
    }

    this.internalSetData({ SignData: value } as SignInputDataRequest, accept, true, accept ? RealizerOperations.Accept : RealizerOperations.None);
  }
}

export class SectionItems {
  private size: number;
  private rest: number;
  private items: Array<UFNclControlBase>;

  constructor(size: number) {
    this.size = size;
    this.rest = size;
    this.items = new Array<UFNclControlBase>();
  }

  public get Rest(): number {
    return this.rest;
  }

  private addOrRemoveItem(item: NclCommandItem, add: boolean) {
    switch (item.Ncl.FrgtData.DisplayStyle) {
      case TUFActionDisplayStyle.ufadsButtonTile:
        if (add) {
          this.rest -= this.size;
        } else {
          this.rest += this.size;
        }
        break;
      case TUFActionDisplayStyle.ufadsButtonSmall:
        if (add) {
          this.rest -= 1;
        } else {
          this.rest += 1;
        }
        break;
      case TUFActionDisplayStyle.ufadsButtonLine:
        if (add) {
          this.rest -= 1;
        } else {
          this.rest += 1;
        }
        break;
    }
  }

  public pushItem(item: NclCommandItem) {
    this.items.push(item);
    if (item instanceof NclCommandItem) {
      this.addOrRemoveItem(item, true);
    }
  }

  public popItem(): NclCommandItem {
    let item: NclCommandItem = this.items.pop() as NclCommandItem;
    if (item instanceof NclCommandItem) {
      this.addOrRemoveItem(item, false);
    }
    return item;
  }

  public get Items(): Array<UFNclControlBase> {
    return this.items;
  }
}

export class NclInnerSection extends NclControl<CSNclInnerSectionMetaData, UpdateControl> {
  private contentItems: Array<UFNclControlBase>;
  private ribbon: NclRibbon;

  constructor(
    ncl: CSNclInnerSectionMetaData,
    parent: NclControlBase,
    vr: ViewRealizer,
    vrAttachDetachFce: ViewRealizerAttachDetachControlFce,
    ribbon: NclRibbon
  ) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (ncl.ContentItems) {
      this.contentItems = new Array<UFNclControlBase>();
      let item: UFNclControlBase;
      let actGroup: SectionItems = new SectionItems(ribbon.Ncl.FrgtData.Size);
      this.ribbon = ribbon;
      ncl.ContentItems.map((value, index) => {
        item = this.createControl(value, this, this.vr, vrAttachDetachFce);
        if (item) {
          this.addNestedControl(item);
          this.contentItems.push(item);
        }
      });
    }
  }

  public get Ribbon(): NclRibbon {
    return this.ribbon;
  }

  public get ContentItems(): Array<UFNclControlBase> {
    return this.contentItems;
  }

  protected createDefaultState(): UpdateControl {
    return new UpdateControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  private createControl(ncl: CSUFNclControlMetadata, parent: this, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce): UFNclControlBase {
    return NclContainer.createControl(ncl, parent, vr, vrAttachDetachFce);
  }
}

export class NclInnerToolBar extends NclControl<CSNclInnerToolBarMetadata, UpdateInnerToolbar> {
  private sections: Array<NclInnerSection>;
  private ribbon: NclRibbon;
  private accessor: NclAccessor;

  constructor(
    ncl: CSNclInnerToolBarMetadata,
    parent: NclRibbon,
    vr: ViewRealizer,
    vrAttachDetachFce: ViewRealizerAttachDetachControlFce,
    accessor: NclAccessor
  ) {
    super(ncl, parent, vr, vrAttachDetachFce);
    this.ribbon = parent;
    this.accessor = accessor;
    if (ncl.Sections) {
      this.sections = new Array<NclInnerSection>();
      let section: NclInnerSection;
      ncl.Sections.map((value) => {
        section = new NclInnerSection(value, this, this.vr, vrAttachDetachFce, parent);
        this.addNestedControl(section);
        this.sections.push(section);
      });
    }
  }

  public get Sections(): Array<NclInnerSection> {
    return this.sections;
  }

  public get Ribbon(): NclRibbon {
    return this.ribbon;
  }

  protected createDefaultState(): UpdateInnerToolbar {
    return new UpdateInnerToolbar({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  protected internalComputeMinHeight(): number {
    return -1; //(2 * (this.VCX.LabelControl.getHeight(this.ribbon.Size)));
  }

  protected afterSetState(canUpdate: boolean, oldState: UpdateInnerToolbar) {
    super.afterSetState(canUpdate, oldState);
    if (canUpdate && oldState.VisibleAccessor !== this.state.VisibleAccessor) {
      if (this.accessor) {
        this.accessor.updateState({ Visible: this.state.VisibleAccessor } as CSUpdateControl);
      }
    }
  }
}

export class NclAccessor extends NclControl<CSNclInnerToolBarMetadata, UpdateControl> {
  private ribbon: NclRibbon;

  constructor(ncl: CSNclInnerToolBarMetadata, parent: NclRibbon, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    let old = ncl.ControlUID;
    ncl.ControlUID += "_accesor_";
    super(ncl, parent, vr, vrAttachDetachFce);
    ncl.ControlUID = old;
    this.ribbon = parent;
  }

  protected createDefaultState(): UpdateControl {
    return new UpdateControl({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  get MarginXFactor(): number {
    return 4;
  }

  get MarginYFactor(): number {
    return 0;
  }
}

export interface RibbonItem {
  Accessor: NclAccessor;
  ToolBar: NclInnerToolBar;
}

export class NclRibbon extends UFNclControl<CSNclRibbonMetadata, UpdateRibbon> {
  private toolbars: Array<RibbonItem>;
  private othersBtn: NclCommandItem;
  private tabHiddeBtn: NclCommandItem;

  constructor(ncl: CSNclRibbonMetadata, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (ncl.ContextToolBarsCount > 0) {
      this.vr.registerContextDependency(this.ncl.ControlUID);
    }
    if (ncl.OthersBtn) {
      this.othersBtn = new NclCommandItem(ncl.OthersBtn, this, this.vr, vrAttachDetachFce);
      this.addNestedControl(this.othersBtn);
    }

    if (ncl.TabHideBtn) {
      this.tabHiddeBtn = new NclCommandItem(ncl.TabHideBtn, this, this.vr, vrAttachDetachFce);
      this.tabHiddeBtn.Ncl.FrgtData.DisplayStyle = TUFActionDisplayStyle.ufadsButtonSmall;
      this.addNestedControl(this.tabHiddeBtn);
    }
    this.toolbars = [];
  }

  public updateState(data: CSUpdateControl) {
    if ((data as CSUpdateRibbon).ToolBars) {
      if (this.toolbars && this.toolbars.length > 0) {
        this.toolbars.forEach((control) => {
          this.removeNestedControl(control.Accessor);
          this.removeNestedControl(control.ToolBar);
        });

        this.toolbars = [];
        this.setState(this.state.with({ ToolBars: null } as CSUpdateRibbon), true); // update for recreate all components
      }

      let toolBar: NclInnerToolBar;
      let accessor: NclAccessor;
      (data as CSUpdateRibbon).ToolBars.map((value) => {
        accessor = new NclAccessor(value, this, this.vr, this.vrAttachDetachFce);
        this.addNestedControl(accessor);
        toolBar = new NclInnerToolBar(value, this, this.vr, this.vrAttachDetachFce, accessor);
        this.addNestedControl(toolBar);
        this.toolbars.push({ Accessor: accessor, ToolBar: toolBar });
      });

      if (this.toolbars.length > 1) {
        this.othersBtn.Ncl.FrgtData.DisplayStyle = TUFActionDisplayStyle.ufadsButtonSmall;
      } else {
        this.othersBtn.Ncl.FrgtData.DisplayStyle = TUFActionDisplayStyle.ufadsButtonTile;
      }
    }
    super.updateState(data);
  }

  public contextMenu() {
    this.appendFunction({ Name: cJSonFunctionContextMenu }, true);
  }

  public get ToolBars(): Array<RibbonItem> {
    return this.toolbars;
  }

  public get OthersBtn(): NclCommandItem {
    return this.othersBtn;
  }

  public get TabHideBtn(): NclCommandItem {
    return this.tabHiddeBtn;
  }

  public changeCurrentToolBar(index: number) {
    if (this.state.CurrentToolBarIndex != index) {
      this.internalSetData<RibbonDataRequest>({ CurrentToolBarIndex: index } as RibbonDataRequest, true);
    }
  }

  protected createDefaultState(): UpdateRibbon {
    return new UpdateRibbon({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  protected internalComputeMinHeight(): number {
    let height = 0;

    height += this.VCX.sizeMap(23) * this.Size;
    height += this.VCX.LabelControl.getHeight(1); // label
    height += 2 * this.VCX.Data.MarginY;
    height += 2; // border
    height += this.VCX.sizeMap(29); // header

    return height; //-1;
  }

  public willUnMount(onlyListener: boolean) {
    if (!onlyListener && this.ncl.ContextToolBarsCount > 0) {
      this.vr.unRegisterContextDependency(this.ncl.ControlUID);
    }
    super.willUnMount(onlyListener);
  }
}

export class NclGantt extends NclHeaderedControl<CSNclGanttMetadata, UpdateHeadered> {
  private content: NclGanttContent;
  private footer: NclGanttFooter;

  constructor(ncl: CSNclGanttMetadata, parent: NclControlBase, vr: ViewRealizer, vrAttachDetachFce: ViewRealizerAttachDetachControlFce) {
    super(ncl, parent, vr, vrAttachDetachFce);
    if (ncl.Content) {
      this.content = new NclGanttContent(ncl.Content, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.content);
    }

    if (ncl.Footer) {
      this.footer = new NclGanttFooter(ncl.Footer, this, vr, vrAttachDetachFce);
      this.addNestedControl(this.footer);
    }
  }

  get Content(): NclGanttContent {
    return this.content;
  }

  get Footer(): NclGanttFooter {
    return this.footer;
  }

  public setAsActiveControl(isActive: boolean) {
    if (this.Content && this.Content.GanttInner && this.Content.GanttInner.setAsActiveControl) {
      this.Content.GanttInner.setAsActiveControl(isActive);
    } else {
      super.setAsActiveControl(isActive);
    }
  }

  public invokeAction(op: GridOperations) {
    this.appendFunction({ Name: cJSonFunctionGridOperation, Args: [op] }, true);
  }

  public changeSortBy(column: number, append: boolean) {
    this.appendFunction({ Name: cJSonFunctionGridChangeSortBy, Args: [column, append] }, true);
  }

  public doubleClick() {
    this.appendFunction({ Name: cJSonDefaultAcceptExecute }, true);
  }

  protected internalComputeMinHeight(): number {
    let result = super.internalComputeMinHeight();

    if (this.Content) {
      result += this.content.ComputedMinHeight;
    }

    if (this.Footer && this.showFooter()) {
      result += this.footer.ComputedMinHeight;
    }

    return result;
  }

  isShowHeader(): boolean {
    return super.isShowHeader() && !this.Ncl.FrgtData.HideHeader;
  }

  showFooter(): boolean {
    return !this.Ncl.FrgtData.HideFooter;
  }

  // isProjectManagement():boolean{
  // 	return this.Ncl.FrgtData.ProjectManagement;
  // }

  // isResourceManagement():boolean{
  // 	return this.Ncl.FrgtData.ResourceManagement;
  // }

  byOperations(): boolean {
    return this.Ncl.FrgtData.ByOperations ? true : false;
  }

  byResources(): boolean {
    return this.Ncl.FrgtData.ByResources ? true : false;
  }

  ownColors(): boolean {
    return this.Ncl.FrgtData.OwnColors ? true : false;
  }

  hideNavigator(): boolean {
    return this.Ncl.FrgtData.HideNavigator ? true : false;
  }

  hideXAxis(): boolean {
    return this.Ncl.FrgtData.HideXAxis ? true : false;
  }

  showDateTime(): boolean {
    return this.Ncl.FrgtData.ShowDateTime ? true : false;
  }

  public isLite(): boolean {
    return false; //this.Ncl.FrgtData.LiteHeader;
  }
}

export class NclDashboard extends NclHeaderedControl<CSNCLDashboardMetadata, UpdateDashboard> {
  private data: DashboardData;
  private changedParts: Array<string>;
  private expandedMembers: VisibleMember[] = [];
  private foundMember: VisibleMember;
  private partUpdateRequests: Array<string> = [];
  private timer: any;
  private partStates: Map<string, PartState> = new Map<string, PartState>();

  public updateState(data: CSUpdateDashboard) {
    this.changedParts = [];
    if (data.PartStates) {
      let parts = data.PartStates;
      delete data.PartStates;
      parts.forEach((part: PartState) => {
        if (part.Id == "" && part.State === TPartState.psShowProgress) {
          this.partStates.clear();
        }
        if (part.Id !== "") this.changedParts.push(part.Id);
        this.updatePartState(part);
        if (part.State === TPartState.psShowProgress) {
          if (this.partUpdateRequests.indexOf(part.Id) < 0) this.partUpdateRequests.push(part.Id);
        } else {
          let i = this.partUpdateRequests.indexOf(part.Id);
          if (i >= 0) {
            this.partUpdateRequests.splice(i, 1);
          }
        }
        if (part.Data) {
          let value = this.getPartById(part.Id);
          if (value) {
            Object.assign(value, part.Data);
            data.DataVersion = Date.now();

            if ((value as FilterPart).FilterPartType === "MultiSelectTreeFilter" && this.expandedMembers.length > 0) {
              // add all current expanded nodes to the tree
              this.expandedMembers.map((expandedMember, index) => {
                // resets member state to 0 if member is not present in UpdatedMembers property; should be implemented on server
                if (expandedMember.Children) {
                  expandedMember.Children.map((child) => {
                    const foundMember = (part.Data as FilterPart).UpdatedMembers.find((updatedMember) => updatedMember.Identifier === child.Identifier);
                    if (!foundMember) {
                      child.MemberState = 0;
                    }
                  });
                }

                this.addMembers((value as FilterPart).VisibleMembers, expandedMember.Identifier, this.expandedMembers[index]);
              });
            }

            if ((part.Data as FilterPart).UpdatedMembers) {
              // on member state change, replace the current members with new ones
              (part.Data as FilterPart).UpdatedMembers.map((updatedMember) => {
                this.addMembers((value as FilterPart).VisibleMembers, updatedMember.Identifier, updatedMember);
              });
            }
          } else {
            this.data = part.Data as DashboardData;
            this.ExpandedMembers = [];
            data.DataVersion = Date.now();
          }

          delete part.Data;
        } else if (part.Error) {
          this.data = null;
          data.Error = part.Error;
          data.DataVersion = Date.now();
        }
      });
    } else if (data.MemberStates) {
      // add a new expanded node to the tree
      const memberStates: any = data.MemberStates;
      const part = this.getPartById(memberStates[0].MemberData.PartIdentifier);

      this.findMember((part as FilterPart).VisibleMembers, memberStates[0].MemberData.MemberID);

      (memberStates[0].MemberData.ExpandedMembers as VisibleMember[]).map((expandedMember) => {
        expandedMember.Parent = this.foundMember;
      });

      this.addMembers((part as FilterPart).VisibleMembers, memberStates[0].MemberData.MemberID, memberStates);

      delete data.MemberStates;
      data.DataVersion = Date.now();
    }

    super.updateState(data);

    if (this.partUpdateRequests.length > 0 && !this.timer) {
      this.timer = setTimeout(() => {
        this.appendFunction({ Name: cJSonPartUpdate, Args: this.partUpdateRequests }, true);
        this.timer = null;
      }, 250);
    }
  }
  private updatePartState(part: PartState) {
    let state = this.partStates.get(part.Id);
    if (state) {
      Object.assign(state, part);
    } else {
      if (part.Data) {
        part.State = TPartState.psShowPart; // pri nacitani dat ze skriptu chodi 'Data' okamzite, neprijde 'State = showProgress' - nejedna se o asynchronni akci, takze lze data rovnou zobrazit
      }
      this.partStates.set(part.Id, part);
    }
  }

  public isPartsUpdateCompleted(): boolean {
    return this.partUpdateRequests.length === 0;
  }

  public findMember = (members: VisibleMember[], searchedMemberID: string) => {
    return members.find((member) => {
      if (member.Children) {
        const found = this.findMember(member.Children, searchedMemberID);

        if (found) {
          return true;
        }
      }

      if (member.Identifier === searchedMemberID) {
        this.foundMember = member;
        return true;
      } else {
        return false;
      }
    });
  };

  public addMembers(members: VisibleMember[], searchedMemberID: string, memberStates: any) {
    members.find((member) => {
      if (member.Children) {
        this.addMembers(member.Children, searchedMemberID, memberStates);
      }

      if (member.Identifier === searchedMemberID) {
        if (memberStates.Children) {
          member.Children = memberStates.Children;
        } else if (memberStates.Caption) {
          member.MemberState = memberStates.MemberState;
        } else {
          member.Children = memberStates[0].MemberData.ExpandedMembers;
        }
      }
    });
  }

  public set ExpandedMembers(expandedMembers: VisibleMember[]) {
    this.expandedMembers = expandedMembers;
  }

  public get ExpandedMembers() {
    return this.expandedMembers;
  }

  public isLite(): boolean {
    return true;
  }

  public isChangedParts(id: string): boolean {
    if (this.changedParts) {
      return this.changedParts.indexOf(id) >= 0;
    }
    return false;
  }

  public getPartState(id: string): PartState {
    if (this.partStates) {
      let result = this.partStates.get(id);
      if (result) return result;
      else return this.getPartState("");
    }
    Log.error(`Dashboard part: ${id} not found in stes.`, undefined);
    return undefined;
  }

  private getPartById(ID: string): Part {
    let result: Part = undefined;
    if (this.data && this.data.Containers) {
      this.data.Containers.forEach((item) => {
        if (item.Parts && !result) {
          item.Parts.forEach((prt) => {
            if (prt.PartIdentifier === ID) {
              result = prt;
              return;
            }
          });
        }
      });
    }
    return result;
  }

  public get DashboardData(): DashboardData {
    return this.data;
  }

  createDefaultState() {
    return new UpdateDashboard({ ControlUID: this.ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  public partClick(partId: string, ids: string[], shiftKey: boolean, ctrlKey: boolean, datasetIndex: number, index: number, mouse: TMouseButton) {
    let args = [partId, ctrlKey, shiftKey, datasetIndex, index, mouse];

    if (ids.length > 0) {
      args = [...args, ...ids];
    }

    this.appendFunction({ Name: cJSonFunctionPartClickExecute, Args: args }, true);
  }

  public updateSelectedMembersInTreeFilter(partId: string, members: { memberId: string; state: number }[]) {
    this.appendFunction({ Name: cJSonTreeViewPartClick, Args: [partId, members] }, true);
  }

  public toggleMember(partId: string, memberId: string) {
    this.appendFunction({ Name: cJSonMemberClickToExpand, Args: [partId, memberId] }, true);
  }

  public dynamicFilterPartClick(partId: string, choice: number) {
    this.appendFunction({ Name: cJSonDynamicFilterPartClick, Args: [partId, choice] }, true);
  }
}

export class NclMultiFormatText extends UFNclControl<CSNclMultiFormatTextMetadata, UpdateMultiFormatText> {
  protected createDefaultState(): UpdateMultiFormatText {
    return new UpdateMultiFormatText({ ControlUID: this.Ncl.ControlUID, RealizerUID: this.getRealizerUID() });
  }

  public executeCommandByNumber = (commandNumber: number) => {
    this.appendFunction({ Name: cJSonExecuteCommandByNumber, Args: [commandNumber] }, true);
  };
}

export enum ControlType {
  Expander = "TNclExpander",
  Image = "TNclImage",
  VRTab = "TNclVRTabControl",
  LibraryReference = "TNclLibraryReference",
  Container = "TNclContainer",
  Panel = "TNclPanel",
  ListView = "TNclListView",
  PanelBase = "TNclPanelBase",
  PreviewPanel = "TNclPreviewPanel",
  DataLabel = "TNclDataLabel",
  SplitPanel = "TNclSplitPanel",
  Tab = "TNclTabControl",
  DetailTab = "TNclDetailTabControl",
  Button = "TNclButton",
  DataGrid = "TNclDataGrid",
  SimpleDataGrid = "TNclSimpleGrid",
  Input = "TNclInput",
  FormattableInputData = "TNclFormattableInputData",
  CheckBox = "TNclCheckBox",
  GroupBox = "TNclGroupBox",
  Space = "TNclSpace",
  View = "TNclView",
  ToolBar = "TNclTabToolBar",
  Action = "TNclNoFrgtButton",
  ActionTT = "TNclToolBarNoFrgtButton",
  MenuButton = "TNclToolBarMenuButton",
  CommandAction = "TNclCommandAction",
  ActionSeparator = "TNclNoFrgtControlSeparator",
  StackPanel = "TNclStackPanel",
  DynamicContent = "TNclDynamicContent",
  Page = "TNclPageInfo",
  FloaterAccessor = "TNclFloaterAccessor",
  FloaterView = "TNclFloaterView",
  MultiContent = "TNclMultiContent",
  OpenDialog = "TNclOpenDialog",
  SilentOpenDialog = "TNclSilentOpenDialog",
  OpenDialogContent = "TNclSilentOpenDialog.TNclOpenDialogContent",
  FormattableInput = "TNclInputFormattable",
  MenuView = "TNclMenuView",
  Menu = "TNclMenu",
  MenuItem = "TNclMenuItem",
  ClientMenuItem = "ClientMenuItem",
  MenuDivider = "TNclMenuDivider",
  MenuGroup = "TNclGroup",
  LocatorPanel = "TNclLocatorPanel",
  FilePreview = "TNclFilePreview",
  SignInput = "TNclSignInput",
  Calendar = "TNclCalendar",
  Gantt = "TNclGantt",
  ListViewGroup = "TNclListViewGroup",
  ListViewItem = "TNclListViewItem",
  NclAppointment = "TNclAppointment",
  NclProvider = "TNclProvider",

  Ribbon = "TNclRibbon",
  RibbonAction = "TNclRibbonButton",
  Breaker = "TNclNoFrgtControlBreaker",
  TreeView = "TNclTreeView",
  QuickFilter = "TNclQuickFilter",
  InplaceView = "TNclInPlaceView",
  Dashboard = "TNclDashboard",
  DeviceConnector = "TNclDeviceConnectorDialog",
  GPSReader = "TNclGPSDialog",
  MultiFormatText = "TUFControlNclMultiFormatterText",
  VirtualKeyboardDialog = "TNclVirtualKeyboardDialog",
  WebView = "TNclWebView",
  CodeReaderDialog = "TNclCodeReaderDialog",
}
